/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-self-assign */
/* eslint-disable no-control-regex */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/accessible-emoji */
// ════════════════════════════════════════════════════════════════
// SelfAssessment.jsx — GSA Rewrite (Chat Container)
//
// Shell: app shell (header, progress, chat area, input bar),
//        conversationHistory accumulator, step router,
//        QnA strip system, input bar routing
// Screens: Intro → ProblemArea → PainLocation →
//          SafetyScreening → CPG → Subtype → SelfAssessmentQ2 →
//          PreNPRS → TestIntro → MovementTest1 →
//          SelfReportROM → SelfReportTempo → RPE → FeelAffect →
//          TestIntro2 → MovementTest2 → Feedback2 →
//          Personalize → RecoveryScore → Plan
// Cross-cutting: ExitHandler, InactivityModal, HardStop
// Imported screens: PainLocationScreen, SafetyScreeningScreen
// ════════════════════════════════════════════════════════════════

import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useAssessment } from "../self-assesment/AssessmentContext";
import { useScreenVoice } from "./useScreenVoice";
import { generatePayloadForScreen, parseDataAfterInfo, buildBucketState } from "./generatePayloadForScreen";
import { QnAOverlay } from "./QnAOverlay";
import { INPUT_PLACEHOLDERS, MYRA_MESSAGES, resolveMessage } from "./GSA_MYRA_MESSAGES";
import * as CONST from "./GSA_CONSTANTS";
import PainLocationScreen from "./PainLocationScreen";
import SafetyScreeningScreen from "./SafetyScreeningScreen";
import styles from "./SelfAssessment.module.css";
import styles2 from "./HomeScreen.module.css";
import { AnalyticsService } from "../self-assesment/SelfAssesment";
import MyraInteraction from "../self-assesment/MyraInteractionController";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import MyraChatService from "../voice-agent/MyraChatService";
import { CustomHeader } from "./HomeScreen";
import { useHistory, useLocation } from "react-router-dom";

// ════════════════════════════════════════════════════════════════
// UTILITY CLASSES
// ════════════════════════════════════════════════════════════════

class TimeTracker {
  startGSATimer() {
    this._gsaStart = Date.now();
  }
  getGSADuration() {
    return Math.round((Date.now() - this._gsaStart) / 1000);
  }
}

class ScreenFlowTracker {
  constructor() {
    this._flow = [];
    this._current = null;
  }
  enterScreen(name) {
    this._current = { screen: name, enter: Date.now() };
  }
  exitScreen(name, meta = {}) {
    if (this._current) {
      this._current.exit = Date.now();
      this._current.duration = this._current.exit - this._current.enter;
      Object.assign(this._current, meta);
      this._flow.push(this._current);
      this._current = null;
    }
  }
  getScreenFlow() {
    return this._flow;
  }
}

// ════════════════════════════════════════════════════════════════
// SHELL CONSTANTS & HELPERS
// ════════════════════════════════════════════════════════════════

const SCREEN_HEADINGS = MYRA_MESSAGES.screenHeadings;

// Max user path is 19 screens. Each visited screen has an `order` (1–19).
// Progress is derived: (order / 19) × 100.
// Screens skipped by the user (e.g., self_assessment for non-LBP) cause
// natural jumps because the next screen visited has a higher order.
//
// Screens with no `order` (mode_selection, camera_permission, recovery_score)
// are not part of the user-facing path. They have no `progress` value, so
// the progress-update effect holds the previous value when they're briefly
// visited (the bar never moves backward).
const MAX_SCREEN_COUNT = 17;
const orderToProgress = (order) => Math.round((order / MAX_SCREEN_COUNT) * 100);

const STEP_CONFIG = {
  intro: { label: SCREEN_HEADINGS.intro, order: 1, progress: orderToProgress(1) },
  problem_area: { label: SCREEN_HEADINGS.problem_area, order: 2, progress: orderToProgress(2) },
  pain_location: { label: SCREEN_HEADINGS.pain_location, order: 3, progress: orderToProgress(3) },
  cpg_questions: { label: SCREEN_HEADINGS.cpg_questions, order: 5, progress: orderToProgress(4) },
  subtype_questioning: { label: SCREEN_HEADINGS.subtype_questioning, order: 6, progress: orderToProgress(5) },
  self_assessment: { label: SCREEN_HEADINGS.self_assessment, order: 7, progress: orderToProgress(6) },
  nprs_symptoms: { label: SCREEN_HEADINGS.nprs_symptoms, order: 8, progress: orderToProgress(7) },
  safety_screening: { label: SCREEN_HEADINGS.safety_screening, order: 4, progress: orderToProgress(8) },
  test1_demo: { label: SCREEN_HEADINGS.test1_demo, order: 9, progress: orderToProgress(9) },
  movement_test_1: { label: SCREEN_HEADINGS.movement_test_1, order: 10, progress: orderToProgress(10) },
  self_report_rom: { label: SCREEN_HEADINGS.self_report_rom, order: 11, progress: orderToProgress(11) },
  self_report_tempo: { label: SCREEN_HEADINGS.self_report_tempo, order: 12, progress: orderToProgress(12) },
  rpe: { label: SCREEN_HEADINGS.rpe, order: 13, progress: orderToProgress(13) },
  feel_affect: { label: SCREEN_HEADINGS.feel_affect, order: 14, progress: orderToProgress(14) },
  feedback2: { label: SCREEN_HEADINGS.feedback2, order: 15, progress: orderToProgress(15) },
  personalize: { label: SCREEN_HEADINGS.personalize, order: 16, progress: orderToProgress(16) },
  plan: { label: SCREEN_HEADINGS.plan, order: 17, progress: 100 },

  // Non-counted screens (no `order`) — keep entries in config for safety
  // but don't advance the progress bar. The progress-update effect uses
  // a fallback that holds the previous value when `progress` is missing.
  mode_selection: { label: SCREEN_HEADINGS.mode_selection },
  camera_permission: { label: SCREEN_HEADINGS.camera_permission },
  recovery_score: { label: SCREEN_HEADINGS.recovery_score },
  hard_stop: { label: SCREEN_HEADINGS.hard_stop, progress: 100 },
};

// Known landing-chat intent values. Used by handleInlineChat's
// unknown-intent warning to surface prompt drift or backend bugs.
// TODO: move to a shared constants module when the intent vocabulary
// stabilizes across Landing, MidJourney, Q&A, and PostSession prompts.
const KNOWN_LANDING_INTENTS = ["intake_problemArea", "intake_selectedZones", "intake_cpg", "intake_subtype", "intake_subtypeQ1", "intake_subtypeQ2", "intake_subtypeAnswer", "intake_painLevel", "symptom_engagement", "safety_screen_conversation", "safety_screen_outcome", "bridge", "start_gsa_request", "noise_discard"];

const AREA_MAP = { "lower back": "LBP", back: "LBP", hip: "HIP", thigh: "THIGH", knee: "KNEE", leg: "KNEE" };
function detectAreaKeyword(text) {
  const lower = text.toLowerCase();
  for (const [kw, id] of Object.entries(AREA_MAP)) {
    if (lower.includes(kw)) return id;
  }
  return null;
}

// ── Spec 1 helpers (intro-payload field reconciliation) ──────
//
// Translates a Claude-extracted CPG option id (e.g., "cpg-radiating",
// "hip-cpg-mobility") into the full option object from CONSTANTS, which
// carries id, label, value, info, and (for HKT) cpgForBackend, routesTo,
// subtypeQuestionIndex / directSubtype.
//
// LBP options live in CPG_OPTIONS_LEG and CPG_OPTIONS_BACK (searched
// together — leg-pain branching only matters for the visible question,
// not for option lookup).
// HKT options live in CLINICAL_PATHS[area].cpgQuestion.options.
function normalizeSubtypeLookupValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
}

function optionMatchesLookupValue(option, value) {
  if (!option || value === undefined || value === null) return false;
  const rawValue = String(value).trim();
  const normalizedValue = normalizeSubtypeLookupValue(rawValue);
  return option.id === rawValue || option.value === rawValue || normalizeSubtypeLookupValue(option.label) === normalizedValue;
}

function lookupCpgOption(optionId, area) {
  if (!optionId) return null;

  // Prefer the active area's options when the area is known.
  if (area === "LBP") {
    const lbpOption = [...CONST.CPG_OPTIONS_LEG, ...CONST.CPG_OPTIONS_BACK].find((o) => optionMatchesLookupValue(o, optionId));
    if (lbpOption) return lbpOption;
  } else if (area && CONST.CLINICAL_PATHS?.[area]) {
    const areaOption = CONST.CLINICAL_PATHS?.[area]?.cpgQuestion?.options?.find((o) => optionMatchesLookupValue(o, optionId));
    if (areaOption) return areaOption;
  }

  // LBP options
  const lbpOption = [...CONST.CPG_OPTIONS_LEG, ...CONST.CPG_OPTIONS_BACK].find((o) => optionMatchesLookupValue(o, optionId));

  if (lbpOption) return lbpOption;

  // All clinical path options
  for (const areaKey of Object.keys(CONST.CLINICAL_PATHS || {})) {
    const found = CONST.CLINICAL_PATHS?.[areaKey]?.cpgQuestion?.options?.find((o) => optionMatchesLookupValue(o, optionId));

    if (found) return found;
  }

  return null;
}

// Translates a Claude-extracted subtype option id (HKT only, e.g.,
// "hip-sub-lateral") into the option object from
// CLINICAL_PATHS[area].subtypeQuestions[*].options. Each option carries
// id, label, info, value (the subtype constant like
// "ANTERIOR_CHAIN_MOBILITY_DEFICIT").
function lookupSubtypeOption(optionId, area) {
  if (!optionId || !area || area === "LBP") return null;
  const subtypeQuestions = CONST.CLINICAL_PATHS[area]?.subtypeQuestions || [];
  for (const q of subtypeQuestions) {
    const opt = q.options?.find((o) => optionMatchesLookupValue(o, optionId));
    if (opt) return opt;
  }
  return null;
}

function logExtractedValidationRejection(field, value, reason, extra = {}) {
  console.warn("[Landing] Validation rejected extracted field", {
    field,
    value,
    reason,
    ...extra,
  });
}

function isKnownMovementTestName(testName) {
  return Boolean(testName) && testName !== "your first movement test" && Object.values(CONST.TEST_MAP || {}).some((test) => test?.name === testName);
}

// Translates Claude's extracted-field names into the field names the GSA
// screens read on mount. Pass currentAssessmentData so the helper can read
// prior state for multi-turn extractions (e.g., subtypeQ1 set last turn,
// subtypeQ2 arriving now — needs both to compute probableSubtype via
// getSubtype). Pure: does not mutate currentAssessmentData.
function mapExtractedToAssessmentData(extracted, currentAssessmentData = {}) {
  const out = {};
  const validProblemAreas = ["LBP", "HIP", "THIGH", "KNEE"];
  const validSafetyOutcomes = ["CONTINUE", "ADVISORY", "STOP"];

  // problemArea
  if (extracted.problemArea !== undefined) {
    if (validProblemAreas.includes(extracted.problemArea)) {
      out.problemArea = extracted.problemArea;
      out.selected_problem_area = CONST.CLINICAL_PATHS[extracted.problemArea]?.name || extracted.problemArea;
      // Mirror the existing chip-click behaviour at line ~2479.
      window.problemArea = extracted.problemArea;
    } else {
      logExtractedValidationRejection("problemArea", extracted.problemArea, "not in canonical problem areas");
    }
  }

  // selectedZones — derive PainLocationScreen's expected fields
  if (extracted.selectedZones !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const zonesBySide = CONST.CLINICAL_PATHS?.[area]?.zones;
    if (!area || !zonesBySide) {
      logExtractedValidationRejection("selectedZones", extracted.selectedZones, "problem area missing or invalid", { area });
    } else if (!Array.isArray(extracted.selectedZones) || extracted.selectedZones.length === 0) {
      logExtractedValidationRejection("selectedZones", extracted.selectedZones, "empty or not array", { area });
    } else {
      const invalidZones = [];
      const selectedZones = extracted.selectedZones.map((z) => String(z));
      selectedZones.forEach((z) => {
        const [side, ...zoneParts] = z.split(":");
        const zone = zoneParts.join(":");
        if ((side !== "left" && side !== "right") || !zone || !zonesBySide?.[side]?.includes(zone)) {
          invalidZones.push(z);
        }
      });

      if (invalidZones.length > 0) {
        logExtractedValidationRejection("selectedZones", extracted.selectedZones, "invalid zone for area", { area, invalidZones });
      } else {
        out.selectedZones = selectedZones;
        out.pinpointSelections = selectedZones.map((z) => {
          const [side, ...zoneParts] = z.split(":");
          return { side, zone: zoneParts.join(":") };
        });
        out.primaryZone = selectedZones[0];
        out.secondaryZones = selectedZones.slice(1);
        if (area === "LBP") {
          out.isLegPain = CONST.hasLegPain(selectedZones);
        }
      }
    }
  }

  // cpgAnswer — option id → cpgValue/cpgForBackend/cpgCategory + (if direct) probableSubtype
  if (extracted.cpgAnswer !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const cpgOption = lookupCpgOption(extracted.cpgAnswer, area);
    if (cpgOption) {
      out.cpgAnswer = cpgOption.id;
      out.cpgValue = cpgOption.value;
      out.cpgForBackend = cpgOption.cpgForBackend || cpgOption.value;
      out.cpgCategory = cpgOption.value;
      if (cpgOption.routesTo === "direct" && cpgOption.directSubtype) {
        out.subtype = cpgOption.directSubtype;
        out.probableSubtype = cpgOption.directSubtype;
      } else if (cpgOption.routesTo === "subtypeQuestion" && area && area !== "LBP") {
        const subtypeQuestion = CONST.CLINICAL_PATHS?.[area]?.subtypeQuestions?.[cpgOption.subtypeQuestionIndex || 0];
        const zoneMap = area === "HIP" && cpgOption.id === "hip-cpg-mobility" ? CONST.HIP_MOB_Q1_ZONE_TO_OPTION : area === "THIGH" ? CONST.THIGH_Q1_ZONE_TO_OPTION : null;
        const pinpointSelections = out.pinpointSelections || currentAssessmentData.pinpointSelections || [];
        const q1Decision = zoneMap && subtypeQuestion ? CONST.planSubtypeQ1Decision(pinpointSelections, zoneMap, subtypeQuestion.options) : { mode: "plain" };
        if (q1Decision.mode === "skip" && q1Decision.option) {
          out.subtypeAnswer = q1Decision.option.value;
          out.subtype = q1Decision.option.value;
          out.probableSubtype = q1Decision.option.value;
          if (CONST.SUBTYPE_TO_CPG_MAP[area]?.[q1Decision.option.value]) {
            out.cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[area][q1Decision.option.value];
          }
        }
      }
    } else {
      logExtractedValidationRejection("cpgAnswer", extracted.cpgAnswer, "not in canonical options", { area });
    }
  }

  // subtypeQ1 (LBP)
  if (extracted.subtypeQ1 !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    if (area !== "LBP") {
      logExtractedValidationRejection("subtypeQ1", extracted.subtypeQ1, "field not applicable for area", { area });
    } else {
      const q1Value = String(extracted.subtypeQ1).trim();
      const q1Option = CONST.Q1_OPTIONS.find((o) => o.value === q1Value);
      if (q1Option) {
        out.subtypeQ1 = q1Option.value;
      } else {
        logExtractedValidationRejection("subtypeQ1", extracted.subtypeQ1, "not in canonical LBP Q1 options", { area });
      }
    }
  }

  // subtypeQ2 (LBP) — compute probableSubtype if Q1 is also known
  if (extracted.subtypeQ2 !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    if (area !== "LBP") {
      logExtractedValidationRejection("subtypeQ2", extracted.subtypeQ2, "field not applicable for area", { area });
    } else {
      const q2Value = typeof extracted.subtypeQ2 === "string" ? extracted.subtypeQ2.trim().toLowerCase() : extracted.subtypeQ2;
      if (q2Value === "yes" || q2Value === "no") {
        out.subtypeQ2 = q2Value;
        const q1 = out.subtypeQ1 || currentAssessmentData.subtypeQ1;
        if (CONST.Q1_OPTIONS.some((o) => o.value === q1)) {
          const subtype = CONST.getSubtype(q1, q2Value);
          out.subtype = subtype;
          out.probableSubtype = subtype;
        }
        // LBP CPG options have no routesTo/directSubtype.
        // Back-only path: cpgToSubtype() resolves subtype from cpgValue.
        // Leg-pain path: subtype comes from Q1/Q2 — don't set here.
        const zones = out.selectedZones || currentAssessmentData.selectedZones;
        const isLegPain = zones ? CONST.hasLegPain(zones) : false;
        if (!isLegPain && currentAssessmentData.cpgValue) {
          const subtype = CONST.cpgToSubtype(currentAssessmentData.cpgValue);
          if (subtype) {
            out.subtype = subtype;
            out.probableSubtype = subtype;
          }
        }
      } else {
        logExtractedValidationRejection("subtypeQ2", extracted.subtypeQ2, "not yes or no", { area });
      }
    }
  }

  // subtypeAnswer (HKT) — option id → subtype constant via the option's value
  if (extracted.subtypeAnswer !== undefined) {
    const area = out.problemArea || currentAssessmentData.problemArea;
    const subtypeOption = lookupSubtypeOption(extracted.subtypeAnswer, area);
    if (!area || area === "LBP") {
      logExtractedValidationRejection("subtypeAnswer", extracted.subtypeAnswer, "field not applicable for area", { area });
    } else if (!subtypeOption) {
      logExtractedValidationRejection("subtypeAnswer", extracted.subtypeAnswer, "not in canonical options", { area });
    } else {
      out.subtypeAnswer = subtypeOption.value;
      out.subtype = subtypeOption.value;
      out.probableSubtype = subtypeOption.value;

      if (CONST.SUBTYPE_TO_CPG_MAP[area]?.[subtypeOption.value]) {
        out.cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[area][subtypeOption.value];
        console.log(`[Landing] Remapped cpgForBackend for ${area} subtype ${subtypeOption.value}:`, out.cpgForBackend);
      }
    }
  }
  // painLevel
  if (extracted.painLevel !== undefined) {
    if (Number.isInteger(extracted.painLevel) && extracted.painLevel >= 0 && extracted.painLevel <= 10) {
      out.painLevel = extracted.painLevel;
    } else {
      logExtractedValidationRejection("painLevel", extracted.painLevel, "not an integer from 0 to 10", { actualType: typeof extracted.painLevel });
    }
  }

  // safety - Claude may return this inside extracted instead of action
  if (extracted.safety !== undefined) {
    const rawSafety = String(extracted.safety).trim();
    const safetyValue = rawSafety.startsWith("SAFETY_") ? rawSafety.slice("SAFETY_".length) : rawSafety;
    if (validSafetyOutcomes.includes(safetyValue)) {
      out.safety = safetyValue;
      out.safetyOutcome = safetyValue;
    } else {
      logExtractedValidationRejection("safety", extracted.safety, "not in canonical safety outcomes");
    }
  }

  // Pass-through for free-text and biometric fields. Claude's extraction
  // tables (prompts-extract.js lines 832–945) define these. The
  // Personalize pre-fill effect (Delta 9.1) reads them and remaps to the
  // screen's local form-state names where they differ (e.g., weightLbs →
  // weight, activityLevel → activity).
  if (extracted.duration !== undefined && out.symptomDuration === undefined) {
    out.symptomDuration = extracted.duration;
  }

  const passThroughKeys = ["pain_location", "pain_severity", "symptomDuration", "pain_character", "aggravators", "relief_factors", "time_pattern", "leg_arm_symptoms", "functional_limitations", "prior_treatment", "treatment_outcome", "onset_trigger", "sleep_impact", "fear_or_hesitation", "recovery_goals", "conditions_disclosed", "age", "weightLbs", "heightFt", "heightIn", "activityLevel", "floorCapability", "balance", "goals"];
  passThroughKeys.forEach((k) => {
    if (extracted[k] !== undefined) out[k] = extracted[k];
  });

  // Defensive: If we have both cpgAnswer and subtypeAnswer/probableSubtype for HKT,
  // ensureing it that cpgForBackend is correct even if previous logic missed it
  const finalArea = out.problemArea || currentAssessmentData.problemArea;
  if (finalArea && finalArea !== "LBP") {
    const subtypeValue = out.subtype || out.probableSubtype || currentAssessmentData.subtype || currentAssessmentData.probableSubtype;
    if (subtypeValue && CONST.SUBTYPE_TO_CPG_MAP[finalArea]?.[subtypeValue]) {
      // Only override if cpgForBackend isn't already correctly mapped
      const expectedCpg = CONST.SUBTYPE_TO_CPG_MAP[finalArea][subtypeValue];
      if (out.cpgForBackend !== expectedCpg) {
        console.log(`[Landing] Defensive cpgForBackend correction for ${finalArea}:`, { from: out.cpgForBackend, to: expectedCpg, subtype: subtypeValue });
        out.cpgForBackend = expectedCpg;
      }
    }
  }

  return out;
}

function _delay(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

// Given a bucket_state object (from buildBucketState in
// generatePayloadForScreen.js), returns the step key of the first GSA
// screen that hasn't been captured conversationally. Used by the bucket
// router in handleInlineChat after Claude signals start_gsa_request.
//
// Returns one of: "problem_area", "pain_location", "cpg_questions",
// "subtype_questioning", "self_assessment", "nprs_symptoms", or
// "safety_screening" when everything is captured.
function findFirstMissingScreen(bucketState) {
  window.showChips = true;

  if (isKnownMovementTestName(bucketState.reveal) && (bucketState.safety === "CONTINUE" || bucketState.safety === "ADVISORY")) {
    return "movement_test_1";
  }

  if (!bucketState.problemArea) return "problem_area";
  if (!bucketState.selectedZones) return "pain_location";
  if (!bucketState.cpgAnswer) return "cpg_questions";

  if (bucketState.problemArea === "LBP") {
    if (!bucketState.subtypeQ1) return "subtype_questioning";
    if (!bucketState.subtypeQ2) return "self_assessment";
  } else {
    // HKT: subtypeAnswer is required only if the chosen CPG option routes
    // through a subtype question. routesTo === "direct" means subtype is
    // already set via directSubtype, so no subtype screen needed.
    const cpgOption = lookupCpgOption(bucketState.cpgAnswer, bucketState.problemArea);
    if (cpgOption?.routesTo !== "direct") {
      const subtypeOption = lookupSubtypeOption(bucketState.subtypeAnswer, bucketState.problemArea);
      if (!bucketState.subtypeAnswer || !(bucketState.subtype || bucketState.probableSubtype || subtypeOption?.value)) {
        return "subtype_questioning";
      }
    }
  }

  if (bucketState.painLevel === null || bucketState.painLevel === undefined) {
    return "nprs_symptoms";
  }

  // Fields 1–7 are filled. Now check safety and reveal.

  // Defensive: STOP is unreachable here because the bucket router does
  // not call findFirstMissingScreen when safety === "STOP". Return null
  // as a sentinel; the caller treats null as "do not transition."
  if (bucketState.safety === "STOP") return null;

  // Safety not yet resolved — fall back to the structured screen.
  if (bucketState.safety === null || bucketState.safety === undefined) {
    return "safety_screening";
  }

  // safety is "CONTINUE" or "ADVISORY". Skip safety_screening.
  // Now check reveal.
  if (!isKnownMovementTestName(bucketState.reveal)) {
    return "test1_demo";
  }

  // Reveal also done. Land on the first step past test1_demo.
  return "movement_test_1";
}

// Returns true when every bucket field needed to advance the user out of
// the landing chat is captured and safety has resolved to a non-STOP state.
// Used by handleInlineChat's auto-trigger path so the GSA transition fires
// even when Claude omits the start_gsa_request intent.
//
// LBP requires both subtype questions. HKT requires subtypeAnswer only when
// the CPG option routes through a subtype question. Direct-route CPG
// options (routesTo === "direct") already carry directSubtype, so no
// subtype screen is needed.
function isReadyForAutoTransition(bucketState) {
  if (!bucketState) return false;
  if (bucketState.reveal && !isKnownMovementTestName(bucketState.reveal)) {
    return false;
  }
  if (!bucketState.problemArea) return false;
  if (!bucketState.selectedZones) return false;
  if (!bucketState.cpgAnswer) return false;

  if (bucketState.problemArea === "LBP") {
    if (!bucketState.subtypeQ1) return false;
    if (!bucketState.subtypeQ2) return false;
  } else {
    const cpgOption = lookupCpgOption(bucketState.cpgAnswer, bucketState.problemArea);
    if (cpgOption?.routesTo !== "direct") {
      const subtypeOption = lookupSubtypeOption(bucketState.subtypeAnswer, bucketState.problemArea);
      if (!bucketState.subtypeAnswer || !(bucketState.subtype || bucketState.probableSubtype || subtypeOption?.value)) {
        return false;
      }
    }
  }

  if (typeof bucketState.painLevel !== "number") return false;
  if (!isKnownMovementTestName(bucketState.reveal)) return false;
  if (bucketState.safety !== "CONTINUE" && bucketState.safety !== "ADVISORY") return false;

  return true;
}

let _historyId = 0;
function nextId() {
  return ++_historyId;
}

function getPinpointChipStyle(zonesBySide = {}) {
  const allZones = [...(zonesBySide.left || []), ...(zonesBySide.right || [])];
  const maxLen = allZones.reduce((max, zone) => Math.max(max, String(zone).length), 0);
  const widthCh = Math.max(8, Math.min(18, maxLen + 2));
  return { width: `${widthCh}ch` };
}

function getNestedMessage(root, dottedPath) {
  return dottedPath.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), root);
}

function getDemoVideo1Message(problemArea, subtype, testName) {
  const setupByArea = MYRA_MESSAGES.demoVideo?.DEMO_VIDEO_1_SETUP_BEAT_BY_AREA || {};
  return resolveMessage(setupByArea[problemArea] || setupByArea.LBP || "", { testName });
}

function getMovementCompletionSummary(testName) {
  return resolveMessage(MYRA_MESSAGES.movementTest?.completionSummary || "Done with the {testName}. That gives me what I need. Let me ask you a couple of follow-up questions.", { testName });
}

function getFeedback2AckMessage(value, speech) {
  const speechText = typeof speech === "string" ? speech.trim() : "";
  if (speechText) return speechText;

  const closeByOutcome = MYRA_MESSAGES.feedback2?.FEEDBACK_2_CLOSE_BY_OUTCOME || {};
  return value === "BETTER" ? closeByOutcome.BETTER : closeByOutcome.WORSE;
}

function getFeedback2OptionLabel(option) {
  return MYRA_MESSAGES.feedback2?.options?.[option.id]?.label || option.label;
}

function getSelfReportRomDisplayOption(option) {
  const copy = MYRA_MESSAGES.selfReportRom?.options?.[option.id] || {};
  return {
    ...option,
    title: copy.title || option.title,
    subtitle: copy.subtitle || option.subtitle,
  };
}

function getSelfReportRomDisplayOptions(options) {
  return options.map(getSelfReportRomDisplayOption);
}

function MovementRevealReadyChip({ label, guideText, onClick }) {
  return (
    <div className={styles.inlineUi2}>
      <div className={styles.chipPairStack}>
        <div className={styles.chipPair}>
          <button type="button" className={`${styles.optionCard} ${styles.chipPair}`} onClick={onClick}>
            {label}
          </button>
        </div>
      </div>
      {guideText && <div style={{ fontSize: "12px", fontWeight: 500, color: "#6b7280", fontStyle: "italic", padding: "4px 0 0 4px", marginTop: "2px" }}>{guideText}</div>}
    </div>
  );
}

function MovementRevealReadyFrozen({ label }) {
  return (
    <div className={styles.inlineUi2}>
      <div className={styles.chipPairStack}>
        <div className={`${styles.chipPair} ${styles.frozen} ${styles.selected}`}>
          <div className={`${styles.optionCard} ${styles.chipPair} ${styles.frozen} ${styles.selected}`}>{label}</div>
        </div>
      </div>
    </div>
  );
}

// ── SVG icons ──
const SEND_ICON = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);
const CHAT_ICON_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const VOICE_ICON_SVG = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
  </svg>
);
const CHEVRON_DOWN = (
  <svg className={styles.accordionChevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// ── Intro CTA config (data-driven, extensible) ──
const INTRO_CTAS = [
  // { id: "video", label: "Watch a Video", type: "info" },
  { id: "start", label: MYRA_MESSAGES.intro.ctaLabels.start, type: "start" },
  // { id: "assessment", label: "Learn more about the assessment...", type: "info" },
  // { id: "myra", label: "Who is Myra?", type: "info" },
];

function getAssessmentSteps() {
  if (MYRA_MESSAGES.intro?.assessmentSteps) return MYRA_MESSAGES.intro.assessmentSteps;
  return [
    { title: "A few questions about your pain", body: "I'll ask where your pain started and a few targeted questions about what it feels like — sharp, dull, radiating. This helps me understand what's going on so I can pick the right movement checks for you." },
    { title: "A quick safety check", body: "Before any movements, I'll run through a short checklist to make sure it's safe to continue. If anything comes up, I'll recommend you see a provider first — your safety always comes first." },
    { title: "1–2 simple movement checks", body: "I'll pick 1 or 2 gentle movements based on your answers. I'll show you a demo video first, then guide you through it. The goal is never to push through pain — it's to help me understand your starting point." },
    { title: "A few optional personal details", body: "After the movement checks, you can share details like your age, activity level, and goals. The more I know, the more accurate your plan. If you skip this, I'll still build a plan with conservative assumptions." },
    { title: "Your personalized recovery plan", body: "Based on everything I've learned, I'll create a recovery plan with exercises tailored to you — including what to do, how often, and why each exercise was chosen." },
  ];
}

// ════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ════════════════════════════════════════════════════════════════

export default function SelfAssessment2({ displayMode = "fullscreen", onStartAssessment, onMyraEngagement }) {
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [currentStep, setCurrentStep] = useState("intro");
  const [exitCurrentStep, setExitCurrentStep] = useState(false);
  window.updateAssessmentDataGlobal = updateAssessmentData;

  // ── Conversation history (message accumulator) ──
  const [conversationHistory, setConversationHistory] = useState([]);
  // Tracks the id of the most recent user-echo entry. Used as the scroll
  // anchor when navigating to a new step so the user reads from their last
  // answer downward, not from the bottom of the new content.
  const lastUserEchoIdRef = useRef(null);
  const [typingVisible, setTypingVisible] = useState(false);
  const [nprsPainSelected, setNprsPainSelected] = useState(false);
  const [introExternalAction, setIntroExternalAction] = useState(null);

  // ── Input bar ──
  const [inputText, setInputText] = useState("");
  const [showIntroCtas, setShowIntroCtas] = useState(false);
  const [ctaUsed, setCtaUsed] = useState(new Set());
  const [introProminent, setIntroProminent] = useState(false);
  const [placeholderText, setPlaceholderText] = useState(MYRA_MESSAGES.shell.inputPlaceholderDefault);

  // ── Shell UI ──
  const [progressPercent, setProgressPercent] = useState(5);
  const [stepLabel, setStepLabel] = useState("Getting Started");
  const [mode, setMode] = useState(MyraInteraction.getMode() || "chat");

  // ── Intent detection (stubbed) ──
  const [detectedArea, setDetectedArea] = useState(null);
  const [detectedDuration, setDetectedDuration] = useState(null); // eslint-disable-line
  const [detectedTrigger, setDetectedTrigger] = useState(null); // eslint-disable-line
  // Intent matching logic deferred — separate project

  // ── Scroll management ──
  const chatAreaRef = useRef(null);
  const userScrolledUpRef = useRef(false);
  const scrollSentinelRef = useRef(null);
  const scrollRafRef = useRef(null);
  const scrollRetryRef = useRef(null);

  // ── QnA overlay ──
  const [qaOpen, setQaOpen] = useState(false);
  const qaRef = useRef(null);

  // ── Cross-cutting overlays ──
  const [showExitHandler, setShowExitHandler] = useState(false);
  const [showInactivityModal, setShowInactivityModal] = useState(false);

  // ── Screen-specific command refs (for input bar routing) ──
  const introAdvanceRef = useRef(null);
  const introCtaHandlerRef = useRef(null);
  const paCommandRef = useRef(null);

  // ── Bucket-router transition guard ──
  // Prevents the start_gsa_request block and the auto-trigger block in
  // handleInlineChat from both firing in the same turn. Set to true the
  // first time either block decides to fire the GSA transition. Never
  // reset — once currentStep advances past "intro", neither block can
  // re-enter (both gate on currentStep === "intro").
  const transitionFiredRef = useRef(false);
  const pendingPostTapRef = useRef(null);
  const postTapTimerRef = useRef(null);

  // ── QA strip tracking ──
  const qaStripIdsRef = useRef(new Set());

  // ── Embedded → fullscreen transition tracking ──
  const prevDisplayModeRef = useRef(displayMode);

  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const [problemArea, setProblemArea] = useState(null);
  const [hideContent, setHideContent] = useState(false);

  // analytics states:
  const [isComeFromGoogle, setIsComeFromGoogle] = useState(false);
  const [isUserCameBackAgain, setIsUserCameBackAgain] = useState(false);
  const [userVariant, setUserVariant] = useState(null);
  const history = useHistory();
  const { search } = useLocation();

  // Voice Status
  const [voiceTranscript, setVoiceTranscript] = useState("");
  const [voiceStatus, setVoiceStatus] = useState("");
  const [qaSilencePhase, setQaSilencePhase] = useState("listening");

  const [chatBucketTest, setChatBucketTest] = useState([]);
  const [inLineChatHistory, setInLineChatHistory] = useState([]);

  // input
  const [inputType, setInputType] = useState("text");
  useEffect(() => {
    if (currentStep === "nprs_symptoms") {
      setInputType("number");
    } else {
      setInputType("text");
    }
    setExitCurrentStep(currentStep);
  }, [currentStep]);
  const currentStepRef = useRef(currentStep);
  const intentionalScroll = useRef(currentStep);
  useEffect(() => {
    currentStepRef.current = currentStep;
  }, [currentStep]);

  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const heroVideoRef = useRef(null);
  const handleHomeVideoClicked = () => {
    setShowVideoOverlay(true);
    window.isHomeVideoWatch = true;
    setTimeout(() => {
      if (heroVideoRef.current) {
        heroVideoRef.current.play().catch((err) => {
          console.error("Video play failed:", err);
          // Most browsers require user interaction first
          // The video will have controls so user can manually play
        });
      }
    }, 100);

    // Track video engagement for analytics
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        event: "intro_video_opened",
        timestamp: new Date().toISOString(),
      });
    }
  };
  const handleWhoIsMyraClick = async () => {
    const question = "Who is Myra?";
    const answer = MYRA_MESSAGES.intro?.whoIsMyra || "I'm Myra, your recovery coach from Virdio Health. I'm powered by AI — not a human — but I'm designed to guide you through understanding and recovering from muscle and joint pain. I work alongside doctors of physical therapy and evidence-based research to help you do recovery at home, under your own guidance. I'm not a doctor, physical therapist, or clinician.";
    const type = "myra";
    pushToHistory({ type: "user", text: question, id: nextId() });
    await _delay(400);
    const qaItem = { id: nextId(), question, answer, type };
    await showMyraMessage(answer, 800);
    await _delay(1000);
  };

  useEffect(() => {
    const el = document.getElementById("debugVoice");
    if (!el) return;

    const observer = new MutationObserver(() => {
      setVoiceTranscript(el.innerHTML.trim());
    });

    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!voiceTranscript || mode !== "voice") return;

    const interval = setInterval(() => {
      const silenceMs = VoiceService.getSilenceDurationMs?.() || 0;
      if (silenceMs < 2000) {
        setQaSilencePhase("listening");
      } else if (silenceMs < 3000) {
        setQaSilencePhase("still");
      } else {
        setQaSilencePhase("thinking");
      }
    }, 200);

    return () => clearInterval(interval);
  }, [voiceTranscript, mode]);

  useEffect(() => {
    if (mode !== "voice") {
      setVoiceStatus("");
      return;
    }

    const computeStatus = () => {
      const agentState = window.mayraCode?.getState?.();
      const isAgentSpeaking = agentState?.isAgentSpeaking || VoiceService._isAgentSpeaking;
      const isListening = agentState?.isListening || VoiceService._isListening;
      const connectionStatus = VoiceService.getConnectionStatus?.() || "";

      const QNA_FLOWS = ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa", "flow_gsa"];
      const isQnAFlow = QNA_FLOWS.includes(window.currentFlow);

      let statusText = "";

      if (connectionStatus === "not_initialized") {
        statusText = "";
      } else if (connectionStatus === "disconnected") {
        statusText = "Connection lost, reconnecting…";
      } else if (connectionStatus === "reconnecting") {
        statusText = "Connecting...";
      } else if (isAgentSpeaking) {
        statusText = "Speaking...";
      } else if (connectionStatus === "Processing_Question") {
        statusText = "Processing your question...";
      } else if (connectionStatus === "Forced_Status" && window.forcedStatusMyra) {
        statusText = window.forcedStatusMyra;
      } else if (connectionStatus === "Preparing_Response") {
        statusText = "Preparing response…";
      } else if (voiceTranscript && isListening) {
        if (qaSilencePhase === "listening") {
          statusText = "Listening…";
        } else if (qaSilencePhase === "still") {
          statusText = "Still listening…";
        } else if (qaSilencePhase === "thinking") {
          statusText = "Thinking…";
        }
      } else if (isListening) {
        statusText = isQnAFlow ? "Ask me anything..." : "Listening...";
      } else {
        statusText = "";
      }

      setVoiceStatus(statusText);
    };

    // Poll every 200ms so speaking/listening changes are reflected quickly
    computeStatus();
    const interval = setInterval(computeStatus, 200);
    return () => clearInterval(interval);
  }, [mode, voiceTranscript, qaSilencePhase]);

  const PROBLEM_AREA_OPTIONS = ["LBP", "HIP", "THIGH", "KNEE"].map((id) => ({
    id,
    label: MYRA_MESSAGES.problemArea.optionsById[id].label,
  }));

  const handleChipClick = async (option) => {
    setShowIntroCtas(true);
    setHideContent(true);
    window.hideNavbarBtm = true;

    const selectedArea = option?.id;
    window.showChips = true;
    setHideContent(true);
    window.chipGotCLicked = true;
    window.problemArea = selectedArea;
    setProblemArea(selectedArea);
    const updatedData = {
      started_assessment: true,
      myraInteractionMode: mode || "chat",
      isComeFromGoogle: isComeFromGoogle,
      isUserCameBackAgain: isUserCameBackAgain,
      variant: userVariant,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      problemArea: selectedArea,
      selected_problem_area: CONST.CLINICAL_PATHS?.[selectedArea]?.name || selectedArea,
      clicked_landing_cta: true,
      clicked_start_assessment: false,
      landing_cta_body_part: selectedArea || problemArea || null,
      session_last_update: new Date().toISOString(),
    };
    // localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    updateAssessmentData(updatedData);

    const phrasePerArea = {
      LBP: "My lower back hurts",
      HIP: "My hip hurts",
      THIGH: "My thigh hurts",
      KNEE: "My knee hurts",
    };

    const message = phrasePerArea[selectedArea];

    if (message && typeof handleInlineChat === "function") {
      pushToHistory({
        type: "user",
        text: message,
        id: nextId(),
      });

      await handleInlineChat(message);
    }
  };

  // ═══════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════

  useEffect(() => {
    window.trSessionId = localStorage?.getItem("trSessionId") || null;
    if (!window?.trSessionId && AnalyticsService) AnalyticsService?.startSession();
    window.timeTracker = new TimeTracker();
    window.timeTracker?.startGSATimer();
    window.screenTracker = new ScreenFlowTracker();
    localStorage.setItem("cameFromGsaV2", "false");

    // Belt-and-suspenders: ensure started_assessment is written even for direct
    // entries that bypass HomeScreen.handleStartAssessment (e.g., /problem-area
    // deep links from subpages, returning sessions). HomeScreen still sets this
    // during its landing-to-GSA transition; this is a safety net, not a replacement.
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        started_assessment: true,
        session_last_update: new Date().toISOString(),
      });
    }

    window.globalCrossClicked = () => setShowExitHandler(true);
    window.updateMicModalCancel = () => {
      const updated = { ...assessmentData, userCancelMic: true };
      updateAssessmentData(updated);
      if (AnalyticsService) AnalyticsService?.trackStep(updated);
    };

    return () => {
      window.globalCrossClicked = null;
      window.updateMicModalCancel = null;
    };
  }, []);

  // setting the placeholder
  useEffect(() => {
    const placeholder = INPUT_PLACEHOLDERS[currentStep] || INPUT_PLACEHOLDERS.default;
    setPlaceholderText(placeholder);
  }, [currentStep]);

  // useEffect(() => {
  //   if (displayMode === "fullscreen" && currentStep === "intro") {
  //     setCurrentStep("problem_area");
  //     pushToHistory({ type: "section-header", label: STEP_CONFIG.problem_area.label, id: nextId() });
  //   }
  // }, [displayMode, currentStep]);

  // ── Global AUTO_PAUSE command ──
  useEffect(() => {
    const timer = setTimeout(() => {
      const existing = window.currentCommandsAudio || {};
      window.currentCommandsAudio = {
        ...existing,
        AUTO_PAUSE: () => {
          if (isVoiceMode) {
            VoiceService?.doSay("I've paused. Take your time...");
          } else {
            setShowInactivityModal(true);
          }
        },
      };
    }, 200);
    return () => clearTimeout(timer);
  }, [currentStep]);

  // ── Embedded → fullscreen deferred advance ──
  // useEffect(() => {
  //   if (prevDisplayModeRef.current === "embedded" && displayMode === "fullscreen" && currentStep === "intro") {
  //     if (!window.trSessionId && AnalyticsService) AnalyticsService.startSession();
  //     localStorage.setItem("startedSelf", "1");
  //     if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD", value: 1.0, currency: "USD" });
  //     setCurrentStep("problem_area");
  //   }
  //   prevDisplayModeRef.current = displayMode;
  // }, [displayMode]);

  const pushToHistory = useCallback((...entries) => {
    setConversationHistory((prev) => [...prev, ...entries]);
  }, []);

  useEffect(() => {
    if (!MyraInteraction.getMode()) {
      MyraInteraction.switchMode("chat", true);
    }
  }, []);

  // ═══════════════════════════════════════════════════════════
  // PERSISTENCE
  // ═══════════════════════════════════════════════════════════

  const persistAndNavigate = useCallback(
    (newFields, nextStep) => {
      const updatedData = {
        ...assessmentData,
        ...newFields,
        screenFlow: window.screenTracker?.getScreenFlow() || [],
        session_last_update: new Date().toISOString(),
      };
      updatedData.analyticsId = window.trSessionId;
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      if (AnalyticsService) AnalyticsService.trackStep(updatedData);

      console.log("Steps", currentStep, nextStep, STEP_CONFIG[nextStep]);

      // Push divider + section header for the incoming screen
      // Skip section header if the next step shares the same label as the current step
      const nextConfig = STEP_CONFIG[nextStep];
      const skipDividerForSteps = ["pain_location"];
      const shouldSkipDivider = skipDividerForSteps.includes(nextStep) || (currentStep === "safety_screening" && nextStep === "test1_demo");
      const shouldAllowLabel = currentStep === "subtype_questioning" && nextStep === "self_assessment";
      if (nextConfig && nextStep !== "hard_stop") {
        const currentConfig = STEP_CONFIG[currentStep];
        if (window.test2WasSkipped) {
          console.log("SKIPPING HEADER AND DIVIDER , 2nd movement test moves to plan-recommendation");
        } else if (shouldSkipDivider) {
          console.log("SKIPPING HEADER AND DIVIDER , SETTING IT FROM THE PRE_NPRS_SCREEN");
        } else if (currentConfig && currentConfig.label === nextConfig.label && !shouldAllowLabel) {
          pushToHistory({ type: "divider", id: nextId() });
        } else {
          pushToHistory({ type: "divider", id: nextId() }, { type: "section-header", label: nextConfig.label, id: nextId() });
        }
      }

      setCurrentStep(nextStep);
    },
    [assessmentData, updateAssessmentData, pushToHistory, currentStep],
  );

  useEffect(() => {
    window.advanceToNoCameraExercise = () => {
      console.log("[advanceToNoCameraExercise] camera → no-camera switch, advancing route");

      // Release the camera if the user had granted it for the camera path.
      if (window.turnOffCamera) {
        try {
          window.turnOffCamera();
        } catch (e) {
          console.warn("turnOffCamera failed:", e);
        }
      }

      // Set noCameraMode flag and advance the route.
      localStorage.setItem("noCameraMode", "true");
      // window.currnetScreen = "self_report_rom";

      // Show the no-camera video player; hide the camera/AR siblings.
      const videoPlayer = document.getElementById("player_ondemand");
      if (videoPlayer) {
        videoPlayer.classList.remove("hide");
        // Kick the video to play (poster shows otherwise; autoplay can be blocked
        // until user gesture, which has already happened by this point in the flow)
        const v = videoPlayer.querySelector("video");
        if (v) {
          try {
            v.currentTime = 0;
            const p = v.play();
            if (p && typeof p.catch === "function") {
              p.catch((err) => console.warn("video play prevented:", err));
            }
          } catch (e) {
            console.warn("video play threw:", e);
          }
        }
      }

      // Hide the camera/AR surfaces so they don't overlap the video.
      const agoraLocal = document.getElementById("agora_ondemand_local");
      if (agoraLocal) agoraLocal.style.display = "none";
      const agoraWaiting = document.getElementById("agora_ondemand_local_waiting");
      if (agoraWaiting) agoraWaiting.style.display = "none";
      const startBtn = document.getElementById("buttonExpandCamera");
      if (startBtn) startBtn.style.display = "none";

      const ODRoot = document.getElementById("OnDemandPlayingRoot");
      if (ODRoot) ODRoot.style.display = "block";

      const assesDiv = document.getElementById("assesmentDiv");
      if (assesDiv) assesDiv.style.display = "none";
    };

    return () => {
      window.advanceToNoCameraExercise = null;
    };
  }, [currentStep, persistAndNavigate, pushToHistory]);

  useEffect(() => {
    if (mode === "chat") {
      VoiceService._releaseMic();
      VoiceService.stopAllVoiceActivity();
    }
  }, [mode, qaOpen]);

  // ═══════════════════════════════════════════════════════════
  // SCROLL MANAGEMENT
  // ═══════════════════════════════════════════════════════════

  const cancelScheduledScroll = useCallback(() => {
    if (scrollRafRef.current) {
      cancelAnimationFrame(scrollRafRef.current);
      scrollRafRef.current = null;
    }
    if (scrollRetryRef.current) {
      clearTimeout(scrollRetryRef.current);
      scrollRetryRef.current = null;
    }
  }, []);

  const scrollToBottom = useCallback(
    (behavior = "smooth") => {
      if (userScrolledUpRef.current) return;

      cancelScheduledScroll();

      scrollRafRef.current = requestAnimationFrame(() => {
        const chatContainer = chatAreaRef.current;
        if (!chatContainer) return;

        const prefersReducedMotion = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

        chatContainer.scrollTo({
          top: chatContainer.scrollHeight,
          behavior: prefersReducedMotion ? "auto" : behavior,
        });

        scrollRafRef.current = null;
      });
    },
    [cancelScheduledScroll],
  );

  // Scrolls so that the most recent user-echo bubble sits at (or near)
  // the top of the visible chat area. Falls back to scrollToBottom if no
  // echo is available yet (first-screen entry, or before any user input).
  const scrollToPreviousEcho = useCallback(
    (behavior = "smooth") => {
      if (userScrolledUpRef.current) return;
      const currentStepValue = currentStepRef.current;

      const chatContainer = chatAreaRef.current;
      const echoId = lastUserEchoIdRef.current;
      if (!chatContainer) return;
      if (!echoId) {
        // No previous echo (e.g., first navigation). Just scroll to bottom.
        scrollToBottom(behavior);
        return;
      }

      cancelScheduledScroll();

      scrollRafRef.current = requestAnimationFrame(() => {
        const echoEl = chatContainer.querySelector(`[data-entry-id="${echoId}"]`);
        if (!echoEl) {
          // Echo element not in DOM yet — fall back to bottom for this pass.
          scrollToBottom(behavior);
          return;
        }

        const prefersReducedMotion = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

        // Position the echo ~16px below the top of the chat container.
        const containerTop = chatContainer.getBoundingClientRect().top;
        const echoTop = echoEl.getBoundingClientRect().top;
        const offsetWithinScroll = chatContainer.scrollTop + (echoTop - containerTop) + 16;
        if (currentStepValue === "plan" && intentionalScroll.current !== null) {
          return;
        }

        chatContainer.scrollTo({
          top: Math.max(0, offsetWithinScroll),
          behavior: prefersReducedMotion ? "auto" : behavior,
        });
        if (currentStepValue === "plan") {
          intentionalScroll.current = true;
        }
        scrollRafRef.current = null;
      });
    },
    [cancelScheduledScroll, scrollToBottom],
  );
  useEffect(() => {
    return () => {
      cancelScheduledScroll();
    };
  }, [cancelScheduledScroll]);
  useEffect(() => {
    return () => {
      if (postTapTimerRef.current) {
        clearTimeout(postTapTimerRef.current);
        postTapTimerRef.current = null;
      }
    };
  }, []);

  // Re-scroll after images in the chat finish loading. Widgets like the body
  // outline include images whose height isn't known until load, so an earlier
  // scrollToBottom call can land short of the true bottom.
  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;
    const handleLoad = () => scrollToPreviousEcho("smooth");
    el.addEventListener("load", handleLoad, { capture: true });
    return () => el.removeEventListener("load", handleLoad, { capture: true });
  }, [scrollToPreviousEcho]);

  // Re-scroll after videos report metadata. Videos don't know their height
  // until `loadedmetadata` fires — the `load` listener above doesn't catch
  // that. Used by TestIntroScreen and TestIntro2Screen.
  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;
    const handleLoadedMetadata = (e) => {
      if (e.target && e.target.tagName === "VIDEO") {
        scrollToPreviousEcho("smooth");
        scrollRetryRef.current = setTimeout(() => scrollToPreviousEcho("smooth"), 120);
      }
    };
    el.addEventListener("loadedmetadata", handleLoadedMetadata, { capture: true });
    return () => el.removeEventListener("loadedmetadata", handleLoadedMetadata, { capture: true });
  }, [scrollToBottom]);

  // Re-scroll whenever the chat area's content changes. Catches state-driven
  // reveals (CameraPermissionScreen's `setReady(true)`, TestIntroScreen's
  // mode-select card, RecoveryScoreScreen's async API data) that don't push
  // to `conversationHistory` and so escape the second-pass effect below.
  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;
    let mutationTimer = null;
    let settleTimer = null;

    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimer);
      clearTimeout(settleTimer);

      mutationTimer = setTimeout(() => {
        scrollToPreviousEcho("smooth");
        settleTimer = setTimeout(() => scrollToPreviousEcho("smooth"), 180);
      }, 60);
    });

    observer.observe(el, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      clearTimeout(mutationTimer);
      clearTimeout(settleTimer);
    };
  }, [scrollToPreviousEcho]);

  useEffect(() => {
    const step = new URLSearchParams(search).get("step");
    if (!step) return;
    if (step === "askmyra" || step === "howitworks" || step === "aboutvirdio" || step === "startnow") {
      localStorage.setItem("isV2", "true");
    }

    switch (step) {
      case "askmyra":
        history.replace("/ask-myra");
        break;
      case "howitworks":
        history.replace("/how-it-works");
        break;
      case "aboutvirdio":
        history.replace("/about");
        break;
      // case "startnow":
      //   handleStartAssessment();
      // break;
      default:
        break;
    }
  }, [search, history]);
  useEffect(() => {
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    if (previousSessionIdExits) {
      localStorage.removeItem("trSessionId");
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }
    window.screenTracker.enterScreen("landing");

    // Repeat visitor detection
    const isRepeat = localStorage.getItem("isUserCameBackAgain") === "true";
    if (isRepeat) {
      setIsUserCameBackAgain(true);
    }
    localStorage.setItem("isUserCameBackAgain", "true");

    // URL param detection (variant / gclid)
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const urlVariant = params.get("variant");
    const resolvedVariant = urlVariant || localStorage.getItem("variant") || null;

    if (urlVariant) {
      localStorage.setItem("variant", urlVariant);
    }

    const isFromGoogle = !!(gclid || resolvedVariant);
    if (resolvedVariant) setUserVariant(resolvedVariant);
    if (isFromGoogle) setIsComeFromGoogle(true);

    // Check whether the user came to the landing page from a subpage this session.
    // Subpages set this marker on page load; we consume it so it only fires once.
    const cameFromSubpage = localStorage.getItem("visitedSubpageBeforeLanding") === "true";
    if (cameFromSubpage) {
      localStorage.removeItem("visitedSubpageBeforeLanding");
    }

    // Build tracking fields for session creation
    const trackingFields = {
      variant: resolvedVariant,
      isComeFromGoogle: isFromGoogle,
      isUserCameBackAgain: isRepeat,
      cameToLandingPage: cameFromSubpage,
    };

    const initializeSession = async () => {
      await AnalyticsService.startSession(trackingFields);
    };

    // if (window?.timeTracker) {
    //   window?.timeTracker?.startLandingTimer();
    // }

    fetch("https://virdio.weborik.com/init.php")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.session;
      })
      .catch((error) => {
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        initializeSession();
      });
  }, []);

  // ═══════════════════════════════════════════════════════════
  // STEP LABEL + PROGRESS SYNC
  // ═══════════════════════════════════════════════════════════

  useEffect(() => {
    const config = STEP_CONFIG[currentStep];
    if (config) {
      setStepLabel(config.label);
      // Only update progress if this step has a defined value.
      // Screens without `progress` (mode_selection, camera_permission,
      // recovery_score) hold the previous value — the bar never moves
      // backward when the user briefly visits a non-counted screen.
      if (typeof config.progress === "number") {
        setProgressPercent(config.progress);
      }
    }
    // Reset scroll guard so new screens always scroll into view
    userScrolledUpRef.current = false;
    // On step change, anchor to the previous user echo so the user reads
    // their last answer → Myra's Ack → divider → new content top-down.
    scrollToPreviousEcho("smooth");
  }, [currentStep, scrollToPreviousEcho]);

  // Track the most recent user echo so we can anchor scroll there on
  // the next step transition.
  useEffect(() => {
    for (let i = conversationHistory.length - 1; i >= 0; i--) {
      if (conversationHistory[i].type === "user") {
        lastUserEchoIdRef.current = conversationHistory[i].id;
        break;
      }
    }
  }, [conversationHistory]);

  useEffect(() => {
    scrollToPreviousEcho("smooth");
    // Second pass after layout settles. The first scrollToBottom fires before
    // the live widget (rendered by renderScreen) has finished mounting —
    // especially when a screen uses setReady(true) to reveal its widget after
    // the Myra prompt. This second call catches the final content height.
    const t = setTimeout(() => scrollToPreviousEcho("smooth"), 180);
    return () => clearTimeout(t);
  }, [conversationHistory, typingVisible, scrollToPreviousEcho]);

  useEffect(() => {
    const el = chatAreaRef.current;
    if (!el) return;
    function onScroll() {
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 60;
      userScrolledUpRef.current = !atBottom;
    }
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  // ═══════════════════════════════════════════════════════════
  // HISTORY HELPERS
  // ═══════════════════════════════════════════════════════════

  const showMyraMessage = useCallback(
    async (text, typingMs = 800) => {
      setTypingVisible(true);
      await _delay(typingMs);
      setTypingVisible(false);
      const entry = { type: "myra", text, id: nextId() };
      pushToHistory(entry);
      return entry;
    },
    [pushToHistory],
  );

  const showQuestionNuggetMessage = useCallback(
    async (questionText, nuggetText, typingMs = 900) => {
      const html = `
        <div class="${styles.qNuggetBubble}">
          <div class="${styles.qNuggetQuestion}">${questionText}</div>
          ${nuggetText ? `<div class="${styles.qNuggetDivider}"></div><div class="${styles.qNuggetText}">${nuggetText}</div>` : ""}
        </div>
      `;
      return showMyraMessage(html, typingMs);
    },
    [showMyraMessage],
  );

  const runRecoveryPlanHandoff = useCallback(
    async (fields = {}) => {
      const placeholder = INPUT_PLACEHOLDERS.recovery_plan_reveal;
      setPlaceholderText(placeholder);
      const merged = { ...assessmentData, ...fields };
      pushToHistory({ type: "divider", id: nextId() }, { type: "section-header", label: "MOVEMENT TEST REVEAL", id: nextId() });

      const beatKey = CONST.resolveLongTermBeatKey(merged);
      const longTermBeat = beatKey ? getNestedMessage(MYRA_MESSAGES.handoff?.longTermBeats, beatKey) : null;
      if (longTermBeat) await showMyraMessage(longTermBeat, 1200);

      const testName = CONST.resolveMovementTestNameFromAssessment(merged);
      const testPick = resolveMessage(MYRA_MESSAGES.handoff?.testPickTemplate || "", { testName });
      if (testPick) await showMyraMessage(testPick, 900);

      const revealQuestion = MYRA_MESSAGES.handoff?.movementRevealQuestion || "A good time to check if you have any questions?";
      if (revealQuestion) await showMyraMessage(revealQuestion, 800);

      pushToHistory({
        type: "movement-reveal-ready",
        id: nextId(),
        label: MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now",
        guideText: MYRA_MESSAGES.handoff?.movementRevealGuide || "Or type your questions below",
        fields,
      });
    },
    [assessmentData, pushToHistory, showMyraMessage],
  );

  // ═══════════════════════════════════════════════════════════
  // QNA OVERLAY PAYLOAD
  // ═══════════════════════════════════════════════════════════

  const screenPayload = useMemo(() => {
    const keyMap = {
      intro: "landing",
      problem_area: "problem_area",
      pain_location: "pain_location",
      safety_screening: "SafetyScreeningScreen",
      cpg_questions: "cpg_questions",
      subtype_questioning: "subtype_questioning",
      self_assessment: "self_assessment",
      nprs_symptoms: "nprs_symptoms",
      test1_demo: "test1_demo",
      movement_test_1: "movement_test_1",
      self_report_rom: "self_report_compare",
      self_report_tempo: "self_report_speed",
      rpe: "test1_rpe",
      feel_affect: "test1_symptoms",
      test2_demo: "test2_demo",
      movement_test_2: "movement_test_2",
      feedback2: "symptom2",
      personalize: "personalize",
      recovery_score: "recovery_score",
      plan: "plan_screen",
    };
    const useMovementContextFromNprs = currentStep === "nprs_symptoms" && nprsPainSelected;
    console.log("useMovementContextFromNprs", useMovementContextFromNprs, "nprsPainSelected", nprsPainSelected);
    const stepForPayload = useMovementContextFromNprs ? "test1_demo" : currentStep;
    const key = keyMap[stepForPayload];
    if (!key) return {};
    return generatePayloadForScreen(key, assessmentData);
  }, [currentStep, assessmentData, nprsPainSelected]);

  const inlineChatHistoryRef = useRef([]);

  async function handleInlineChat(text) {
    // Fires the GSA transition out of the landing chat. Called by the
    // start_gsa_request block (when Claude explicitly signals readiness)
    // and by the auto-trigger block (when the bucket is full and safety
    // is resolved, regardless of intent). Sets transitionFiredRef so the
    // two blocks never both fire in the same turn.
    const fireTransition = (currentBucket, transitionFields = {}) => {
      transitionFiredRef.current = true;
      // MovementTest1Screen AR bootstrap (loadSelf / payloads) must run only when
      // leaving intro via inline chat — not when the user started from landing chips
      // (handleChipClick) or other structured flows (duplicate preload / wrong ordering vs 321).
      window._gsaLandingChatMovementTest = true;
      if (typeof onStartAssessment === "function") {
        onStartAssessment();
      }
      setTimeout(() => {
        const nextScreen = findFirstMissingScreen(currentBucket);
        if (nextScreen === "movement_test_1") {
          if (AnalyticsService) {
            AnalyticsService.trackStep({
              ...assessmentData,
              rom_test1_started: true,
              session_last_update: new Date().toISOString(),
            });
          }
        }
        if (nextScreen) {
          persistAndNavigate(transitionFields, nextScreen);
        }
      }, 500);
    };

    // Build history for context
    const newHistory = [...inlineChatHistoryRef.current, { role: "user", content: text }];
    let mergedAssessmentData = assessmentData;
    const mergeAssessmentFields = (fieldsToMerge) => {
      if (!fieldsToMerge || Object.keys(fieldsToMerge).length === 0) return;
      mergedAssessmentData = { ...mergedAssessmentData, ...fieldsToMerge };
      updateAssessmentData(fieldsToMerge);
      if (fieldsToMerge?.cpgForBackend) {
        console.log("[Landing] cpgForBackend ", fieldsToMerge?.cpgForBackend);
      }
      const existing = JSON.parse(localStorage.getItem("assessmentData") || "{}");
      // localStorage.setItem("assessmentData", JSON.stringify({ ...existing, ...fieldsToMerge }));
    };

    // ── Determine engagement touchpoint for this chat turn ──
    // intro step = landing (the user is chatting with Myra while GSA is embedded
    // on the landing page). plan step = post-plan. Everything else = GSA mid-journey.
    let engagementFields = {};
    const turnCount = inLineChatHistory;
    if (currentStep === "intro") {
      setShowIntroCtas(true);
      setHideContent(true);
      window.showChips = true;
      window.hideNavbarBtm = true;
      window.myraEngagedLanding = true;
      engagementFields = {
        myraEngagedLanding: true,
        myraChatMessagesCount: turnCount,
        myraConversationCount: turnCount,
        myraTotalTurns: turnCount,
      };
      // Notify HomeScreen so its local state stays in sync with the DB write.
      // (HomeScreen also writes its own trackStep, but this is the source of truth.)
      if (typeof onMyraEngagement === "function") {
        onMyraEngagement(turnCount);
      }
    } else if (currentStep === "plan") {
      window.myraEngagedPostPlan = true;
      engagementFields = {
        myraEngagedPostPlan: true,
        myraConversationCount: turnCount,
        myraTotalTurns: turnCount,
      };
    } else {
      window.myraEngagedGsa = true;
      engagementFields = {
        myraEngagedGsa: true,
        myraConversationCount: turnCount,
        myraTotalTurns: turnCount,
      };
    }

    // Write engagement immediately. Don't wait for Myra's response — if the
    // request fails, we still want to know the user engaged.
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        ...engagementFields,
        session_last_update: new Date().toISOString(),
      });
    }

    // Show typing indicator
    setTypingVisible(true);
    if (pendingPostTapRef.current !== null) {
      const postTapText = pendingPostTapRef.current;
      postTapTimerRef.current = setTimeout(() => {
        pushToHistory({ type: "myra", text: postTapText, id: nextId() });
        pendingPostTapRef.current = null;
        postTapTimerRef.current = null;
      }, 2000);
    }

    try {
      const screenPayloadForChat =
        currentStep === "intro"
          ? generatePayloadForScreen("intro", assessmentData)
          : generatePayloadForScreen("SafetyScreeningScreen", {
              ...assessmentData,
              safetySelections: window.safetySelections,
              safetySelectionIds: window.safetySelectionIds,
            });

      const response = await MyraChatService.sendMessage(text, window.trSessionId, inLineChatHistory, inLineChatHistory.length, screenPayloadForChat, currentStep);
      if (response.history) {
        setInLineChatHistory(response.history);
      }

      setTypingVisible(false);

      // const answerText = response?.response || response?.speech || "I'm not sure how to answer that right now.";
      const answerText = response?.response || response?.speech || "";

      // ── intents normalization ──
      // Declared here at the top of the response-handling block so every
      // downstream consumer (answerText push gating, extract-merge
      // observability, bridge persistence, safety persistence, bucket
      // router) reads from a single normalized array.
      const intents = Array.isArray(response?.intent) ? response.intent : response?.intent ? [response.intent] : [];

      // ── Observability: unknown intent value ──
      // Surfaces intent values not in the known vocabulary. Helps catch
      // prompt drift, backend bugs, or new intents that haven't been
      // added to KNOWN_LANDING_INTENTS yet.
      intents.forEach((intent) => {
        if (!KNOWN_LANDING_INTENTS.includes(intent)) {
          console.warn("[Landing] Unknown intent value", { intent, knownIntents: KNOWN_LANDING_INTENTS });
        }
      });

      // ── Observability: empty response text with non-discard intent ──
      // The existing if (answerText) guard below already skips the push
      // when text is empty. This warning surfaces the case where empty
      // text arrives paired with an intent other than noise_discard,
      // which suggests Claude returned an incomplete or malformed reply.
      if (!answerText && !intents.includes("noise_discard")) {
        console.warn("[Landing] Empty response text with non-discard intent", { response });
      }

      // Push Myra's response to main chat history
      if (answerText) {
        pushToHistory({ type: "myra", text: answerText, id: nextId() });
      }
      if (currentStep === "intro") {
        const intakeIntents = intents.filter((i) => typeof i === "string" && i.startsWith("intake_"));
        if (intakeIntents.length > 0) {
          const lastIntakeIntent = intakeIntents[intakeIntents.length - 1];

          const INTAKE_INTENT_TO_PLACEHOLDER = {
            intake_problemArea: INPUT_PLACEHOLDERS.problem_area,
            intake_selectedZones: INPUT_PLACEHOLDERS.pain_location,
            intake_cpg: INPUT_PLACEHOLDERS.cpg_questions,
            intake_subtype: INPUT_PLACEHOLDERS.subtype_questioning,
            intake_subtypeQ1: INPUT_PLACEHOLDERS.self_assessment,
            intake_subtypeQ2: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_subtypeAnswer: INPUT_PLACEHOLDERS.nprs_symptoms,
            intake_painLevel: INPUT_PLACEHOLDERS.nprs_symptoms,
          };
          const INTAKE_INTENT_TO_EXIT_STEP = {
            intake_problemArea: "problem_area",
            intake_selectedZones: "pain_location",
            intake_cpg: "cpg_questions",
            intake_subtype: "subtype_questioning",
            intake_subtypeQ1: "subtype_questioning",
            intake_subtypeQ2: "subtype_questioning",
            intake_subtypeAnswer: "self_assessment",
            intake_painLevel: "nprs_symptoms",
          };
          const nextExitStep = INTAKE_INTENT_TO_EXIT_STEP[lastIntakeIntent];
          if (nextExitStep) {
            setExitCurrentStep(nextExitStep);
          }

          const nextPlaceholder = INTAKE_INTENT_TO_PLACEHOLDER[lastIntakeIntent];
          if (nextPlaceholder) {
            setPlaceholderText(nextPlaceholder);
          }
          if (intents.includes("safety_screen_conversation")) {
            setPlaceholderText(INPUT_PLACEHOLDERS.safety_screening);
          }
        } else {
          setPlaceholderText(INPUT_PLACEHOLDERS.default);
        }
      }
      const hasSafetyStop = response?.actions?.some((item) => item.action === "SAFETY_STOP");
      if (hasSafetyStop) {
        pushToHistory({
          type: "frozen-widget",
          widgetType: "safety_stop_card",
          id: Math.random().toString(36).substr(2, 9),
          data: {
            detail: "",
          },
        });

        const followUp = MYRA_MESSAGES.safetyOutcome?.stoppedFollowUp || "I know this isn't the news you were hoping for. If you have any questions, I'm right here.";
        showMyraMessage(followUp, 800);
      }

      // Update inline history for multi-turn context
      inlineChatHistoryRef.current = [...newHistory, { role: "assistant", content: answerText }];

      // ── Spec 1: persist extracted bucket-named fields ──
      // mapExtractedToAssessmentData translates Claude's bucket-name fields
      // (problemArea, selectedZones, cpgAnswer, painLevel, biometrics, etc.)
      // into the field names each GSA screen reads on mount.
      if (response?.extracted && typeof response.extracted === "object") {
        const fieldsToMerge = mapExtractedToAssessmentData(response.extracted, mergedAssessmentData);
        // Debuging the cpgForBackend
        if (fieldsToMerge.cpgForBackend) {
          console.log("[Landing] cpgForBackend captured:", {
            cpgAnswer: response.extracted.cpgAnswer,
            subtypeAnswer: response.extracted.subtypeAnswer,
            cpgForBackend: fieldsToMerge.cpgForBackend,
            problemArea: mergedAssessmentData.problemArea || fieldsToMerge.problemArea,
          });
        }
        mergeAssessmentFields(fieldsToMerge);
      }

      // ── Observability: intake intent with no matching extracted field ──
      // Surfaces cases where Claude emits an intake_* intent but the
      // corresponding bucket field is missing from response.extracted.
      // Helps catch prompt drift between intent and extraction.
      const intakeFieldMap = {
        intake_problemArea: ["problemArea"],
        intake_selectedZones: ["selectedZones"],
        intake_cpg: ["cpgAnswer"],
        intake_subtype: ["subtypeQ1", "subtypeQ2", "subtypeAnswer"],
        intake_subtypeQ1: ["subtypeQ1"],
        intake_subtypeQ2: ["subtypeQ2"],
        intake_subtypeAnswer: ["subtypeAnswer"],
        intake_painLevel: ["painLevel"],
      };
      intents.forEach((intent) => {
        if (typeof intent === "string" && intent.startsWith("intake_")) {
          const expected = intakeFieldMap[intent];
          if (expected) {
            const extracted = response?.extracted || {};
            const hasAny = expected.some((field) => extracted[field] !== undefined);
            if (!hasAny) {
              console.warn("[Landing] Intake intent fired but no matching extracted field", { intent, expected, extracted });
            }
          }
        }
      });
      (() => {
        const hasBridge = intents.includes("bridge");
        const hasSafety = intents.some((i) => typeof i === "string" && i.startsWith("safety_screen_"));

        if (hasBridge || hasSafety) {
          pendingPostTapRef.current = null;
          return;
        }

        const intakeIntents = intents.filter((i) => typeof i === "string" && i.startsWith("intake_"));
        if (intakeIntents.length === 0) return; // nothing captured this turn

        const lastIntent = intakeIntents[intakeIntents.length - 1];
        const ext = response?.extracted || {};
        let resolved = null;

        if (ext.subtypeAnswer !== undefined) {
          // HIP / KNEE / THIGH subtype answer — option id like "hip-sub-lateral"
          const answerId = ext.subtypeAnswer;
          resolved = (answerId && MYRA_MESSAGES.subtypeQ1?.postTap?.[answerId]) || MYRA_MESSAGES.postTapGeneric?.subtypeAnswer || null;
        } else if (ext.subtypeQ2 !== undefined) {
          // LBP Q2 — yes/no; single postTap string, no per-option variant
          resolved = MYRA_MESSAGES.q2?.postTap || MYRA_MESSAGES.postTapGeneric?.subtypeQ2 || null;
        } else if (ext.subtypeQ1 !== undefined) {
          // LBP Q1 — option id like "q1a", "q1b", etc.
          const q1Id = ext.subtypeQ1;
          const messageKey = q1Id?.length === 1 ? `q1${q1Id}` : q1Id;
          resolved = (q1Id && MYRA_MESSAGES.subtypeQ1?.postTap?.[messageKey]) || MYRA_MESSAGES.postTapGeneric?.subtypeQ1 || null;
          console.log("subtypeQ1 response captured: ", resolved, q1Id);
        } else if (ext.cpgAnswer !== undefined) {
          // CPG option — id like "cpg-mobility", "hip-cpg-power", etc.
          const cpgId = ext.cpgAnswer;
          resolved = (cpgId && MYRA_MESSAGES.cpg?.postTap?.[cpgId]) || MYRA_MESSAGES.postTapGeneric?.cpg || null;
        } else if (ext.painLevel !== undefined) {
          resolved = MYRA_MESSAGES.postTapGeneric?.painLevel || null;
        } else if (ext.problemArea !== undefined) {
          const area = ext.problemArea;
          resolved = (area && MYRA_MESSAGES.problemArea?.ackByArea?.[area]) || null;
        } else if (ext.selectedZones !== undefined) {
          resolved = null; // no postTap content for zones yet
        }
        // If extracted is null/empty or no known field was captured, leave resolved = null (silent).
        pendingPostTapRef.current = resolved || null;
      })();

      // ── Spec 1: persist disclosed conditions ──
      // Merge into localStorage.userCondition (the canonical store that
      // getUserConditions() reads on every payload and that Recovery Score /
      // Personalize / etc. consume downstream). Runs every turn — conditions
      // can be disclosed at any point in the conversation.
      if (response?.conditions && typeof response.conditions === "object") {
        const existingRaw = localStorage.getItem("userCondition");
        const existing = existingRaw ? JSON.parse(existingRaw) : {};
        const existingConds = existing.usercondition || { pre_existing: [], current: [] };

        const merged = {
          pre_existing: Array.from(new Set([...(existingConds.pre_existing || []), ...(response.conditions.pre_existing || [])])),
          current: Array.from(new Set([...(existingConds.current || []), ...(response.conditions.current || [])])),
        };

        localStorage.setItem("userCondition", JSON.stringify({ usercondition: merged }));
      }

      // ── Reveal-Safety: persist reveal bucket field on bridge intent ──
      // When Claude delivers the bridge response, the reveal moment has
      // happened. resolveMovementTestNameFromAssessment is the same helper
      // Path A uses in runRecoveryPlanHandoff to name the user's first
      // movement test.
      if (intents.includes("bridge")) {
        const resolvedTestName = CONST.resolveMovementTestNameFromAssessment(mergedAssessmentData);
        const bridgeTestName = screenPayloadForChat?.gsa_question_bank?.bridge?.testName;
        const testName = resolvedTestName && resolvedTestName !== "your first movement test" ? resolvedTestName : bridgeTestName;
        if (isKnownMovementTestName(testName)) {
          mergeAssessmentFields({ reveal: testName });
        }
      }

      // ── Reveal-Safety: persist safety bucket field on SAFETY_* action ──
      // The action is the source of truth. Strip the SAFETY_ prefix to
      // match the bucket field's value shape ("CONTINUE" / "ADVISORY" /
      // "STOP"). safetyOutcome is also written for parity with Path A's
      // SafetyScreeningScreen, which sets assessmentData.safetyOutcome via
      // its own onContinue.
      //
      // Fallback: Haiku occasionally returns intent: ["safety_screen_outcome"]
      // without the paired SAFETY_* action field, even though the prompt
      // requires it. When that happens, treat it as SAFETY_CONTINUE — that
      // intent is only emitted on the terminal turn of the safety
      // conversation and the warm-close text already implies the user is
      // proceeding. ADVISORY and STOP still require the explicit action;
      // the fallback only covers the most common (and most user-blocking)
      // case. Without this, a missing action field causes the bucket
      // router to silently no-op on the next turn's start_gsa_request.
      let safetyValue = null;
      if (typeof response?.action === "string" && response.action.startsWith("SAFETY_")) {
        safetyValue = response.action.slice("SAFETY_".length);
      } else if (intents.includes("safety_screen_outcome")) {
        // Observability: safety_screen_outcome arrived without a paired
        // SAFETY_ action. The fallback below defaults to CONTINUE. This
        // warning surfaces how often the fallback fires in practice.
        console.warn("[Landing] safety_screen_outcome intent received without SAFETY_ action, defaulting to CONTINUE", { response });
        safetyValue = "CONTINUE";
      }
      if (safetyValue) {
        mergeAssessmentFields({ safety: safetyValue, safetyOutcome: safetyValue });

        if ((safetyValue === "CONTINUE" || safetyValue === "ADVISORY") && currentStep === "intro" && !transitionFiredRef.current) {
          const currentBucket = buildBucketState(mergedAssessmentData);
          setChatBucketTest(currentBucket);
          fireTransition(currentBucket, mergedAssessmentData);
        }
      }

      // Execute any command the backend returned (SAFETY_CONTINUE, SAFETY_STOP, etc.)
      if (response?.action && window.currentCommandsAudio?.[response.action]) {
        setTimeout(() => {
          window.currentCommandsAudio[response.action](response.value, response.speech, response.intent);
        }, 500);
      }

      // ── Spec 1: bucket router on start_gsa_request (intro only) ──
      // When Claude signals the user is ready to advance to the GSA, fire
      // the existing fullscreen transition and land on the first screen
      // with missing bucket data (or safety_screening if the bucket is
      // fully captured). The 500ms timeout matches the existing 450ms
      // CSS exit animation in HomeScreen.handleStartAssessment.
      //
      // ── Reveal-Safety: bucket router branches on safety state ──
      // On Path B, the user's readiness signal after the bridge fires
      // "start_gsa_request". What happens next depends on whether the
      // safety beat has resolved yet:
      //
      //   safety === null         → stay in chat. The next prompt turn
      //                              from Myra opens the safety question.
      //   safety === "CONTINUE"   → fire the transition.
      //   safety === "ADVISORY"     findFirstMissingScreen decides where
      //                              to land (mode_selection if reveal is
      //                              set, else test1_demo).
      //   safety === "STOP"       → defensive no-op. The prompt should
      //                              not produce start_gsa_request in a
      //                              STOP state. If it ever does, the
      //                              router does nothing visible.
      if (intents.includes("start_gsa_request") && currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        setChatBucketTest(currentBucket);
        const safetyState = currentBucket.safety;

        if (safetyState === "CONTINUE" || safetyState === "ADVISORY") {
          fireTransition(currentBucket);
        }
        // safetyState === null   → no-op. Prompt drives the next turn (safety question).
        // safetyState === "STOP" → no-op. Prompt should not have produced this state.
      }

      // ── Auto-trigger fallback: bucket is full and safety is resolved ──
      // Fires when Claude omits start_gsa_request even though every bucket
      // field is captured. transitionFiredRef ensures this block and the
      // start_gsa_request block above never both fire in the same turn.
      if (currentStep === "intro" && !transitionFiredRef.current) {
        const currentBucket = buildBucketState(mergedAssessmentData);
        console.log("currentBucket is  : ", currentBucket, "reveal is : ", currentBucket.reveal);
        setChatBucketTest(currentBucket);
        if (isReadyForAutoTransition(currentBucket)) {
          fireTransition(currentBucket);
        }
      }
    } catch (err) {
      setTypingVisible(false);
      pushToHistory({
        type: "myra",
        text: "Sorry, something went wrong. Please try again.",
        id: nextId(),
      });
    } finally {
      setTypingVisible(false);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // INPUT BAR ROUTING (Rule 1)
  // ═══════════════════════════════════════════════════════════

  async function handleInputSubmit() {
    const text = inputText.trim();
    if (!text) return;
    setInputText("");
    if (window.notOpenQNA === true) {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    // Intro
    if (currentStep === "intro") {
      pushToHistory({ type: "user", text, id: nextId() });
      await handleInlineChat(text);
      return;
    }

    // Problem Area
    if (currentStep === "problem_area") {
      const area = detectAreaKeyword(text);
      if (area) {
        pushToHistory({ type: "user", text, id: nextId() });
        paCommandRef.current?.(area);
        return;
      }
    }

    // All other screens → overlay
    setTypingVisible(true);
    qaRef.current?.addExchange?.(text, null, "typed", true, () => setTypingVisible(false));
    window.audioPlayer?.unlockAudioForChat?.();
    // setQaOpen(true);
  }

  function detectIntents(text) {
    // Intent matching logic deferred — separate project
    const area = detectAreaKeyword(text);
    if (area) setDetectedArea(area);
  }

  // ═══════════════════════════════════════════════════════════
  // Q&A STRIP SYSTEM (Rule 6)
  // ═══════════════════════════════════════════════════════════

  function handleQaOverlayClose() {
    setQaOpen(false);
    const exchanges = qaRef.current?.getExchanges?.() || [];
    const newStrips = [];
    exchanges.forEach((ex) => {
      if (!qaStripIdsRef.current.has(ex.id) && ex.originScreen === currentStep) {
        qaStripIdsRef.current.add(ex.id);
        newStrips.push({ type: "qa-strip", id: nextId(), qaId: ex.id, question: ex.question });
      }
    });
    if (newStrips.length > 0) pushToHistory(...newStrips);
  }

  function handleStripClick(qaId) {
    qaRef.current?.focusExchange?.(qaId);
    window.audioPlayer?.unlockAudioForChat?.();
    setQaOpen(true);
  }

  function handleMovementRevealReady(entry) {
    const label = entry.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now";
    const echoText = MYRA_MESSAGES.handoff?.movementRevealReadyEcho || "I'm good for now.";

    setConversationHistory((prev) =>
      prev.map((item) =>
        item.id === entry.id
          ? {
              type: "frozen-widget",
              widgetType: "movement_reveal_ready",
              data: { label },
              id: item.id,
            }
          : item,
      ),
    );

    pushToHistory({ type: "user", text: echoText, id: nextId() });
    persistAndNavigate(entry.fields || {}, "nprs_symptoms");
  }

  // ═══════════════════════════════════════════════════════════
  // HISTORY RENDERER
  // ═══════════════════════════════════════════════════════════

  function renderHistoryEntry(entry) {
    const isProblemAreaHeading = entry.label === STEP_CONFIG.problem_area.label;
    switch (entry.type) {
      case "myra":
        return (
          <div key={entry.id} className={styles.msgRowMyra}>
            <div className={styles.msgAvatar}>M</div>
            <div className={styles.msgBubbleMyra} dangerouslySetInnerHTML={{ __html: entry.text }} />
          </div>
        );
      case "user":
        return (
          <div key={entry.id} data-entry-id={entry.id} className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>{entry.text}</div>
          </div>
        );
      case "divider":
        return <div key={entry.id} className={styles.sectionDivider} />;
      case "section-header":
        return (
          <div key={entry.id} className={`${styles.sectionHeader}${isProblemAreaHeading ? ` ${styles.sectionHeaderProblemArea}` : ""}`}>
            {entry.label}
          </div>
        );
      case "voice-indicator":
        return (
          <div key={entry.id} className={styles.inlineUi}>
            <div className={styles.myraVoiceIndicator}>
              {VOICE_ICON_SVG}
              <span>Myra will announce this screen</span>
            </div>
          </div>
        );
      case "voice-indicator2":
        return (
          <div key={entry.id} className={styles.inlineUi2} style={{ margin: "0 auto" }}>
            <div className={styles.myraVoiceIndicator}>
              {VOICE_ICON_SVG}
              <span>Myra will announce this screen</span>
            </div>
          </div>
        );
      case "qa-strip":
        return (
          <div key={entry.id} className={styles.qaStrip} onClick={() => handleStripClick(entry.qaId)}>
            <span className={styles.qaStripIcon}>💬</span>
            <span className={styles.qaStripText}>You asked: {entry.question}</span>
            <span className={styles.qaStripArrow}>›</span>
          </div>
        );
      case "movement-reveal-ready":
        return <MovementRevealReadyChip key={entry.id} label={entry.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now"} guideText={entry.guideText} onClick={() => handleMovementRevealReady(entry)} />;
      case "frozen-widget":
        return renderFrozenWidget(entry);
      case "pain-location-summary":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "safety_screening")} readOnly={true} entry={entry} phase="pain_location" />;
      case "safety-summary":
        return <SafetyScreeningScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} onHardStop={(source) => persistAndNavigate({ safetyScreenResult: "FLAGGED", hardStopSource: source }, "hard_stop")} readOnly={true} entry={entry} />;
      default:
        return null;
    }
  }

  function renderFrozenWidget(entry) {
    if (entry.widgetType === "problem_area") {
      const { selectedArea, options = [] } = entry.data;
      return (
        <div key={entry.id} className={styles.frozenStripInline}>
          <div className={styles.frozenStripInlineLabel}>Where do you feel pain?</div>
          <div className={styles.frozenStripInlineRow}>
            {options.map((o) => (
              <div key={o.id} className={`${styles.frozenChip} ${selectedArea === o.id ? styles.selected : ""}`}>
                {o.label}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "movement_reveal_ready") {
      return <MovementRevealReadyFrozen key={entry.id} label={entry.data?.label || MYRA_MESSAGES.handoff?.movementRevealReadyLabel || "I am good for now"} />;
    }

    if (entry.widgetType === "pinpoint") {
      const { zones = { left: [], right: [] }, selections = [] } = entry.data;
      const selectedKeys = new Set(selections.map((s) => `${s.side}:${s.zone}`));
      const pinpointChipStyle = getPinpointChipStyle(zones);
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.pinpointWrap}>
            <div className={styles.pinpointCols}>
              {["left", "right"].map((side) => {
                const sideLabel = side === "left" ? "Left side" : "Right side";
                const zoneList = zones?.[side] || [];
                return (
                  <div key={side} className={styles.pinpointCol}>
                    <div className={styles.pinpointColLabel}>{sideLabel}</div>
                    {zoneList.map((zone) => {
                      const selected = selectedKeys.has(`${side}:${zone}`);
                      return (
                        <div key={`${side}:${zone}`} className={`${styles.pinpointChip} ${styles.frozen} ${selected ? styles.selected : ""}`} style={pinpointChipStyle}>
                          {zone}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className={`${styles.ageConfirm} ${styles.ageHighlight}`}>
              <input type="checkbox" id="ageChk" checked={true} disabled />
              <label htmlFor="ageChk">I confirm I am 18 years of age or older</label>
            </div>
          </div>
        </div>
      );
    }
    if (entry.widgetType === "cpg_options" || entry.widgetType === "option_cards") {
      const { options, selectedId } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {options.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                {/* Chip (non-clickable, locked state) */}
                <div
                  className={`
            ${styles.optionCard}
            ${selectedId === o.id ? styles.selected : ""}
            ${styles.locked}
          `}
                >
                  {o.label}
                </div>

                {/* Helper text BELOW */}
                {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "yesno") {
      const { selectedAnswer } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            <div className={styles.chipPair}>
              <button className={`${styles.yesnoBtn} ${selectedAnswer === "yes" || selectedAnswer === "YES" ? styles.selected : ""}`} disabled>
                Yes, that helps
              </button>
            </div>

            <div className={styles.chipPair}>
              <button className={`${styles.yesnoBtn} ${selectedAnswer === "no" || selectedAnswer === "NO" || selectedAnswer === "NO_UNSURE" ? styles.selected : ""}`} disabled>
                No, not really
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "pre_nprs_duration") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.durationOptions} style={{ marginTop: "8px" }}>
            {CONST.DURATION_OPTIONS.map((o) => (
              <div key={o.id} className={`${styles.durationOption} ${selectedValue === o.value ? styles.selected : ""}`} style={{ pointerEvents: "none" }}>
                {o.label}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "voice_warning") {
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.voiceWarning}>
            <span className={styles.voiceWarningIcon}>🔊</span>
            {/* <p>Myra will speak out loud during movement sections</p> */}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "camera_permission") {
      const { selectedAnswer } = entry.data;
      return (
        <div className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            <div className={styles.cameraChipPair}>
              {/* Actions */}
              <button className={`${styles.cameraChip} ${selectedAnswer === "decline" ? styles.cameraselected : ""}`} disabled>
                {MYRA_MESSAGES.camera.buttonLabels.continueWithoutCamera}
              </button>

              <button className={`${styles.cameraChip} ${selectedAnswer === "allow" ? styles.cameraselected : ""}`} disabled>
                {MYRA_MESSAGES.camera.buttonLabels.allowCameraAccess}
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "mode_selection") {
      const { selectedMode } = entry.data;
      return (
        <div className={styles.inlineUi2}>
          <div>
            <button className={`${styles.modeChip} ${selectedMode === "voice" ? styles.selected : ""} ${selectedMode === "voice" ? styles.locked : ""}`} disabled>
              {MYRA_MESSAGES.modeSelection.talkLabel}
            </button>
            {/* <div className={styles.chipHelper}>{MYRA_MESSAGES.modeSelection.talkHelper}</div> */}
          </div>

          <div>
            <button className={`${styles.modeChip} ${selectedMode === "chat" ? styles.selected : ""} ${selectedMode === "voice" ? styles.locked : ""}`} disabled>
              {MYRA_MESSAGES.modeSelection.chatLabel}
            </button>
            {/* <div className={styles.chipHelper}>{MYRA_MESSAGES.modeSelection.chatHelper}</div> */}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "demo_video") {
      const { testName: demoTestName, videoUrl } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <p className={styles.paSubtitle}>
            {MYRA_MESSAGES.demoVideo.buttonLabels.frozenDemoLabel} <strong>{demoTestName}</strong>
          </p>
          <div className={styles.videoContainer}>
            <video src={videoUrl} controls playsInline preload="metadata" />
          </div>
        </div>
      );
    }

    if (entry.widgetType === "sr_cards") {
      const { options, selectedId } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {options.map((opt) => (
              <div key={opt.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${styles.locked}`}>{opt.title}</div>
                {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "rpe_options") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.RPE_OPTIONS2.map((chip) => {
              const isSelected = selectedValue === chip.value;

              return (
                <div
                  key={chip.id}
                  className={styles.chipPair}
                  style={{
                    opacity: isSelected ? 1 : 0.4,
                    pointerEvents: "none",
                  }}
                >
                  <button className={`${styles.optionCard} ${isSelected ? styles.selected : ""}`}>
                    {/* <span className={styles.chipEmojiCircle} aria-hidden="true">
                      <span className={styles.chipEmoji}>{chip.emoji}</span>
                    </span> */}

                    {chip.label}
                  </button>

                  {/* <div className={styles.chipHelper}>{chip.helper}</div> */}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "affect_options") {
      const { selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.FEEL_AFFECT_OPTIONS.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedValue === o.value ? styles.selected : ""} ${styles.locked}`}>{o.label}</div>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "hard_stop_card") {
      const { detail } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.hardStopCard}>
            <div className={styles.hardStopIcon}>🩺</div>
            <div className={styles.hardStopTitle}>We recommend in-person care</div>
            <p className={styles.hardStopText}>{detail}</p>
          </div>
        </div>
      );
    }
    if (entry.widgetType === "safety_stop_card") {
      const { detail } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.hardStopCard}>
            <div className={styles.hardStopIcon}>🩺</div>
            <div className={styles.hardStopTitle}>We recommend waiting</div>
            {detail && <p className={styles.hardStopText}>{detail}</p>}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "safety_advisory_card") {
      const { detail, choice } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div
            style={{
              background: "#fffbeb",
              border: "1px solid #f59e0b",
              borderRadius: "0.75rem",
              padding: "1.25rem",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>⚠️</div>
            <p style={{ fontSize: "0.875rem", color: "#4b5563", lineHeight: 1.5 }}>{detail}</p>
            <p style={{ fontSize: "0.8rem", color: "#9ca3af", marginTop: "0.75rem", fontStyle: "italic" }}>{choice === "leave" ? "You chose to come back later." : ""}</p>
          </div>
        </div>
      );
    }

    if (entry.widgetType === "pain_location_text") {
      const { zoneText } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <p style={{ fontSize: "13px", color: "#6b7280", textAlign: "center" }}>Selected: {zoneText}</p>
        </div>
      );
    }

    if (entry.widgetType === "feedback2") {
      const { selectedId, selectedValue } = entry.data;
      return (
        <div key={entry.id} className={styles.inlineUi2}>
          <div className={styles.feedback2Options}>
            {CONST.FEEDBACK2_OPTIONS.map((o) => {
              const isSelected = selectedId ? selectedId === o.id : selectedValue === o.value;
              return (
                <div key={o.id} className={`${styles.feedback2Btn} ${isSelected ? styles.selected : ""} ${styles.locked}`}>
                  {getFeedback2OptionLabel(o)}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (entry.widgetType === "personalize_group") {
      const { groupId, result, formData: savedFormData = {}, selectedGoals: savedGoals = [] } = entry.data;
      const group = CONST.PERSONALIZE_GROUPS.find((g) => g.id === groupId);
      if (!group) return null;

      const numberFields = group.fields.filter((f) => f.type === "number");
      const otherFields = group.fields.filter((f) => f.type !== "number");
      const wasSkipped = result === "skipped";

      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.pzGroup} style={{ pointerEvents: "none", opacity: wasSkipped ? 0.55 : 0.9 }}>
            {numberFields.length > 0 &&
              (() => {
                const rows = [];
                for (let i = 0; i < numberFields.length; i += 2) {
                  rows.push(
                    <div className={styles.pzFieldRow} key={numberFields[i].id}>
                      <div className={styles.pzField}>
                        <label className={styles.formLabel}>
                          {numberFields[i].label}
                          <span className={styles.optional}>(optional)</span>
                        </label>
                        <input type="number" className={styles.formInput} value={savedFormData[numberFields[i].id] || ""} disabled readOnly />
                      </div>
                      {i + 1 < numberFields.length && (
                        <div className={styles.pzField}>
                          <label className={styles.formLabel}>
                            {numberFields[i + 1].label}
                            <span className={styles.optional}>(optional)</span>
                          </label>
                          <input type="number" className={styles.formInput} value={savedFormData[numberFields[i + 1].id] || ""} disabled readOnly />
                        </div>
                      )}
                    </div>,
                  );
                }
                return rows;
              })()}
            {otherFields.map((field) => {
              if (field.type === "goals") {
                return (
                  <div className={styles.pzField} key={field.id}>
                    <label className={styles.formLabel}>
                      {field.label}
                      <span className={styles.optional}>((optional, pick any))</span>
                    </label>
                    <div className={styles.pzGoalWrapper}>
                      <div className={styles.pzGoalRow}>
                        {field.options.map((opt) => (
                          <div key={opt.id} className={`${styles.pzGoalItem} ${savedGoals.includes(opt.value) ? styles.selected : ""}`}>
                            <span className={styles.pzGoalLabel}>{opt.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }
              if (field.type === "options") {
                return (
                  <div className={styles.pzField} key={field.id}>
                    <label className={styles.formLabel}>{field.label}</label>
                    <div className={styles.pzOptionRow}>
                      {field.options.map((opt) => (
                        <button key={opt.id} className={`${styles.pzOptBtn} ${savedFormData[field.id] === opt.value ? styles.selected : ""}`} disabled>
                          {opt.label}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      );
    }
    if (entry.widgetType === "rcs") {
      const { score = 0, diagnosis = {} } = entry.data;
      const circumferenceFrozen = 2 * Math.PI * 65;
      return (
        <div key={entry.id} className={styles.inlineUi}>
          <div className={styles.rcsScreen} style={{ pointerEvents: "none", opacity: 0.9 }}>
            <h2 className={styles.rcsTitle}>Recovery Compass</h2>
            <p className={styles.rcsSubtitle}>The Starting Point of Your Recovery Journey</p>

            <div className={styles.rcsScoreSection}>
              <span className={styles.rcsScoreLabel}>Your Score</span>
              <div className={styles.rcsRingContainer}>
                <svg viewBox="0 0 160 160" className={styles.rcsRingSvg}>
                  <defs>
                    <linearGradient id={`scoreGradFrozen-${entry.id}`} x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#16a34a" />
                      <stop offset="100%" stopColor="#15803d" />
                    </linearGradient>
                  </defs>
                  <circle cx="80" cy="80" r="65" fill="none" stroke="#e5e7eb" strokeWidth="8" />
                  <circle cx="80" cy="80" r="65" fill="none" stroke={`url(#scoreGradFrozen-${entry.id})`} strokeWidth="8" strokeLinecap="round" strokeDasharray={circumferenceFrozen} strokeDashoffset={circumferenceFrozen * (1 - score / 100)} transform="rotate(-90 80 80)" />
                </svg>
                <span className={styles.rcsScoreNumber}>{score}</span>
              </div>
            </div>

            <p className={styles.rcsExplanation}>Your Recovery Compass Score starts at {score}, reflecting your current recovery stage. As you follow your personalized plan over the next 8 weeks, this score is designed to improve steadily, with a goal of reaching closer to 100.</p>

            <div className={styles.rcsDiagnosisCard}>
              <h3 className={styles.rcsDiagnosisHeadline}>{diagnosis.headline}</h3>
              <p className={styles.rcsDiagnosisRelief}>{diagnosis.relief}</p>
            </div>

            <div className={styles.rcsPersonalizationCard}>
              <p className={styles.rcsPersonalizationTitle}>How We've Personalized Your Plan</p>
              <div className={styles.rcsFactors}>
                <div className={styles.rcsFactor}>
                  <span>📊</span>
                  <span>Your Score</span>
                </div>
                <span className={styles.rcsPlus}>+</span>
                <div className={styles.rcsFactor}>
                  <span>📋</span>
                  <span>Your History</span>
                </div>
                <span className={styles.rcsPlus}>+</span>
                <div className={styles.rcsFactor}>
                  <span>👤</span>
                  <span>Your Info</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Fallback for unknown frozen widget types
    return null;
  }

  // ═══════════════════════════════════════════════════════════
  // STEP ROUTER
  // ═══════════════════════════════════════════════════════════

  function renderScreen() {
    switch (currentStep) {
      case "intro":
        return (
          <IntroScreen
            pushToHistory={pushToHistory}
            showMyraMessage={showMyraMessage}
            setIntroProminent={setIntroProminent}
            setPlaceholderText={setPlaceholderText}
            introAdvanceRef={introAdvanceRef}
            introCtaHandlerRef={introCtaHandlerRef}
            showIntroCtas={showIntroCtas}
            detectedArea={detectedArea}
            qaRef={qaRef}
            introProminent={introProminent}
            setQaOpen={setQaOpen}
            qaStripIdsRef={qaStripIdsRef}
            scrollToBottom={scrollToBottom}
            externalAction={introExternalAction}
            onContinue={(area) => {
              setPlaceholderText(MYRA_MESSAGES.shell.inputPlaceholderAskMyra);
              setIntroProminent(false);
              if (area) setDetectedArea(area);
              // if (displayMode === "embedded" && onStartAssessment) {
              //   // Phase 1: signal landing page to fade out — do NOT advance yet
              //   onStartAssessment();
              // } else {
              // Fullscreen (direct entry): advance immediately
              if (!window.trSessionId && AnalyticsService) AnalyticsService.startSession();
              localStorage.setItem("startedSelf", "1");
              if (window.gtag) window.gtag("event", "conversion", { send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD", value: 1.0, currency: "USD" });
              setCurrentStep("problem_area");
              // }
            }}
            updateAssessmentData={updateAssessmentData}
            assessmentData={assessmentData}
            setHideContent={setHideContent}
            userVariant={userVariant}
            isComeFromGoogle={isComeFromGoogle}
            isUserCameBackAgain={isUserCameBackAgain}
            handleHomeVideoClicked={handleHomeVideoClicked}
            handleWhoIsMyraClick={handleWhoIsMyraClick}
            onInlineChat={handleInlineChat}
            setShowIntroCtas={setShowIntroCtas}
          />
        );

      case "problem_area":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} paCommandRef={paCommandRef} detectedArea={detectedArea} scrollToBottom={scrollToBottom} phase={window?.chipGotCLicked ? "pain_location" : "problem_area"} persistAndNavigate={persistAndNavigate} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "pain_location":
        return <PainLocationScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} phase="pain_location" persistAndNavigate={persistAndNavigate} onContinue={(fields) => persistAndNavigate(fields, "cpg_questions")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "safety_screening":
        return <SafetyScreeningScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "test1_demo")} onHardStop={(source) => persistAndNavigate({ safetyScreenResult: "FLAGGED", hardStopSource: source }, "hard_stop")} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} />;

      case "cpg_questions":
        return <CPGQuestionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => (nextStep === "nprs_symptoms" ? runRecoveryPlanHandoff(fields) : persistAndNavigate(fields, nextStep))} onHardStop={(source) => persistAndNavigate({ hardStopSource: source }, "hard_stop")} />;

      case "subtype_questioning":
        return <SubtypeQuestionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} detectedTrigger={detectedTrigger} onContinue={(fields, nextStep) => (nextStep === "nprs_symptoms" ? runRecoveryPlanHandoff(fields) : persistAndNavigate(fields, nextStep))} />;

      case "self_assessment":
        return <SelfAssessmentQ2Screen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} showQuestionNuggetMessage={showQuestionNuggetMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => runRecoveryPlanHandoff(fields)} />;

      case "nprs_symptoms":
        return <PreNPRSScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "safety_screening")} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} />;

      case "test1_demo":
        return <TestIntroScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "movement_test_1")} showQuestionNuggetMessage={showQuestionNuggetMessage} setPlaceholderText={setPlaceholderText} />;

      case "mode_selection":
        return <ModeSelectionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "movement_test_1")} showMyraMessage={showMyraMessage} />;

      case "camera_permission":
        return <CameraPermissionScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextstep) => persistAndNavigate(fields, nextstep)} />;

      case "movement_test_1":
        return <MovementTest1Screen assessmentData={assessmentData} updateAssessmentData={updateAssessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => persistAndNavigate(fields, nextStep)} onHardStop={(source) => persistAndNavigate({ hardStopSource: source }, "hard_stop")} chatBucketTest={chatBucketTest} />;

      case "self_report_rom":
        return <SelfReportROMScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "self_report_tempo")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "self_report_tempo":
        return <SelfReportTempoScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "rpe")} onHardStop={() => persistAndNavigate({ hardStopSource: "couldnt_finish" }, "hard_stop")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "rpe":
        return <RPEScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "feel_affect")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "feel_affect":
        return <FeelAffectScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields, nextStep) => persistAndNavigate(fields, nextStep)} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "feedback2":
        return <Feedback2Screen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "personalize")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "personalize":
        return <PersonalizeScreen assessmentData={assessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "plan")} setMode={setMode} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "recovery_score":
        return <RecoveryScoreScreen assessmentData={assessmentData} updateAssessmentData={updateAssessmentData} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} onContinue={(fields) => persistAndNavigate(fields, "plan")} showQuestionNuggetMessage={showQuestionNuggetMessage} />;

      case "plan":
        return (
          <PlanScreen
            assessmentData={assessmentData}
            updateAssessmentData={updateAssessmentData}
            qaRef={qaRef}
            onOpenQnA={() => {
              // window.audioPlayer?.unlockAudioForChat?.();
              setQaOpen(true);
            }}
            pushToHistory={pushToHistory}
            showMyraMessage={showMyraMessage}
            scrollToBottom={scrollToBottom}
            showQuestionNuggetMessage={showQuestionNuggetMessage}
            scrollToPreviousEcho={scrollToPreviousEcho}
          />
        );

      case "hard_stop":
        return <HardStopScreen source={assessmentData.hardStopSource} pushToHistory={pushToHistory} showMyraMessage={showMyraMessage} scrollToBottom={scrollToBottom} />;

      default:
        return (
          <div className={styles.inlineUi}>
            <p style={{ color: "var(--gray-500)", textAlign: "center" }}>Unknown step: {currentStep}</p>
          </div>
        );
    }
  }

  // ═══════════════════════════════════════════════════════════
  // RENDER — APP SHELL
  // ═══════════════════════════════════════════════════════════

  const handleVoiceClicked = () => {
    setMode("voice");
    MyraInteraction?.switchMode?.("voice", true);
    if (window?.mayraCode) {
      window?.mayraCode.handlePickVoice();
    }
  };
  const handleChatClicked = () => {
    setMode("chat");
    MyraInteraction?.switchMode?.("chat", true);
    if (window?.mayraCode) {
      window?.mayraCode.handlePickChat();
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleInputSubmit();
    }
  };

  useEffect(() => {
    if (mode !== "voice") return;
    setInputText(voiceTranscript);
  }, [voiceTranscript, mode]);

  return (
    <>
      <div className={`${styles.appShell}${displayMode === "embedded" ? ` ${styles.embedded}` : ""}`}>
        {/* Header */}
        <div className={styles.mainHeader}>
          <CustomHeader
            setShowMemberBlockScreen={() => {}}
            onIntroAction={(type) => {
              setIntroExternalAction({ type });
            }}
            isComeFromGoogle={isComeFromGoogle}
            hideContent={hideContent}
            handleHomeVideoClicked={handleHomeVideoClicked}
            handleWhoIsMyraClick={handleWhoIsMyraClick}
          />
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <div className={styles.headerAvatar}>M</div>
              <div className={styles.headerInfo}>
                <h1>{MYRA_MESSAGES.shell.myraName}</h1>
                <span>{MYRA_MESSAGES.shell.myraRole}</span>
              </div>
            </div>
            {!qaOpen && (
              <div className={styles.modeToggle}>
                <button className={`${styles.modeBtn} ${mode === "chat" ? styles.active : ""}`} onClick={handleChatClicked}>
                  {CHAT_ICON_SVG}
                  {MYRA_MESSAGES.shell.modeChatLabel}
                </button>
                <button className={`${styles.modeBtn} ${mode === "voice" ? styles.active : ""}`} onClick={handleVoiceClicked}>
                  {VOICE_ICON_SVG}
                  {MYRA_MESSAGES.shell.modeVoiceLabel}
                </button>
              </div>
            )}
            {/* <button
          className={styles.myraFab}
          onClick={() => {
            window.audioPlayer?.unlockAudioForChat?.();
            setQaOpen(true);
          }}
          aria-label="Chat with Myra"
        >
          Myra
        </button> */}
            {currentStep !== "hard_stop" && currentStep !== "plan" && (
              <button className={styles.headerClose} onClick={() => setShowExitHandler(true)} title={MYRA_MESSAGES.shell.exitAssessmentTitle}>
                ×
              </button>
            )}
          </div>
        </div>

        {/* Progress */}
        {currentStep !== "intro" && (
          <>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: `${progressPercent}%` }} />
              <span className={styles.progressLabel}>{progressPercent}% Done</span>
            </div>
            {/* <div className={styles.stepLabel}>{stepLabel}</div> */}
          </>
        )}

        {/* Chat Area */}
        <div className={styles.chatArea} ref={chatAreaRef} style={{ overflowAnchor: "none" }}>
          {currentStep === "intro" && showIntroCtas && (
            <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
              <div className={styles.introCtaRow}>
                {INTRO_CTAS.map((cta) => (
                  <button
                    key={cta.id}
                    className={`${cta.type === "start" ? styles.introCtaBtnStart : styles.introCtaBtn} ${cta.id === "assessment" ? styles.introAssessmentLink : ""} ${ctaUsed.has(cta.id) ? styles.introCtaBtnUsed : ""}`}
                    onClick={() => {
                      setCtaUsed((prev) => new Set(prev).add(cta.id));
                      introCtaHandlerRef.current?.(cta.id);
                    }}
                    disabled = {!introProminent || ctaUsed.has(cta.id)}
                  >
                    {cta.label}
                  </button>
                ))}
              </div>
            </div>
          )}
          {conversationHistory.map((entry) => renderHistoryEntry(entry))}
          {typingVisible && (
            <div className={styles.typingRow}>
              <div className={styles.msgAvatar}>M</div>
              <div className={styles.typingDots}>
                <span />
                <span />
                <span />
              </div>
            </div>
          )}
          {renderScreen()}
        </div>
        {/* <div className={styles.chipStrip} id="chipStrip">
        <div className={styles.chipStripLabel}>{MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
        <div className={styles.chipStripRow} id="chipStripRow">
          <button className={styles.LandingChip} data-area="LBP">
            My lower back
          </button>
          <button className={styles.LandingChip} data-area="HIP">
            My hip
          </button>
          <button className={styles.LandingChip} data-area="THIGH">
            My thigh
          </button>
          <button className={styles.LandingChip} data-area="KNEE">
            My knee
          </button>
        </div>
      </div> */}
        {!window.showChips && (
          <div className={styles.problemAreaChipGroup} style={{ background: "white" }}>
            <div className={`${styles.problemAreaChipLabel} ${styles.whereHurtsLabel}`}>{MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
            <div className={styles.problemAreaChipRow}>
              {PROBLEM_AREA_OPTIONS.map((option) => (
                <button key={option.id} type="button" className={styles.problemAreaChip} onClick={() => handleChipClick(option)} disabled={!introProminent}>
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        )}
        {showVideoOverlay && (
          <div
            className={styles.videoOverlay}
            onClick={(e) => {
              // Close only if clicking outside the video container
              if (e.target === e.currentTarget) {
                setShowVideoOverlay(false);
                if (heroVideoRef.current) {
                  heroVideoRef.current.pause();
                }
              }
            }}
          >
            <div className={styles.videoOverlayContent}>
              <button
                className={styles.videoOverlayClose}
                onClick={() => {
                  setShowVideoOverlay(false);
                  if (heroVideoRef.current) {
                    heroVideoRef.current.pause();
                  }
                }}
                aria-label="Close video"
              >
                ×
              </button>

              <div className={styles.videoContainerOverlay}>
                <video
                  ref={heroVideoRef}
                  src={CONST.HOME_VIDEO_2}
                  autoPlay
                  controls
                  playsInline
                  preload="metadata"
                  onEnded={() => {
                    // Optionally auto-close or show CTA after video ends
                    // setShowVideoOverlay(false);
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Input Bar — never disabled, never hidden */}
        <div className={styles.inputBarContainer}>
          <div className={styles.inputBar} style={{ position: "relative" }}>
            {mode === "voice" && voiceStatus && <div className={styles.statusBubble}>{voiceStatus}</div>}

            <div className={styles.inputChat}>
              {mode === "voice" ? (
                <>
                  <textarea type={inputType} className={introProminent ? styles.inputFieldIntroProminent : styles.inputField} value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholderText} autoComplete="off" rows={inputText.split("\n").length > 2 ? 3 : 2} style={{ resize: "none" }} />
                  <button className={styles.sendBtn} disabled={!inputText.trim()} onClick={handleInputSubmit}>
                    {SEND_ICON}
                  </button>
                </>
              ) : (
                <>
                  <textarea type={inputType} className={introProminent ? styles.inputFieldIntroProminent : styles.inputField} value={inputText} onChange={(e) => setInputText(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholderText} autoComplete="off" rows={inputText.split("\n").length > 2 ? 3 : 2} style={{ resize: "none" }} />
                  <button className={styles.sendBtn} disabled={!inputText.trim()} onClick={handleInputSubmit}>
                    {SEND_ICON}
                  </button>
                </>
              )}
            </div>
          </div>

          <div ref={scrollSentinelRef} style={{ height: 1, flexShrink: 0, overflowAnchor: "auto" }} />

          <div className={`${styles.cardSurround} ${hideContent ? styles.cardSurroundHidden : ""}`}>
            <div className={styles2.cardFrame}>
              <div className={styles2.cardFooter}>
                <p className={styles2.disclaimerText}>StartFreePT provides educational guidance based on your input. It is not a substitute for medical advice, diagnosis, or treatment.</p>
              </div>
            </div>
            <p className={styles2.copyrightText}>&copy; 2026 Virdio Health. All rights reserved.</p>
          </div>
        </div>
        {/* QnA Overlay */}
        <QnAOverlay ref={qaRef} isOpen={qaOpen} onClose={handleQaOverlayClose} screenName={currentStep} screenPayload={screenPayload} setQaOpen={setQaOpen} setTypingVisible={setTypingVisible} />

        {/* Exit Handler */}
        {showExitHandler && (
          <ExitHandler
            currentStep={exitCurrentStep}
            assessmentData={assessmentData}
            onClose={() => setShowExitHandler(false)}
            onOpenQnA={(question, answer, source) => {
              setShowExitHandler(false);
              qaRef.current?.addExchange?.(question, answer, source);
              window.audioPlayer?.unlockAudioForChat?.();
              setQaOpen(true);
            }}
          />
        )}

        {/* Inactivity Modal */}
        {showInactivityModal && (
          <InactivityModal
            onResume={() => setShowInactivityModal(false)}
            onExit={() => {
              setShowInactivityModal(false);
              setShowExitHandler(true);
            }}
          />
        )}
      </div>
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN: INTRO (New)
// Myra greeting → CTA buttons → advance to Problem Area.
// Inline Q&A (Pattern A) lives in local state, collapses to strips on advance.
// ════════════════════════════════════════════════════════════════

function IntroScreen({ pushToHistory, introProminent, showIntroCtas, showMyraMessage, setIntroProminent, setPlaceholderText, introAdvanceRef, introCtaHandlerRef, detectedArea, qaRef, setQaOpen, qaStripIdsRef, scrollToBottom, externalAction, onContinue, updateAssessmentData, assessmentData, setHideContent, userVariant, isComeFromGoogle, isUserCameBackAgain, handleHomeVideoClicked, handleWhoIsMyraClick, onInlineChat, setShowIntroCtas, setExitCurrentStep }) {
  const [phase, setPhase] = useState("loading");
  const [ctaUsed, setCtaUsed] = useState(new Set());
  const [inlineQa, setInlineQa] = useState([]);
  const [ctaTyping, setCtaTyping] = useState(false);
  const [openAccIdx, setOpenAccIdx] = useState(-1);
  const introQaItemsRef = useRef([]);
  const [problemArea, setProblemArea] = useState(null);
  const [showAssessmentSteps, setShowAssessmentSteps] = useState(false);
  console.log("assessmentData : ", assessmentData);
  MyraInteraction.onScreenEnter("intro");

  // ── Greeting sequence ──
  useEffect(() => {
    let cancelled = false;
    async function greet() {
      await _delay(600);
      if (cancelled) return;
      await showMyraMessage(MYRA_MESSAGES.intro?.welcome || "Hi, I'm Myra. I'll help you build a personalized recovery plan for your muscle or joint pain — guided by physical therapy principles.", 1200);
      if (cancelled) return;
      await _delay(400);
      await showMyraMessage(MYRA_MESSAGES.intro?.readyPrompt || "Whenever you're ready, tap below to get started — or, if you already know where it hurts, you can pick from the options.", 900);
      if (cancelled) return;
      setIntroProminent(true);
      setPhase("ready");
    }
    greet();
    return () => {
      cancelled = true;
    };
  }, []);

  // ── Register advance callback for shell input routing ──
  useEffect(() => {
    introAdvanceRef.current = (_text, area) => handleAdvance(area);
    return () => {
      introAdvanceRef.current = null;
    };
  }, []);

  useEffect(() => {
    introCtaHandlerRef.current = (ctaId) => handleCta(ctaId);
    return () => {
      introCtaHandlerRef.current = null;
    };
  }, []);

  // ── Set flow context for Myra backend during intro ──
  useEffect(() => {
    window.currentCommandsAudio = {
      SHOW_VIDEO_INFO: (value, speech, intent) => {
        handleHomeVideoClicked();
      },
      SHOW_ASSESSMENT_INFO: (value, speech, intent) => {
        setShowAssessmentSteps(true);
      },
      SHOW_MYRA_INFO: (value, speech, intent) => {
        handleWhoIsMyraClick();
      },
    };
    if (typeof window !== "undefined") {
      window.currentFlow = "flow_landing_page";
      if (VoiceService) {
        VoiceService._currentFlow = "flow_landing_page";
      }
    }
  }, []);

  // ── CTA handler (async for typing pacing) ──
  async function handleCta(ctaId) {
    // VIDEO BUTTON: No state change, video is always visible
    if (ctaId === "video") {
      // Track video engagement for analytics
      if (AnalyticsService) {
        AnalyticsService.trackStep({
          event: "intro_video_opened",
          timestamp: new Date().toISOString(),
        });
      }
      return;
    }

    if (ctaId === "start") {
      const trackingFields = {
        variant: userVariant,
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
      };

      if (!window.trSessionId) {
        AnalyticsService.startSession(trackingFields);
      }
      // Google Ads conversion tracking
      try {
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD",
          });
        }
      } catch (e) {
        console.warn(e);
      }

      const updatedData = {
        started_assessment: true,
        myraInteractionMode: MyraInteraction.getMode() || "chat",
        isComeFromGoogle: isComeFromGoogle,
        isUserCameBackAgain: isUserCameBackAgain,
        variant: userVariant,
        analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
        EngagedOnLanding: window.EngagedOnLanding || false,
        clicked_landing_cta: false,
        clicked_start_assessment: true,
        session_last_update: new Date().toISOString(),
      };

      // localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);

      updateAssessmentData(updatedData);
      await new Promise((resolve) => setTimeout(resolve, 0));

      if (setHideContent) {
        setHideContent(true);
      }
      if (window.doKeepVideoPlay) window.doKeepVideoPlay();
      window.initFromUserGesture();
      if (window.audioPlayer?.ctx?.state === "suspended") {
        window.audioPlayer.ctx.resume();
      }
      if (window.preloadAllAudios) {
        window.preloadAllAudios();
      }
      if (window.videoUnlockPlay) {
        window.videoUnlockPlay();
      }
      let message = "Start with the questions for self assessment.";
      if (typeof onInlineChat === "function") {
        pushToHistory({
          type: "user",
          text: message,
          id: nextId(),
        });
        setShowIntroCtas(true);
        window.showChips = true;
        window.hideNavbarBtm = true;
        await showMyraMessage("To get started, where did your pain initially start, your lower back, hip, thigh, or knee?", 900);
        // await onInlineChat(message);
      }

      // handleAdvance(null);
      return;
    }
    setCtaUsed((prev) => new Set(prev).add(ctaId));

    // M1: Collapse any existing inline Q&A to strips before showing new response
    if (introQaItemsRef.current.length > 0) {
      const strips = [];
      introQaItemsRef.current.forEach((item) => {
        const exId = qaRef.current?.addExchange?.(item.question, item.answer, "intro_cta");
        const stripId = nextId();
        if (exId) qaStripIdsRef.current.add(exId);
        strips.push({ type: "qa-strip", id: stripId, qaId: exId || stripId, question: item.question });
      });
      pushToHistory(...strips);
      introQaItemsRef.current = [];
      setInlineQa([]);
    }

    let question, answer, type;
    if (ctaId === "assessment") {
      question = "What's the Assessment?";
      answer = MYRA_MESSAGES.intro?.whatsAssessment || "Here's what we'll do together — about 10 minutes total. Tap any step to learn more.";
      type = "assessment";
    } else if (ctaId === "myra") {
      question = "Who is Myra?";
      answer = MYRA_MESSAGES.intro?.whoIsMyra || "I'm Myra, your recovery coach from Virdio Health. I'm powered by AI — not a human — but I'm designed to guide you through understanding and recovering from muscle and joint pain. I work alongside doctors of physical therapy and evidence-based research to help you do recovery at home, under your own guidance. I'm not a doctor, physical therapist, or clinician.";
      type = "myra";
    } else {
      return;
    }

    // M2: Show user bubble immediately, typing dots, then Myra response
    const qaItem = { id: nextId(), question, answer, type };
    setInlineQa([{ ...qaItem, answer: null }]);
    setCtaTyping(true);
    await _delay(400);
    await _delay(1000);
    setCtaTyping(false);
    setInlineQa([qaItem]);
    introQaItemsRef.current.push(qaItem);
  }

  // ── Advance: collapse inline Q&A to strips, proceed ──
  function handleAdvance(preselectedArea) {
    const strips = [];
    introQaItemsRef.current.forEach((item) => {
      const exId = qaRef.current?.addExchange?.(item.question, item.answer, "intro_cta");
      const stripId = nextId();
      if (exId) qaStripIdsRef.current.add(exId);
      strips.push({ type: "qa-strip", id: stripId, qaId: exId || stripId, question: item.question });
    });
    pushToHistory(...strips, { type: "user", text: MYRA_MESSAGES.intro.ctaLabels.startMyAssessment, id: nextId() });
    onContinue(preselectedArea || detectedArea || null);
  }

  useEffect(() => {
    scrollToBottom("smooth");
  }, [inlineQa, ctaTyping, scrollToBottom]);

  useEffect(() => {
    if (!externalAction?.type) return;
    if (externalAction.type === "video" || externalAction.type === "myra") {
      handleCta(externalAction.type);
    }
  }, [externalAction]);
  const PROBLEM_AREA_OPTIONS = [
    { id: "LBP", label: "My lower back" },
    { id: "HIP", label: "My hip" },
    { id: "THIGH", label: "My thigh" },
    { id: "KNEE", label: "My knee" },
  ];

  const handleChipClick = async (option) => {
    window.showChips = true;
    window.hideNavbarBtm = true;
    const selectedArea = option?.id;

    // ── Spec 1: Variant B (chip_conversational) ──
    // When the user is in the chip_conversational variant, tapping a chip
    // fires a synthetic chat message into the embedded card chat instead
    // of advancing the GSA. Variant string is set elsewhere by the
    // variant-selection logic (random / daily / etc.) and lands in
    // localStorage.variant or the ?variant=… URL param.
    // "chip_conversational" is a placeholder — confirm final value with
    // Arjun before launch.
    if (userVariant === "chip_conversational") {
      const phrasePerArea = {
        LBP: "My lower back hurts",
        HIP: "My hip hurts",
        THIGH: "My thigh hurts",
        KNEE: "My knee hurts",
      };
      const message = phrasePerArea[selectedArea];
      if (message && typeof onInlineChat === "function") {
        pushToHistory({ type: "user", text: message, id: nextId() });
        await onInlineChat(message);
      }
      return;
    }

    // ── Variant A (current chip behaviour, default) ──
    console.log("updateAssessmentData", updateAssessmentData);
    window.chipGotCLicked = true;
    window.problemArea = selectedArea;

    // Update local state
    setProblemArea(selectedArea);

    // Create the updates object (not the full assessmentData)
    const updates = {
      problemArea: selectedArea,
      selected_problem_area: CONST.CLINICAL_PATHS?.[selectedArea]?.name || selectedArea,
      EngagedOnLanding: window.EngagedOnLanding || false,
    };

    console.log("PROBLEM AREA SELECTED:", selectedArea);
    console.log("Updates to apply:", updates);

    // Update assessment data with just the updates
    updateAssessmentData(updates);
    await new Promise((resolve) => setTimeout(resolve, 0));
    setTimeout(() => {
      if (onContinue) {
        onContinue(selectedArea);
      }
    }, 10);
  };
  if (phase === "loading") return null;

  const hasResponded = inlineQa.some((qa) => qa.answer !== null);
  const steps = getAssessmentSteps();

  return (
    <>
      {/* Inline Q&A from CTA taps (Pattern A) */}
      {inlineQa.map((qa) => (
        <React.Fragment key={qa.id}>
          <div className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>{qa.question}</div>
          </div>
          {qa.answer && (
            <>
              <div className={styles.msgRowMyra}>
                <div className={styles.msgAvatar}>M</div>
                <div className={styles.msgBubbleMyra}>{qa.answer}</div>
              </div>
              {qa.type === "assessment" && (
                <div className={styles.inlineUi}>
                  <div className={styles.accordion}>
                    {steps.map((s, i) => (
                      <div key={i} className={`${styles.accordionItem} ${openAccIdx === i ? styles.open : ""}`} onClick={() => setOpenAccIdx(openAccIdx === i ? -1 : i)}>
                        <div className={styles.accordionHeader}>
                          <span className={styles.accordionStep}>{i + 1}</span>
                          <span className={styles.accordionTitle}>{s.title}</span>
                          {CHEVRON_DOWN}
                        </div>
                        <div className={styles.accordionBody}>
                          <p>{s.body}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </React.Fragment>
      ))}

      {/* M2: Typing dots while CTA response is loading */}
      {ctaTyping && (
        <div className={styles.typingRow}>
          <div className={styles.msgAvatar}>M</div>
          <div className={styles.typingDots}>
            <span />
            <span />
            <span />
          </div>
        </div>
      )}

      {/* CTA buttons */}
      <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
        <div className={styles.introCtaRow}>
          {/* {INTRO_CTAS.filter((c) => (hasResponded ? c.type === "info" : true)).map((cta) => ( */}
          {!showIntroCtas &&
            INTRO_CTAS.map((cta) => (
              <button key={cta.id} className={`${cta.type === "start" ? styles.introCtaBtnStart : styles.introCtaBtn} ${cta.id === "assessment" ? styles.introAssessmentLink : ""} ${ctaUsed.has(cta.id) ? styles.introCtaBtnUsed : ""}`} onClick={() => handleCta(cta.id)} disabled={!introProminent}>
                {cta.label}
              </button>
            ))}
        </div>
      </div>
      {showAssessmentSteps && (
        <>
          <div className={styles.msgRowUser}>
            <div className={styles.msgBubbleUser}>What's the Assessment?</div>
          </div>
          <div className={styles.msgRowMyra}>
            <div className={styles.msgAvatar}>M</div>
            <div className={styles.msgBubbleMyra}>{MYRA_MESSAGES.intro?.whatsAssessment}</div>
          </div>
          <div className={styles.inlineUi}>
            <div className={styles.accordion}>
              {steps.map((s, i) => (
                <div key={i} className={`${styles.accordionItem} ${openAccIdx === i ? styles.open : ""}`} onClick={() => setOpenAccIdx(openAccIdx === i ? -1 : i)}>
                  <div className={styles.accordionHeader}>
                    <span className={styles.accordionStep}>{i + 1}</span>
                    <span className={styles.accordionTitle}>{s.title}</span>
                    {CHEVRON_DOWN}
                  </div>
                  <div className={styles.accordionBody}>
                    <p>{s.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {/* Floating "Let's get started" after CTA response */}
      {/* {hasResponded && (
        <div className={`${styles.inlineUi} ${styles.introCtaInlineUi}`}>
          <div className={styles.introCtaRow}>
            <button className={styles.introCtaBtnStartFloat} onClick={() => handleAdvance(null)}>
              Start My Assessment
            </button>
          </div>
        </div>
      )} */}
      {/* <div className={styles.problemAreaChipGroup}>
        <div className={styles.problemAreaChipLabel}>{MYRA_MESSAGES.problemArea.whereHurtsLabel}</div>
        <div className={styles.problemAreaChipRow}>
          {PROBLEM_AREA_OPTIONS.map((option) => (
            <button key={option.id} type="button" className={styles.problemAreaChip} onClick={() => handleChipClick(option)}>
              {option.label}
            </button>
          ))}
        </div>
      </div> */}
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 5: CPG QUESTION
// LBP: 2-step branching based on isLegPain.
//   Leg pain → CPG_OPTIONS_LEG → subtype Q1
//   Back only → CPG_OPTIONS_BACK → cpgToSubtype() → Pre-NPRS
// HKT: CLINICAL_PATHS[area].cpgQuestion
//   routesTo "direct" → Pre-NPRS (with Thigh Neural zone routing)
//   routesTo "subtypeQuestion" → Subtype Question
// ════════════════════════════════════════════════════════════════

function CPGQuestionScreen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, onContinue }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const problemArea = assessmentData.problemArea;
  const isLBP = problemArea === "LBP";
  const isLegPain = assessmentData.isLegPain;
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  window.notOpenQNA = false;

  let prompt, nugget, options;
  if (isLBP) {
    options = isLegPain ? CONST.CPG_OPTIONS_LEG : CONST.CPG_OPTIONS_BACK;
    prompt = isLegPain ? MYRA_MESSAGES.cpg?.lbpLegQuestion : MYRA_MESSAGES.cpg?.lbpBackQuestion;
    nugget = isLegPain ? MYRA_MESSAGES.cpg?.lbpLegNugget : MYRA_MESSAGES.cpg?.lbpBackNugget;
  } else {
    const cpgQ = CONST.CLINICAL_PATHS[problemArea].cpgQuestion;
    prompt = MYRA_MESSAGES.cpg?.questionByArea?.[problemArea] || cpgQ.prompt;
    nugget = MYRA_MESSAGES.cpg?.nuggetByArea?.[problemArea];
    options = cpgQ.options;
  }

  useEffect(() => {
    let cancelled = false;
    async function init() {
      const setup = MYRA_MESSAGES.cpg?.setupByArea?.[problemArea];
      if (setup) await showMyraMessage(setup, 800);
      await showQuestionNuggetMessage(prompt, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    window.currentFlow = "flow_cpg";
    VoiceService._currentFlow = "flow_cpg";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_cpg");
    }
  }, []);

  const handleSelect = useCallback(
    async (id) => {
      if (locked) return;
      setSelectedId(id);
      setLocked(true);

      const opt = options.find((o) => o.id === id);
      if (!opt) return;

      pushToHistory({ type: "frozen-widget", widgetType: "cpg_options", id: nextId(), data: { options, selectedId: id } }, { type: "user", text: opt.label, id: nextId() });

      const postTap = MYRA_MESSAGES.cpg?.postTap?.[id];
      if (postTap) await showMyraMessage(postTap, 900);

      if (isLBP) {
        onContinue(
          {
            cpgValue: opt.value,
            cpgForBackend: opt.value,
            cpgCategory: opt.value,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "subtype_questioning",
        );
        return;
      }

      if (opt.routesTo === "direct") {
        let subtype = opt.directSubtype;

        if (problemArea === "THIGH" && opt.value === "THIGH_NEURAL_INVOLVEMENT") {
          const zones = assessmentData.selectedZones || [];
          const zoneString = zones.join(" ").toLowerCase();
          const singleZone = zones.length === 1;
          if (singleZone && (zoneString.includes("front") || zoneString.includes("anterior"))) {
            subtype = "QUADRICEPS_LOADING_IMPACT_INTOLERANCE";
          } else if (singleZone && (zoneString.includes("outer") || zoneString.includes("lateral"))) {
            subtype = "ITB_FRICTION_SYNDROME";
          } else {
            subtype = "HAMSTRING_LOADING_LENGTHENING_DEFICIT";
          }
        }

        onContinue(
          {
            cpgValue: opt.cpgForBackend,
            cpgForBackend: opt.cpgForBackend,
            cpgOption: opt,
            cpgCategory: opt.value,
            probableSubtype: subtype,
            skipSubtypeQuestion: true,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "nprs_symptoms",
        );
        return;
      }

      const path = CONST.CLINICAL_PATHS[problemArea];
      const subtypeQuestion = path.subtypeQuestions?.[opt.subtypeQuestionIndex || 0];
      const zoneMap = problemArea === "HIP" && opt.id === "hip-cpg-mobility" ? CONST.HIP_MOB_Q1_ZONE_TO_OPTION : problemArea === "THIGH" ? CONST.THIGH_Q1_ZONE_TO_OPTION : null;
      const q1Decision = zoneMap && subtypeQuestion ? CONST.planSubtypeQ1Decision(assessmentData.pinpointSelections, zoneMap, subtypeQuestion.options) : { mode: "plain" };

      if (q1Decision.mode === "skip" && q1Decision.option) {
        let cpgForBackend = opt.cpgForBackend;
        if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[q1Decision.option.value]) {
          cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][q1Decision.option.value];
        }
        onContinue(
          {
            cpgValue: opt.cpgForBackend,
            cpgForBackend,
            cpgOption: opt,
            cpgCategory: opt.value,
            probableSubtype: q1Decision.option.value,
            subtypeQuestions: { q1: q1Decision.option },
            skipSubtypeQuestion: true,
            q1PostTapFired: false,
            completed_cpg_question_screen: true,
          },
          "nprs_symptoms",
        );
        return;
      }

      onContinue(
        {
          cpgValue: opt.cpgForBackend,
          cpgForBackend: opt.cpgForBackend,
          cpgOption: opt,
          cpgCategory: opt.value,
          subtypeQuestionIndex: opt.subtypeQuestionIndex,
          skipSubtypeQuestion: false,
          q1DecisionMode: q1Decision.mode,
          q1ReferencePhrase: q1Decision.referencePhrase || null,
          completed_cpg_question_screen: true,
        },
        "subtype_questioning",
      );
    },
    [locked, options, isLBP, isLegPain, problemArea, assessmentData.selectedZones, assessmentData.pinpointSelections],
  );

  const validateAndSelect = useCallback(() => {
    if (!selectedId && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please make your selection before we can move to the next screen");
      return;
    }
  }, [selectedId, locked]);

  const CPG_VOICE_MAP = {
    LBP: isLegPain
      ? {
          LEG_SHARP_SHOOTING: "cpg-radiating",
          LEG_DULL_ACHE: "cpg-referred",
          REFERRED_ACHE: "cpg-referred",
          BOTH_NOT_SURE: "cpg-referred",
          STIFFNESS_BLOCK: "cpg-referred",
          WEAKNESS_GIVE_OUT: "cpg-referred",
          MUSCULAR_ACHE: "cpg-referred",
          BURNING_TINGLING: "cpg-radiating",
          PINCHING_CATCHING: "cpg-radiating",
        }
      : {
          BACK_DEEP_STIFF: "cpg-mobility",
          BACK_INSTABILITY: "cpg-coordination",
          BOTH_NOT_SURE: "cpg-coordination",
          LEG_DULL_ACHE: "cpg-mobility",
          REFERRED_ACHE: "cpg-mobility",
          STIFFNESS_BLOCK: "cpg-mobility",
          WEAKNESS_GIVE_OUT: "cpg-coordination",
          MUSCULAR_ACHE: "cpg-mobility",
          BURNING_TINGLING: "cpg-mobility",
          PINCHING_CATCHING: "cpg-coordination",
        },
    HIP: {
      STIFFNESS_BLOCK: "hip-cpg-mobility",
      WEAKNESS_GIVE_OUT: "hip-cpg-power",
      PINCHING_CATCHING: "hip-cpg-motor",
      REFERRED_ACHE: "hip-cpg-mobility",
      MUSCULAR_ACHE: "hip-cpg-mobility",
      BURNING_TINGLING: "hip-cpg-motor",
      BOTH_NOT_SURE: "hip-cpg-mobility",
    },
    THIGH: {
      MUSCULAR_ACHE: "thigh-cpg-muscular",
      BURNING_TINGLING: "thigh-cpg-neural",
      REFERRED_ACHE: "thigh-cpg-referred",
      BACK_DEEP_STIFF: "thigh-cpg-referred",
      STIFFNESS_BLOCK: "thigh-cpg-muscular",
      WEAKNESS_GIVE_OUT: "thigh-cpg-muscular",
      PINCHING_CATCHING: "thigh-cpg-neural",
      BOTH_NOT_SURE: "thigh-cpg-muscular",
    },
    KNEE: {
      AROUND_KNEECAP: "knee-cpg-pfp",
      JOINT_STIFF_UNSTABLE: "knee-cpg-mobility",
      OUTER_LATERAL: "knee-cpg-lateral",
      BACK_OF_KNEE: "knee-cpg-posterior",
      INNER_MEDIAL: "knee-cpg-medial",
      REFERRED_ACHE: "knee-cpg-mobility",
      MUSCULAR_ACHE: "knee-cpg-mobility",
      BURNING_TINGLING: "knee-cpg-lateral",
      STIFFNESS_BLOCK: "knee-cpg-mobility",
      WEAKNESS_GIVE_OUT: "knee-cpg-mobility",
      BOTH_NOT_SURE: "knee-cpg-mobility",
    },
  };

  useScreenVoice({
    screenName: "cpg_questions",
    flowName: "flow_cpg",
    payloadKey: "cpg_questions",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value) => {
        if (value === "continue_command") validateAndSelect();
      },
      MOVE_ON: () => validateAndSelect(),
      SELECT_CPG: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        const optionId = CPG_VOICE_MAP?.[problemArea]?.[actionValue];
        if (!optionId) return;
        handleSelect(optionId);
      },
    },
    exitReason: "cpg_selected",
  });

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {options.map((o) => (
            <div key={o.id} className={styles.chipPair}>
              {/* Clickable chip */}
              <div className={`${styles.optionCard} ${selectedId === o.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                {o.label}
              </div>

              {/* Helper text BELOW */}
              {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function SubtypeQuestionScreen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, detectedTrigger, onContinue }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const problemArea = assessmentData.problemArea;
  const isLBP = problemArea === "LBP";
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  let prompt, options;
  if (isLBP) {
    prompt = MYRA_MESSAGES.subtypeQ1?.lbpQuestion || "What tends to make it worse?";
    options = CONST.Q1_OPTIONS;
  } else {
    const path = CONST.CLINICAL_PATHS[problemArea];
    const qIndex = assessmentData.subtypeQuestionIndex || 0;
    const question = path.subtypeQuestions[qIndex];
    prompt = question.prompt;
    options = question.options;
    const isZoneBasedQ1 = problemArea === "THIGH" || (problemArea === "HIP" && qIndex === 0);
    if (isZoneBasedQ1) {
      const selectedZones = assessmentData.selectedZones || [];
      let zoneToOptionMap;
      if (problemArea === "HIP") {
        zoneToOptionMap = CONST.HIP_MOB_Q1_ZONE_TO_OPTION;
      } else if (problemArea === "THIGH") {
        zoneToOptionMap = CONST.THIGH_Q1_ZONE_TO_OPTION;
      }
      console.log(" zoneToOptionMap:", zoneToOptionMap);

      if (zoneToOptionMap && selectedZones.length > 0) {
        const matchedOptionIds = new Set();
        selectedZones.forEach((zone) => {
          const zoneName = zone.includes(":") ? zone.split(":")[1] : zone;
          const optionId = zoneToOptionMap[zoneName];

          console.log(` Zone: "${zone}" → OptionId:`, optionId);
          if (optionId) matchedOptionIds.add(optionId);
        });
        console.log(" matchedOptionIds:", Array.from(matchedOptionIds));
        const matchCount = matchedOptionIds.size;

        if (matchCount >= 2) {
          // 2+ hits: Filter to only the matched options
          options = options.filter((o) => matchedOptionIds.has(o.id));
          console.log(
            "Filtered options to:",
            options.map((o) => o.id),
          );
        } else if (matchCount === 1) {
          // console.log(
          //   " Single match, filtered to:",
          //   options.map((o) => o.id),
          // );

          // the cpg screens handles this:
          // The CPG screen should have already set skipSubtypeQuestion = true
          const singleMatchId = Array.from(matchedOptionIds)[0];
          const matchedOption = options.find((o) => o.id === singleMatchId);
          if (matchedOption) {
            pushToHistory({ type: "frozen-widget", widgetType: "option_cards", id: nextId(), data: { options, selectedId: singleMatchId } }, { type: "user", text: matchedOption.label, id: nextId() });
          }
          // const postTap = MYRA_MESSAGES.subtypeQ1?.postTap?.[singleMatchId];
          // if (postTap) {
          //   setTimeout(async () => {
          //     await showMyraMessage(postTap, 900);
          //   }, 10);
          // }
          setLocked(true);

          // Continue to next screen
          let cpgForBackend = assessmentData.cpgForBackend;
          if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[matchedOption.value]) {
            cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][matchedOption.value];
          }
          onContinue(
            {
              probableSubtype: matchedOption.value,
              cpgForBackend,
              subtypeQuestions: { q1: matchedOption },
              q1PostTapFired: true,
              completed_subtype_screen: true,
            },
            "nprs_symptoms",
          );

          return;
        }
        // matchCount === 0: Show all options (unchanged)
      }
    }
  }

  let nugget = null;
  if (isLBP) {
    nugget = MYRA_MESSAGES.subtypeQ1?.lbpNugget;
  } else {
    const nuggetKey = `${problemArea}_${assessmentData.subtypeQuestionIndex || 0}`;
    nugget = MYRA_MESSAGES.subtypeQ1?.nuggetByAreaAndIndex?.[nuggetKey] || null;
  }
  let introMessage = "";
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isLBP && detectedTrigger) {
        const matchOpt = CONST.Q1_OPTIONS.find((o) => o.value === detectedTrigger);
        if (matchOpt) {
          await showQuestionNuggetMessage(MYRA_MESSAGES.subtypeQ1?.promptWithPreselect || prompt, "", 900);
          if (!cancelled) {
            setSelectedId(matchOpt.id);
            setReady(true);
          }
          return;
        }
      }

      if (assessmentData.q1ReferencePhrase) {
        await showMyraMessage(resolveMessage(MYRA_MESSAGES.subtypeQ1?.referenceTemplate || "", { referencePhrase: assessmentData.q1ReferencePhrase }), 800);
      } else {
        const setup = MYRA_MESSAGES.subtypeQ1?.setupByArea?.[problemArea];
        if (setup) await showMyraMessage(setup, 800);
      }

      await showQuestionNuggetMessage(prompt, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = useCallback(
    async (id) => {
      if (locked) return;
      setSelectedId(id);
      setLocked(true);

      const opt = options.find((o) => o.id === id);
      if (!opt) return;

      pushToHistory({ type: "frozen-widget", widgetType: "option_cards", id: nextId(), data: { options, selectedId: id } }, { type: "user", text: opt.label, id: nextId() });

      const postTap = MYRA_MESSAGES.subtypeQ1?.postTap?.[id];
      if (postTap) await showMyraMessage(postTap, 900);

      if (isLBP) {
        onContinue(
          {
            subtypeQ1: opt.value,
            subtypeQuestions: { q1: opt },
            q1PostTapFired: true,
            completed_subtype_screen: true,
          },
          "self_assessment",
        );
        return;
      }

      let cpgForBackend = assessmentData.cpgForBackend;
      if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[opt.value]) {
        cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][opt.value];
      }

      onContinue(
        {
          probableSubtype: opt.value,
          cpgForBackend,
          subtypeQuestions: { q1: opt },
          q1PostTapFired: true,
          completed_subtype_screen: true,
        },
        "nprs_symptoms",
      );
    },
    [locked, options, isLBP, problemArea, assessmentData.cpgForBackend],
  );

  const validateAndContinue = useCallback(() => {
    if (!selectedId && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please make your selection before we can move to the next screen");
    }
  }, [selectedId, locked]);

  useEffect(() => {
    window.currentFlow = "flow_subtype";
    VoiceService._currentFlow = "flow_subtype";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_subtype");
    }
  }, []);

  const SUBTYPE_VOICE_MAP = {
    LBP: {
      FLEXION_TRIGGER: "q1a",
      EXTENSION_TRIGGER: "q1b",
      ROTATION_TRIGGER: "q1e",
      STATIC_TRIGGER: "q1c",
      UNPREDICTABLE: "q1d",
    },
    HIP_0: {
      LATERAL_HIP: "hip-sub-lateral",
      HIP_FLEXOR: "hip-sub-anterior",
      POSTERIOR_HIP: "hip-sub-posterior",
      ADDUCTOR_GROIN: "hip-sub-rotational",
      DEEP_BUTTOCK: "hip-sub-neuro",
      JOINT_GENERALIZED: "hip-sub-global",
    },
    HIP_1: {
      ADDUCTOR_STRAIN: "hip-sub-adductor",
      ABDUCTOR_WEAKNESS: "hip-sub-abduction",
    },
    THIGH_0: {
      FRONT_THIGH: "thigh-sub-anterior",
      INNER_THIGH: "thigh-sub-medial",
      BACK_THIGH: "thigh-sub-posterior",
      OUTER_THIGH: "thigh-sub-lateral",
    },
    KNEE_0: {
      PATELLAR_TRACKING: "knee-sub-valgus",
      PATELLAR_GRINDING: "knee-sub-maltrack",
      PATELLAR_TENDON: "knee-sub-tendon",
    },
    KNEE_1: {
      KNEE_STIFFNESS: "knee-sub-stiff",
      KNEE_INSTABILITY: "knee-sub-unstable",
    },
  };

  useScreenVoice({
    screenName: "subtype_questioning",
    flowName: "flow_subtype",
    payloadKey: "subtype_questioning",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value) => {
        if (value === "continue_command") validateAndContinue();
      },
      MOVE_ON: () => validateAndContinue(),
      SELECT_SUBTYPE: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        const enumValue = actionValue;
        if (!enumValue) return;
        const mapKey = isLBP ? "LBP" : `${problemArea}_${assessmentData.subtypeQuestionIndex || 0}`;
        const optionId = SUBTYPE_VOICE_MAP[mapKey]?.[enumValue];
        if (!optionId) return;
        handleSelect(optionId);
      },
    },
    exitReason: "subtype_selected",
  });

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {options.map((o) => (
            <div key={o.id} className={styles.chipPair}>
              {/* Clickable chip */}
              <div className={`${styles.optionCard} ${selectedId === o.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                {o.label}
              </div>

              {/* Helper text BELOW */}
              {/* {o.info && <div className={styles.chipHelper}>{o.info}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function SelfAssessmentQ2Screen({ assessmentData, pushToHistory, showMyraMessage, showQuestionNuggetMessage, scrollToBottom, onContinue }) {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const q1Value = assessmentData.subtypeQ1;
  const q2Data = CONST.Q2_MAP[q1Value];
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    if (!q2Data) return;
    let cancelled = false;
    async function init() {
      if (MYRA_MESSAGES.q2?.transition) await showMyraMessage(MYRA_MESSAGES.q2.transition, 700);
      const q2Nugget = MYRA_MESSAGES.q2?.nuggetByQ1?.[q1Value] || MYRA_MESSAGES.q2?.nuggetByQ1?.c;
      await showQuestionNuggetMessage(q2Data.title, "", 800);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = useCallback(
    async (answer) => {
      if (locked) return;
      setSelectedAnswer(answer);
      setLocked(true);
      let echoText = "";
      if (answer === "YES" || answer === "yes") {
        echoText = "Yes, that helps";
      } else {
        echoText = "No, not really";
      }

      // const echoText = answer === "yes" ? "Yes, that helps" : "No, not really";
      pushToHistory({ type: "frozen-widget", widgetType: "yesno", id: nextId(), data: { selectedAnswer: answer } }, { type: "user", text: echoText, id: nextId() });

      const subtype = CONST.getSubtype(q1Value, answer);
      if (MYRA_MESSAGES.q2?.postTap) await showMyraMessage(MYRA_MESSAGES.q2.postTap, 700);

      onContinue({
        selfAssessmentAnswer: echoText,
        selfAssessmentValue: answer,
        subtypeQ2: answer,
        probableSubtype: subtype,
        submitted_symptoms_1: true,
        q1PostTapFired: true,
      });
    },
    [locked, q1Value, pushToHistory, onContinue, showMyraMessage],
  );

  const validateAndContinue = useCallback(() => {
    if (!selectedAnswer && !locked) {
      if (isVoiceMode) VoiceService?.doSay("Please answer yes or no before we can move to the next screen");
    }
  }, [selectedAnswer, locked]);

  useScreenVoice({
    screenName: "self_assessment",
    flowName: "flow_self_assessment",
    payloadKey: "self_assessment",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted, actionValue) => {
        if (locked) return;
        if (value === "continue_command") {
          validateAndContinue();
          return;
        }
        const answer = actionValue === "YES" || value === "yes" ? "yes" : actionValue === "NO" || value === "no" ? "no" : null;
        if (answer) handleSelect(answer);
      },
      MOVE_ON: () => validateAndContinue(),
      SELECT_Q2: (value, speech, intent, extracted, actionValue, matched) => {
        if (actionValue === "YES" || actionValue === "NO_UNSURE") handleSelect(actionValue);
      },
    },
    exitReason: "self_assessment_answered",
  });

  if (!q2Data) {
    return <div className={styles.inlineUi}>No follow-up question available.</div>;
  }

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          <div className={styles.chipPair}>
            <button className={`${styles.yesnoBtn} ${selectedAnswer === "yes" ? styles.selected : ""}`} onClick={() => handleSelect("yes")} disabled={locked}>
              Yes, that helps
            </button>
          </div>
          <div className={styles.chipPair}>
            <button className={`${styles.yesnoBtn} ${selectedAnswer === "no" ? styles.selected : ""}`} onClick={() => handleSelect("no")} disabled={locked}>
              No, not really
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

function PreNPRSScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, readOnly = false, showQuestionNuggetMessage, setPlaceholderText }) {
  const [ready, setReady] = useState(false);
  const [painLocked, setPainLocked] = useState(false);
  const painLockedRef = useRef(false);

  // Push setup beat + question + nugget on mount.
  // Set screen-specific placeholder for the chat composer.
  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(MYRA_MESSAGES.preNprs.NPRS_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.preNprs.painPrompt, MYRA_MESSAGES.preNprs.nugget, 900);
      if (!cancelled) setReady(true);
    }
    init();
    if (setPlaceholderText && MYRA_MESSAGES.preNprs.placeholder) {
      setPlaceholderText(MYRA_MESSAGES.preNprs.placeholder);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  // Voice flow setup
  useEffect(() => {
    window.currentFlow = "flow_nprs_symptoms";
    VoiceService._currentFlow = "flow_nprs_symptoms";
    MyraInteraction?.onScreenEnter?.("nprs_symptoms");
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_nprs_symptoms");
    }
  }, []);

  // Receive a numeric pain value (0–10) from Beacon and advance.
  // Beacon parses "4", "four", "a 4", "about a four", etc. and returns
  // a normalized integer. Anything Beacon can't parse is handed to Claude
  // and arrives back here through the same command channel.
  const handlePainValue = useCallback(
    (val) => {
      if (painLockedRef.current || painLocked || readOnly) return;
      painLockedRef.current = true;
      setPainLocked(true);
      pushToHistory({ type: "user", text: `${val}`, id: nextId() }, { type: "myra", text: MYRA_MESSAGES.preNprs.NPRS_POST_TAP_NUGGET, id: nextId() });
      onContinue({
        painLevel: val,
        completed_nprs: true,
      });
    },
    [painLocked, readOnly, pushToHistory, onContinue],
  );

  useScreenVoice({
    screenName: "nprs_symptoms",
    trackerName: "pre_nprs",
    flowName: "flow_nprs_symptoms",
    payloadKey: "nprs_symptoms",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (extracted && extracted.painLevel !== undefined && extracted.painLevel !== null) {
          const painValue = typeof extracted.painLevel === "number" ? extracted.painLevel : parseInt(extracted.painLevel);
          if (!isNaN(painValue) && painValue >= 0 && painValue <= 10) {
            handlePainValue(painValue);
          }
        }
      },
      SELECT_PAIN_LEVEL: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = Array.isArray(actions) ? actions : Array.isArray(actionValue) ? actionValue : [];
        const painAction = allActions.find((a) => a.action === "SELECT_PAIN_LEVEL");
        const rawPainValue = painAction?.value ?? (!Array.isArray(actionValue) && actionValue !== undefined ? actionValue : value);
        if (rawPainValue !== undefined && rawPainValue !== null) {
          const painValue = typeof rawPainValue === "number" ? rawPainValue : parseInt(rawPainValue);
          if (!isNaN(painValue) && painValue >= 0 && painValue <= 10) {
            handlePainValue(painValue);
          }
        }
      },
    },
    exitReason: "pre_nprs_completed",
  });

  if (!ready) return null;

  // No live UI — the question + nugget bubble is in conversation history,
  // and the user replies through the existing chat composer.
  return null;
}

// ════════════════════════════════════════════════════════════════
// SCREEN 9: TEST INTRO 1
// Mode selection card (conditional) → demo video → "Ready" button.
// Most complex voice integration in the GSA:
//   - Manual flow management (not standard useScreenVoice flow)
//   - 4 startFlow paths based on name + returning status
//   - 9 command handlers including GIVE_NAME and video controls
//   - AR handoff with full window.* global setup
//   - Second (and optionally third) test video preloading
// ════════════════════════════════════════════════════════════════

function TestIntroScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setPlaceholderText }) {
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const videoRef = useRef(null);

  const subtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";
  const problemArea = assessmentData.problemArea || "LBP";
  const test = CONST.TEST_MAP[subtype];
  const testName = test?.name || assessmentData.testName || assessmentData.rom_test1_name || "";
  const introVideoUrl = CONST.TEST_INTRO_VIDEOS?.[testName] || test?.video || "";
  const [demoStarted, setDemoStarted] = useState(false);

  // Derive AR handoff values from assessmentData (persisted by TestIntroScreen)
  const cameraPayload = useMemo(() => generatePayloadForScreen("camera_permission", assessmentData), [assessmentData]);
  const movementTestPayload = useMemo(() => generatePayloadForScreen("movement_test_1", assessmentData), [assessmentData]);
  window.notOpenQNA = false;
  MyraInteraction?.onScreenEnter?.("test1_demo");

  // Generate test intro payload (camera + movement test payloads move to CameraPermissionScreen with AR handoff)
  const testIntroPayload = useMemo(() => generatePayloadForScreen("test1_demo", assessmentData), [assessmentData]);

  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(getDemoVideo1Message(problemArea, subtype, testName), 1100);
      if (!cancelled) {
        scrollToBottom?.("smooth");
        setReady(true);
      }
    }
    init();
    if (setPlaceholderText && MYRA_MESSAGES.shell) {
      setPlaceholderText(MYRA_MESSAGES.shell.inputPlaceholderDefault);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ready) return;
    scrollToBottom?.("smooth");
    const t = setTimeout(() => scrollToBottom?.("smooth"), 180);
    return () => clearTimeout(t);
  }, [ready, scrollToBottom]);

  useEffect(() => {
    // Video controller
    window.videoController = {
      pause: () => videoRef.current?.pause(),
      play: () => videoRef.current?.play(),
      expand: () => {
        document.body.classList.add("videoplay-expanded");
        videoRef.current?.requestFullscreen?.();
      },
      replay: () => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play();
        }
      },
      isPaused: () => videoRef.current?.paused ?? true,
    };
  }, []);
  const doReplyVideo = () => {
    const video = videoRef.current;
    if (!video) {
      console.error("Video element not found");
      return;
    }
    videoRef.current.currentTime = 0;
    setDemoStarted(true);
    videoRef.current.play().catch((err) => console.log("Replay autoplay prevented:", err));
  };

  const handlePlayDemoVideo = useCallback(() => {
    if (locked) return;
    const video = videoRef.current;
    if (!video) return;
    setDemoStarted(true);
    video.play().catch((err) => console.log("Demo video play prevented:", err));
  }, [locked]);

  // useScreenVoice for boilerplate only — flow handled manually
  useScreenVoice({
    screenName: "test1_demo",
    flowName: "flow_demo_video",
    payloadKey: "test1_demo",
    exitReason: "started_test",
    commands: {
      GIVE_NAME: (value) => {
        if (window.exitHandlerOpen) return;
        localStorage.setItem("self_name", value);
        window.mayraForwardCode = { midjourneyData: testIntroPayload };
        window.mayraCode.startFlow("flow_demo_video", "first_video_play_name", () => {
          doReplyVideo();
          window.videoController?.replay();
        });
      },
      SKIP_NAME: (value) => {
        if (window.exitHandlerOpen) return;
        window.mayraForwardCode = { midjourneyData: testIntroPayload };
        window.mayraCode.startFlow("flow_demo_video", "first_video_play_skip_name", () => {
          doReplyVideo();
          window.videoController?.replay();
        });
      },
      SKIP_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Got it! Skipping the video.");
        // window.mayraCode?.startFlow("flow_demo_video", "first_video_play_skip_name");
        handleContinueToTest();
      },
      REPLAY_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        window.videoController?.replay();
        doReplyVideo();
      },
      PAUSE_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        if (window.videoController?.isPaused()) {
          VoiceService?.doSay("The video is already paused.");
        } else {
          VoiceService?.doSay("Sure! I'll pause the video...");
          window._lastPauseTime = Date.now();
          window.videoController?.pause();
        }
      },
      RESUME_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Sure! I'll resume the video...");
        window.videoController?.play();
      },
      EXPAND_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Sure! I'll expand the video...");
        window.videoController?.expand();
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleContinueToTest();
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command") handleContinueToTest();
      },
    },
  });

  // ── Continue to Mode Selection (video ends, user commits to proceeding) ──
  // AR handoff has moved to CameraPermissionScreen (fires when camera choice is made).
  const handleContinueToTest = useCallback(async () => {
    if (window.clickedOnceOpen) return;
    window.clickedOnceOpen = true;
    if (locked) return;
    setLocked(true);

    const watchedDuration = videoRef.current?.currentTime || 0;
    const totalDuration = videoRef.current?.duration || 0;

    // Clean up video
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute("src");
      videoRef.current.load();
    }
    document.body.classList.remove("videoplay-expanded");

    // Push frozen video widget + user echo to conversation history
    pushToHistory({ type: "frozen-widget", widgetType: "demo_video", id: nextId(), data: { testName, videoUrl: introVideoUrl } }, { type: "user", text: resolveMessage(MYRA_MESSAGES.demoVideo.buttonLabels.watchedDemoEcho, { testName }), id: nextId() });

    await showMyraMessage(MYRA_MESSAGES.demoVideo?.DEMO_VIDEO_1_POST_VIDEO || "Got it. Let's keep going.", 700);

    // use noCamera mode as default
    localStorage.setItem("noCameraMode", "true");
    localStorage.setItem("cameFromGsaV2", "true");

    // ── AR handoff (moved here from TestIntroScreen) ──
    // This is the "moving to Movement Test" commit point.
    window.stopAudio?.();
    window.mayraCode?.disableCallback();

    window.selectedSubType = subtype;
    window.movementTestPayload = movementTestPayload;
    window.cameraPayload = cameraPayload;
    localStorage.setItem("runStep", "1");
    localStorage.setItem("loadSelf", testName);

    window.preloadAllAudios?.();
    window.videoUnlockPlay?.();

    if (subtype === "ROTATIONAL_INTOLERANT") {
      window.assessmentChangeExercise = true;
    }

    window.loadROMExercises?.(true);
    let input_mode_at_test_start = MyraInteraction.getMode() || "chat";
    window.input_mode_at_test_start = input_mode_at_test_start;

    // Persist payload fields from Demo Video 1 (unchanged). AR fires later from Camera Selection.
    onContinue({
      testName,
      rom_test1_name: testName,
      rom_test1_started: true,
      test1VideoWatched: watchedDuration > 0,
      test1VideoDuration: watchedDuration,
      // watched_demo_1: totalDuration > 0 ? watchedDuration / totalDuration > 0.5 : false,
      watched_demo_1: watchedDuration >= 1,
      input_mode_at_test_start: input_mode_at_test_start,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locked, testName, introVideoUrl]);

  // ── Register command handlers ──
  const registerCommands = useCallback(() => {
    window.currentCommandsAudio = {
      GIVE_NAME: (value) => {
        if (window.exitHandlerOpen) return;
        localStorage.setItem("self_name", value);
        window.mayraForwardCode = { midjourneyData: testIntroPayload };
        window.mayraCode.startFlow("flow_demo_video", "first_video_play_skip_name", () => {
          doReplyVideo();
          window.videoController?.replay();
        });
      },
      SKIP_NAME: (value) => {
        if (window.exitHandlerOpen) return;
        window.mayraForwardCode = { midjourneyData: testIntroPayload };
        window.mayraCode.startFlow("flow_demo_video", "first_video_play_skip_name", () => {
          doReplyVideo();
          window.videoController?.replay();
        });
      },
      SKIP_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Got it! Skipping the video.");
        // window.mayraCode?.startFlow("flow_demo_video", "first_video_play_skip_name");
        handleContinueToTest();
      },
      REPLAY_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        window.videoController?.replay();
      },
      PAUSE_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        if (window.videoController?.isPaused()) {
          VoiceService?.doSay("The video is already paused.");
        } else {
          VoiceService?.doSay("Sure! I'll pause the video...");
          window._lastPauseTime = Date.now();
          window.videoController?.pause();
        }
      },
      RESUME_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Sure! I'll resume the video...");
        window.videoController?.play();
      },
      EXPAND_VIDEO: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("Sure! I'll expand the video...");
        window.videoController?.expand();
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleContinueToTest();
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command") handleContinueToTest();
      },
      _default: () => {
        if (window.exitHandlerOpen) return;
        VoiceService?.doSay("I didn't catch that one. Here's what I can help with: Skip, Replay, Pause, Expand");
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testIntroPayload]);

  // ── Mount: video controller, preloading, flow start ──
  useEffect(() => {
    // AR initialization function (called from mode selection or app shell)
    window.initAR = () => {
      window.loadROMExercises?.(true);
    };

    // Preload second test video
    const test2 = CONST.getNegativeTest(subtype, problemArea);
    if (test2) {
      const secondVideoUrl = CONST.TEST_INTRO_VIDEOS?.[test2.name] || test2.video;
      if (secondVideoUrl) {
        const secondVideo = document.createElement("video");
        secondVideo.id = "secondTestVideo";
        secondVideo.style.cssText = "width:1px;height:1px;position:absolute;opacity:0";
        secondVideo.src = secondVideoUrl;
        document.body.appendChild(secondVideo);

        // Toe Touch: preload third video if needed
        if (test2.name === "Toe Touch") {
          window.hasSecondVideoRotation = true;
          const thirdUrl = CONST.TEST_INTRO_VIDEOS?.["Toe Touch"];
          if (thirdUrl && thirdUrl !== secondVideoUrl) {
            const thirdVideo = document.createElement("video");
            thirdVideo.id = "secondTestVideo2";
            thirdVideo.style.cssText = "width:1px;height:1px;position:absolute;opacity:0";
            thirdVideo.src = thirdUrl;
            document.body.appendChild(thirdVideo);
          }
        }
      }
    }

    // iOS video unlock function
    window.unlockAllVideos = () => {
      const vid = document.getElementById("secondTestVideo");
      if (vid) {
        vid
          .play()
          .then(() => vid.pause())
          .catch(() => {});
      }
      const vid2 = document.getElementById("secondTestVideo2");
      if (vid2) {
        vid2
          .play()
          .then(() => vid2.pause())
          .catch(() => {});
      }
    };

    // Register commands without starting a voice announcement or auto-playing the demo.
    // Session-level communication mode (header Chat/Voice toggle) is preserved from earlier screens.
    window.preloadAllAudios?.();
    registerCommands();

    return () => {
      window.videoController = null;
      window.initAR = null;
      window.clickedOnceOpen = false;
      const sv = document.getElementById("secondTestVideo");
      if (sv) sv.remove();
      const sv2 = document.getElementById("secondTestVideo2");
      if (sv2) sv2.remove();
      window.unlockAllVideos = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) return null;
  return (
    <>
      {!locked ? (
        <div className={`${styles.inlineUi} ${styles.demovideoui}`}>
          {/* Demo Video — always shown */}
          <p className={styles.paSubtitle}>
            {MYRA_MESSAGES.demoVideo.watchInstructionPrefix} <strong>{testName}</strong>
            {MYRA_MESSAGES.demoVideo.watchInstructionSuffix}
          </p>

          <div className={styles.videoContainer}>
            <video ref={videoRef} src={introVideoUrl} controls playsInline preload="metadata" onPlay={() => setDemoStarted(true)} />
          </div>

          {/* Start Movement Test — always visible */}
          <div className={styles.videoActions}>
            <button className={`${styles.videoBtn} ${styles.videoBtnPrimary}`} onClick={handleContinueToTest} disabled={locked || !demoStarted}>
              {MYRA_MESSAGES.demoVideo.buttonLabels.startMovementTest}
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 9a: MODE SELECTION
// Silent card — no Myra message. Captures the user's preferred
// communication style for the movement test (when they're away
// from their device and CV needs to see them).
// Two options: Talk (voice + mic permission) / Chat (text).
// Advances to Camera Selection regardless of mic grant/deny.
// ════════════════════════════════════════════════════════════════

function ModeSelectionScreen({ assessmentData, pushToHistory, scrollToBottom, onContinue, showMyraMessage }) {
  const [locked, setLocked] = useState(false);
  const lockedRef = useRef(false);
  const [ready, setReady] = useState(false);

  const subtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";
  const test = CONST.TEST_MAP[subtype];
  const testName = test?.name || assessmentData.testName || "";
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  useEffect(() => {
    if (isVoiceMode) {
      pushToHistory({ type: "frozen-widget", widgetType: "mode_selection", id: nextId(), data: { selectedMode: "voice" } }, { type: "user", text: "Yes, talk", id: nextId() });
      onContinue({ userUsesVoice: true });
    }
  }, []);
  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(MYRA_MESSAGES.modeSelection?.MODE_SELECTION_SETUP_BEAT, 800);
      await showMyraMessage(MYRA_MESSAGES.modeSelection?.MODE_SELECTION_CHAT_VALIDITY, 1200);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, [showMyraMessage]);

  // Mount scroll — ModeSelectionScreen doesn't push to conversationHistory on enter,
  // so the shell's [conversationHistory] effect never fires for this screen. Match
  // the shell's own first-pass + 300ms second-pass pattern.
  useEffect(() => {
    scrollToBottom("smooth");
    const t = setTimeout(() => scrollToBottom("smooth"), 180);
    return () => clearTimeout(t);
  }, [scrollToBottom]);
  useEffect(() => {
    window.currentFlow = "flow_mode_selection";
    VoiceService._currentFlow = "flow_mode_selection";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_mode_selection");
    }
  }, []);
  useScreenVoice({
    screenName: "mode_selection",
    trackerName: "flow_mode_selection",
    flowName: "mode_selection",
    payloadKey: "mode_selection",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (value === "continue_command") {
        }
      },
      MOVE_ON: () => {},
      SELECT_MODE: (value, speech, intent, extracted, actionValue, actions) => {
        if (lockedRef.current) return;

        const enumValue = actionValue;
        if (!enumValue) return;

        if (enumValue === "VOICE") handleVoiceMode();
        else if (enumValue === "CHAT") handleChatMode();
      },
    },
    exitReason: "SELECTED MODE",
  });

  const handleVoiceMode = useCallback(async () => {
    if (lockedRef.current) return;
    lockedRef.current = true;
    setLocked(true);

    try {
      window.audioPlayer?.ctx?.resume();
    } catch (e) {
      /* ignore */
    }

    MyraInteraction?.confirmIntroARMode?.("voice");
    let micGranted = false;

    await window.requestMicrophonePermission?.({
      onGrant: () => {
        micGranted = true;
        MyraInteraction?.switchMode?.("voice", true);
        window.mayraCode?.handleMicClick?.(true, true, false, true);
        const currentHealth = VoiceService?._isActuallyListening?.();
        if (currentHealth && !currentHealth.healthy) {
          console.log("[RECONNECT] Starting listening");
          VoiceService._startListening().catch(() => {
            setTimeout(() => {
              VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
            }, 2000);
          });
        }
        MyraInteraction?.closeVoice?.();
      },
      onDeny: () => {
        MyraInteraction?.switchMode?.("chat", true);
        VoiceService?.startFlowWithoutAnnouncement?.(window.currentFlow || VoiceService?._currentFlow);
        const msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
        MyraInteraction?.onMyraMessage?.(msg);
        MyraInteraction?.closeVoice?.();
      },
    });

    if (micGranted) {
      pushToHistory({ type: "frozen-widget", widgetType: "mode_selection", id: nextId(), data: { selectedMode: "voice" } }, { type: "myra", text: MYRA_MESSAGES.modeSelection?.MODE_SELECTION_POST_DECISION.talk, id: nextId() });
      onContinue({ userUsesVoice: true, userUsesChat: false });
    } else {
      pushToHistory({ type: "frozen-widget", widgetType: "mode_selection", id: nextId(), data: { selectedMode: "chat" } }, { type: "myra", text: MYRA_MESSAGES.modeSelection?.MODE_SELECTION_POST_DECISION.chat, id: nextId() });
      onContinue({ userUsesVoice: false, userUsesChat: true });
    }
  }, [pushToHistory, onContinue]);

  const handleChatMode = useCallback(() => {
    if (lockedRef.current) return;
    lockedRef.current = true;
    setLocked(true);

    MyraInteraction?.switchMode?.("chat", true);
    VoiceService?.startFlowWithoutAnnouncement?.(window?.currentFlow || VoiceService?._currentFlow || "flow_demo_video");

    const chatAnnouncement = `We're going to try a movement called ${testName}. Tap "Ready" when you want to begin.`;
    MyraInteraction?.onMyraMessage?.(chatAnnouncement);
    MyraInteraction?.closeChat?.();

    pushToHistory({ type: "frozen-widget", widgetType: "mode_selection", id: nextId(), data: { selectedMode: "chat" } }, { type: "myra", text: MYRA_MESSAGES.modeSelection?.MODE_SELECTION_POST_DECISION.chat, id: nextId() });

    onContinue({ userUsesChat: true });
  }, [testName, pushToHistory, onContinue]);

  return (
    <>
      {ready && (
        <div className={styles.inlineUi2}>
          <div>
            <button className={styles.modeChip} onClick={handleVoiceMode} disabled={locked}>
              {MYRA_MESSAGES.modeSelection.talkLabel}
            </button>
            {/* <div className={styles.chipHelper}>{MYRA_MESSAGES.modeSelection.talkHelper}</div> */}
          </div>

          <div>
            <button className={styles.modeChip} onClick={handleChatMode} disabled={locked}>
              {MYRA_MESSAGES.modeSelection.chatLabel}
            </button>
            {/* <div className={styles.chipHelper}>{MYRA_MESSAGES.modeSelection.chatHelper}</div> */}
          </div>
        </div>
      )}
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 9b: CAMERA PERMISSION
// Dialog-style camera access choice before movement test.
// ════════════════════════════════════════════════════════════════
function CameraPermissionScreen({ assessmentData, pushToHistory, showMyraMessage, onContinue }) {
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);

  // Derive AR handoff values from assessmentData (persisted by TestIntroScreen)
  const subtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";
  const testName = assessmentData.testName || assessmentData.rom_test1_name || CONST.TEST_MAP[subtype]?.name || "";
  const cameraPayload = useMemo(() => generatePayloadForScreen("camera_permission", assessmentData), [assessmentData]);
  const movementTestPayload = useMemo(() => generatePayloadForScreen("movement_test_1", assessmentData), [assessmentData]);

  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(MYRA_MESSAGES.camera?.CAMERA_PERMISSION_SETUP_BEAT, 800);
      // await showMyraMessage(MYRA_MESSAGES.camera?.CAMERA_PERMISSION_DECLINE_LEGITIMIZATION, 1200);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, [showMyraMessage]);
  useEffect(() => {
    window.currentFlow = "flow_camera_permission";
    VoiceService._currentFlow = "flow_camera_permission";
    if (window.mayraCode) {
      VoiceService.startFlowWithoutAnnouncement("flow_camera_permission");
    }
  }, []);
  useScreenVoice({
    screenName: "camera_permission",
    flowName: "flow_camera_permission",
    payloadKey: "camera_permission",
    commands: {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (value === "continue_command") {
        }
      },
      MOVE_ON: () => {},
      SELECT_CAMERA: (value, speech, intent, extracted, actionValue, actions) => {
        if (lockedRef.current) return;

        const enumValue = actionValue;
        if (!enumValue) return;

        if (enumValue === "ALLOW") handleSelect("allow");
        else if (enumValue === "DECLINE") handleSelect("decline");
      },
    },
    exitReason: "SELECTED CAMERA MODE",
  });

  const handleSelect = useCallback(
    async (choice) => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setLocked(true);

      const isAllow = Boolean(choice === "allow");
      const userText = isAllow ? "Use camera" : "No camera";

      pushToHistory({ type: "frozen-widget", widgetType: "camera_permission", id: nextId(), data: { selectedAnswer: choice } }, { type: "user", text: userText, id: nextId() });

      // Requested behavior: set noCameraMode=true when "Allow camera" is selected.
      console.log("noCameraMode - isAllow", !isAllow, "Keeping noCameraMode false for now to allow AR testing with camera path (SelfAssessment.jsx)");
      // localStorage.setItem("noCameraMode", !isAllow);
      localStorage.setItem("noCameraMode", true); // Always keeping noCameraMode true
      localStorage.setItem("cameFromGsaV2", "true");

      // ── AR handoff (moved here from TestIntroScreen) ──
      // This is the "moving to Movement Test" commit point.
      window.stopAudio?.();
      window.mayraCode?.disableCallback();

      window.selectedSubType = subtype;
      window.movementTestPayload = movementTestPayload;
      window.cameraPayload = cameraPayload;
      localStorage.setItem("runStep", "1");
      localStorage.setItem("loadSelf", testName);

      window.preloadAllAudios?.();
      window.videoUnlockPlay?.();

      if (subtype === "ROTATIONAL_INTOLERANT") {
        window.assessmentChangeExercise = true;
      }

      window.loadROMExercises?.(true);

      const followup = isAllow ? MYRA_MESSAGES.camera?.cameraAllowed : MYRA_MESSAGES.camera?.cameraDeclined;
      await showMyraMessage(followup || (isAllow ? "In the full app, the AR tracking screen would appear here. For this prototype, we'll simulate the camera path." : "No problem at all. I'll ask you a couple of quick questions after the movement instead."), 700);

      const nextStep = choice === "allow" ? "mode_selection" : "movement_test_1";
      if (choice !== "allow") {
        MyraInteraction?.switchMode?.("chat", true);
      }

      onContinue(
        {
          cameraPermissionChoice: choice,
          userDeclinesCamera: choice === "decline",
          nextStep: nextStep,
          userUsesChat: choice === "allow" ? false : true,
        },
        nextStep,
      );
    },
    [pushToHistory, showMyraMessage, onContinue, subtype, testName, cameraPayload, movementTestPayload],
  );

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          <div className={styles.cameraChipPair}>
            <button className={styles.cameraChip} onClick={() => handleSelect("allow")}>
              {MYRA_MESSAGES.camera.buttonLabels.allowCameraAccess}
            </button>
            <button className={styles.cameraChip} onClick={() => handleSelect("decline")}>
              {MYRA_MESSAGES.camera.buttonLabels.continueWithoutCamera}
            </button>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 10: MOVEMENT TEST 1 (AR)
// Placeholder screen — AR/Flutter takes over entirely.
// On mount: clears commands, disables Myra, sets completion handler.
// AR writes dataAfterInfo to localStorage and calls
// window.doNextLocation.push() when complete.
// ════════════════════════════════════════════════════════════════

function MovementTest1Screen({ assessmentData, updateAssessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, onHardStop, chatBucketTest }) {
  const [isVisible, setIsVisible] = useState(false);
  MyraInteraction?.onScreenEnter?.("movement_test_1");

  const handleARComplete = useCallback(async () => {
    // Hide movement progress UI immediately after AR completion to avoid UI flash
    // while Myra transitions into the completion/confirmation message.
    window.hideMovementProgressUi = true;

    // Re-enable Myra
    window.mayraCode?.setIsVisible(true);
    window.mayraCode?.enableCallback?.();

    // Read AR results from localStorage
    let dataAfterInfo = {};
    try {
      const raw = localStorage.getItem("dataAfterInfo");
      if (raw) dataAfterInfo = JSON.parse(raw);
    } catch (e) {
      /* ignore parse errors */
    }

    const completedTestName = CONST.TEST_MAP[assessmentData.probableSubtype]?.name || assessmentData.testName || assessmentData.rom_test1_name || "the movement";
    pushToHistory({ type: "user", text: "I've done the movement.", id: nextId() });
    await showMyraMessage(getMovementCompletionSummary(completedTestName), 800);
    console.log("AR completion data:", assessmentData.input_mode_at_test_start, MyraInteraction.getMode());
    let switchModeDuringTest = false;
    if (window.switchedModeDuringTest) {
      switchModeDuringTest = true;
    } else if (assessmentData.input_mode_at_test_start && MyraInteraction.getMode() && assessmentData.input_mode_at_test_start !== MyraInteraction.getMode()) {
      switchModeDuringTest = true;
    } else {
      switchModeDuringTest = false;
    }

    // Determine path: camera vs no-camera
    const noCameraMode = localStorage.getItem("noCameraMode") === "true";
    const nextStep = noCameraMode ? "self_report_rom" : "rpe";
    window.currnetScreen = nextStep;
    window.currentScreen = nextStep;

    onContinue(
      {
        ...dataAfterInfo,
        rom_test1_started: true,
        rom_test1_completed: true,
        viewed_test1_reveal: true,
        noCameraMode,
        switched_to_voice_during_test: switchModeDuringTest,
      },
      nextStep,
    );
  }, [onContinue, assessmentData.probableSubtype, showMyraMessage, pushToHistory]);

  useEffect(() => {
    // Reset per-test transient UI hide flag at test start.
    window.hideMovementProgressUi = false;

    // Clear commands and hide Myra during AR
    window.currentCommandsAudio = {};
    window.mayraCode?.disableCallback();
    window.mayraCode?.setIsVisible(false);

    // Push voice indicator to history
    pushToHistory({ type: "voice-indicator", id: nextId() });

    // AR completion handler — AR calls window.doNextLocation.push() when done
    window.doNextLocation = {
      push: () => {
        handleARComplete();
      },
    };

    // Safety hard stop handler — AR calls this if user can't complete reps
    window.handleARHardStop = () => {
      window.mayraCode?.setIsVisible(false);
      window.mayraCode?.forceStop?.();
      onHardStop("test1_pain");
    };

    return () => {
      window.doNextLocation = null;
      window.handleARHardStop = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Landing bucket router can jump straight to movement_test_1 (skipping TestIntro /
    // CameraPermission). Those screens set localStorage.loadSelf and window payloads;
    // without them, loadROMExercises() in ondemand-camera.js no-ops and Flutter never
    // gets ROM data (checkIsSelf → "self no"), leaving the user on this placeholder.

    if (window._gsaLandingChatMovementTest === true) {
      console.log("inside movement test 1 from landing page chat", chatBucketTest);
      window._gsaLandingChatMovementTest = false;
      const subtype = chatBucketTest.subtype || "NEUTRAL_SENSITIVE";
      const test = CONST.TEST_MAP[subtype];
      const testName = chatBucketTest.reveal || test?.name || assessmentData.testName || assessmentData.rom_test1_name || "";
      if (testName) {
        window.selectedSubType = subtype;
        window.problemArea = chatBucketTest.problemArea || "LBP";
        if (subtype === "ROTATIONAL_INTOLERANT") {
          window.assessmentChangeExercise = true;
        }
        window.movementTestPayload = generatePayloadForScreen("movement_test_1", assessmentData);
        window.cameraPayload = generatePayloadForScreen("camera_permission", assessmentData);
        localStorage.setItem("loadSelf", testName);
        localStorage.setItem("cameFromGsaV2", "true");
        window.input_mode_at_test_start = MyraInteraction.getMode() || "chat";
        // TestIntro / CameraPermission persist testName st1_name; landing chat skips them.
        // Score API uses romTest1.testName for rationale — merge s+ rom_teo Recovery/Plan get the real label.
        updateAssessmentData({ testName, rom_test1_name: testName });
        const existing = JSON.parse(localStorage.getItem("assessmentData") || "{}");
        localStorage.setItem("assessmentData", JSON.stringify({ ...existing, testName, rom_test1_name: testName }));
      }
    }

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }
    if (window.clickedOnceOpen) {
      return false;
    }

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    localStorage.setItem("runStep", "1");
    if (window.loadROMExercises) {
      window.loadROMExercises(true);
    }

    // Modified on Aug 7th - for user tracking

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").pause();
      document.querySelector("#assesmentDiv video").removeAttribute("autoplay");
    }

    window.clickedOnceOpen = true;

    if (document.querySelector(".rom-test-start-button")) {
      document.querySelector(".rom-test-start-button").innerHTML = "Loading Movement Test…";
    }

    console.log("Tried open");
    const startARWithDelay = () => {
      if (window.doCameraScreenStart) {
        setTimeout(() => {
          window.doCameraScreenStart();
          setTimeout(() => setIsVisible(true), 100);
          console.log("Tried open - ready");
        }, 800);
      } else {
        let openIntervalCheck = setInterval(() => {
          if (window.doCameraScreenStart) {
            setTimeout(() => {
              window.doCameraScreenStart();
              setTimeout(() => setIsVisible(true), 100);
              console.log("Tried open - ready");
            }, 800);
            clearInterval(openIntervalCheck);
          } else {
            console.log("Tried open - not ready");
          }
        }, 1000);
      }
    };
    startARWithDelay();

    // if (window.doCameraScreenStart) {
    //   window.doCameraScreenStart();
    //   console.log("Tried open - ready");
    // } else {
    //   let openIntervalCheck = setInterval(() => {
    //     if (window.doCameraScreenStart) {
    //       window.doCameraScreenStart();
    //       console.log("Tried open - ready");
    //       clearInterval(openIntervalCheck);
    //     } else {
    //       console.log("Tried open - not ready");
    //     }
    //   }, 1000);
    // }
  }, []);

  if (window.hideMovementProgressUi) return null;

  return (
    <div className={styles.inlineUi} style={{ textAlign: "center" }}>
      <p style={{ fontWeight: 600, marginBottom: 8 }}>Movement Test in Progress</p>
      <p style={{ color: "#6b7280", fontSize: "14px" }}>Follow Myra's voice instructions to complete the movement.</p>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 11: SELF-REPORT STEP 1 — ROM COMPARISON
// No-camera path only. Three option cards (Got smaller / Got bigger /
// Stayed the same). No hard stop on this screen.
// Uses explicit startFlow — not standard useScreenVoice flow.
// ════════════════════════════════════════════════════════════════

function SelfReportROMScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const ContainerRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const selectedIdRef = useRef(null);
  const problemArea = assessmentData?.problemArea || "LBP";
  const displayOptions = useMemo(() => getSelfReportRomDisplayOptions(CONST.SELF_REPORT_ROM.options), []);
  const questionText = MYRA_MESSAGES.selfReportRom?.SELF_REPORT_QUESTION || CONST.SELF_REPORT_ROM.heading;
  const subheading = MYRA_MESSAGES.selfReportRom?.subheading || CONST.SELF_REPORT_ROM.subheading;
  VoiceService._currentFlow = "flow_selfreport_compare";
  window.currentFlow = "flow_selfreport_compare";
  if (window?.mayraCode) {
    window.mayraCode?.setIsVisible(false);
  }

  if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
    setMode("voice");
    VoiceService._startListening().catch((err) => {
      setTimeout(() => {
        VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
      }, 2000);
    });
  }

  // Push divider on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      // No Myra chat message — the SR card with heading/subheading serves as the prompt

      await showMyraMessage(MYRA_MESSAGES.selfReportRom.SELF_REPORT_ROM_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(questionText, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);
  const handleSelect = useCallback(
    async (id, source = "tap") => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedId(id);
      selectedIdRef.current = id;
      setLocked(true);

      const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === id);
      const displayOpt = getSelfReportRomDisplayOption(opt);

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "sr_cards", id: nextId(), data: { heading: questionText, options: displayOptions, selectedId: id, subheading } }, { type: "user", text: displayOpt.title, id: nextId() });

      const replyText = MYRA_MESSAGES.selfReportRom?.replyByValue?.[opt.id] || "";
      const continueWithSelection = async () => {
        await showMyraMessage(replyText || MYRA_MESSAGES.selfReportRom?.SELF_REPORT_ROM_POST_TAP || "Thanks for sharing. One more question.", 800);
        onContinue({
          selfReportRom: opt.id,
          selfReportRomPoints: opt.points,
          completed_rom_screen: true,
        });
      };
      if (source !== "tap" && replyText && VoiceService && isVoiceMode) {
        // Wait for speech completion to avoid clipping audio on fast screen transition.
        VoiceService.doSay(replyText, continueWithSelection);
      } else {
        continueWithSelection();
      }
    },
    [onContinue, pushToHistory, showMyraMessage, displayOptions, questionText, subheading, isVoiceMode],
  );

  // Boilerplate only — skip standard flow
  useScreenVoice({
    screenName: "self_report_compare",
    flowName: "flow_selfreport_compare",
    payloadKey: "self_report_compare",
    exitReason: "self_report_rom_completed",
    skipFlow: false,
    commands: {
      SELECT_COMPARE: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("self_report_compare", assessmentData),
    };
    if (isVoiceMode) {
      mayraCode.startFlow("flow_selfreport_compare", "self_report_compare");
    } else {
      VoiceService.startFlowWithoutAnnouncement("flow_selfreport_compare");
    }

    window.currentCommandsAudio = {
      SELECT_COMPARE: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_ROM.options.find((o) => o.id === selectedIdRef.current);
          if (opt) {
            onContinue({ selfReportRom: opt.id, selfReportRomPoints: opt.points });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!ready) return null;

  return (
    <div className={styles.inlineUi2} ref={ContainerRef}>
      {!locked ? (
        <div className={styles.chipPairStack}>
          {displayOptions.map((opt) => (
            <div key={opt.id} className={styles.chipPair}>
              <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(opt.id, "tap")}>
                {opt.title}
              </div>
              {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 12: SELF-REPORT STEP 2 — TEMPO / SPEED
// No-camera path only. Three option cards.
// "Couldn't finish" → safety hard stop.
// Sets cameraUsed: false so backend uses self-report Pillar 4 logic.
// ════════════════════════════════════════════════════════════════

function SelfReportTempoScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, onHardStop, showQuestionNuggetMessage }) {
  const [selectedId, setSelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const selectedIdRef = useRef(null);
  const problemArea = assessmentData?.problemArea || "LBP";
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  if (window?.mayraCode) {
    window.mayraCode?.setIsVisible(false);
  }

  // Push divider on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      // Show Myra message
      await showMyraMessage(MYRA_MESSAGES.selfReportTempo.SELF_REPORT_TEMPO_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(CONST.SELF_REPORT_TEMPO.heading, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = useCallback(
    async (id, source = "tap") => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedId(id);
      selectedIdRef.current = id;
      setLocked(true);

      const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === id);

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "sr_cards", id: nextId(), data: { heading: CONST.SELF_REPORT_TEMPO.heading, options: CONST.SELF_REPORT_TEMPO.options, selectedId: id, subheading: CONST.SELF_REPORT_TEMPO.subheading } }, { type: "user", text: opt.title, id: nextId() });

      // "Couldn't finish" → hard stop, no voice reply
      if (opt.outcome === "HARD_STOP") {
        onHardStop();
        return;
      }

      const replyText = MYRA_MESSAGES.selfReportTempo?.replyByValue?.[opt.id] || "";
      const continueWithSelection = async () => {
        await showMyraMessage(replyText || MYRA_MESSAGES.selfReportTempo?.SELF_REPORT_TEMPO_POST_TAP_CONTINUE || "Thanks — one more question about the movement.", 800);
        onContinue({
          selfReportSpeed: opt.id,
          selfReportPace: opt.id,
          selfReportSpeedPoints: opt.points,
          cameraUsed: false,
          completed_speed_screen: true,
        });
      };
      console.log("source", source);
      if (source !== "tap" && replyText && VoiceService && isVoiceMode) {
        // Wait for speech completion to avoid clipping audio on fast screen transition.
        VoiceService.doSay(replyText, continueWithSelection);
      } else {
        continueWithSelection();
      }
    },
    [onContinue, onHardStop, pushToHistory, showMyraMessage],
  );

  // Boilerplate only — skip standard flow
  useScreenVoice({
    screenName: "self_report_speed",
    flowName: "flow_selfreport_speed",
    payloadKey: "self_report_speed",
    exitReason: "self_report_tempo_completed",
    skipFlow: false,
    commands: {
      SELECT_SPEED: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
            });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
            });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("self_report_speed", assessmentData),
    };
    if (isVoiceMode) {
      mayraCode.startFlow("flow_selfreport_speed", "flow_selfreport_speed");
    } else {
      VoiceService.startFlowWithoutAnnouncement("flow_selfreport_speed");
    }

    window.currentCommandsAudio = {
      SELECT_SPEED: (value) => {
        if (window.exitHandlerOpen) return;
        const normalized = (value || "").toString().trim().toLowerCase();
        console.log("normalized", normalized);
        const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === normalized);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id, "voice_or_chat");
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
            });
          }
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedIdRef.current) {
          const opt = CONST.SELF_REPORT_TEMPO.options.find((o) => o.id === selectedIdRef.current);
          if (opt && opt.outcome !== "HARD_STOP") {
            onContinue({
              selfReportSpeed: opt.id,
              selfReportPace: opt.id,
              selfReportSpeedPoints: opt.points,
              cameraUsed: false,
            });
          }
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please make your selection before we can move to the next screen");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) return null;

  return (
    <>
      <div className={styles.inlineUi2}>
        {!locked ? (
          <div className={styles.chipPairStack}>
            {CONST.SELF_REPORT_TEMPO.options.map((opt) => (
              <div key={opt.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${selectedId === opt.id ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(opt.id, "tap")}>
                  {opt.title}
                </div>
                {/* {opt.subtitle && <div className={styles.chipHelper}>{opt.subtitle}</div>} */}
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
}

// UTILITY: deriveDirectionalChange
// Compares first-half mean vs second-half mean of a per-rep array
// to produce a directional label for the Symptom 1 synthesis.
// Tolerance: ±25% relative change = "same".
// Returns null if input is empty/invalid; caller decides fallback.
// kind: "rom"   → returns "same" | "bigger" | "smaller"
// kind: "tempo" → returns "kept_up" | "slowed_down"
//   (tempo uses rep DURATION; longer late reps = slowed down)
// ════════════════════════════════════════════════════════════════

function deriveDirectionalChange(values, kind) {
  if (!Array.isArray(values) || values.length < 2) return null;

  const half = Math.floor(values.length / 2);
  const firstHalf = values.slice(0, half);
  const secondHalf = values.slice(values.length - half);

  const mean = (arr) => arr.reduce((sum, v) => sum + v, 0) / arr.length;
  const firstMean = mean(firstHalf);
  const secondMean = mean(secondHalf);

  if (firstMean === 0) return kind === "rom" ? "same" : "kept_up";

  const relativeChange = (secondMean - firstMean) / firstMean;
  const TOLERANCE = 0.25;

  if (kind === "rom") {
    if (relativeChange > TOLERANCE) return "bigger";
    if (relativeChange < -TOLERANCE) return "smaller";
    return "same";
  }

  // tempo: secondMean larger than firstMean means later reps took LONGER
  if (kind === "tempo") {
    if (relativeChange > TOLERANCE) return "slowed_down";
    return "kept_up";
  }

  return null;
}

// ════════════════════════════════════════════════════════════════
// AI PROCESSING LOADER
// Shown while Feel Affect waits for backend customSpeech.
// Blocks UI interaction with an overlay.
// ════════════════════════════════════════════════════════════════

function AIProcessingLoader({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div className={styles.msgRowMyra}>
      <div className={styles.msgAvatar}>M</div>
      <div className={styles.typingDots} aria-label="Myra is typing">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 13: RPE (Rate of Perceived Exertion)
// 5 RPE circles (1/3/5/7/9). Uses flow_rpe with manual startFlow.
// Extracts ROM/dur from parseDataAfterInfo() on mount.
// Cleans up window.movementTestPayload.
// ════════════════════════════════════════════════════════════════

function RPEScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [selectedRPE, setSelectedRPE] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const selectedRef = useRef(null);
  const ContainerRef = useRef(null);
  const romDurRef = useRef({ rom: [], dur: [] });
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  if (window?.mayraCode) {
    window.mayraCode?.setIsVisible(false);
  }
  if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
    setMode("voice");
  }

  // Extract ROM/dur on mount and clean up AR config
  useEffect(() => {
    romDurRef.current = parseDataAfterInfo();
    window.movementTestPayload = null;
  }, []);
  const completedTestName = CONST.TEST_MAP[assessmentData?.probableSubtype]?.name || "the movement";
  useEffect(() => {
    if (window?.currnetScreen === "rpe" && ready) {
      if (isVoiceMode) {
        pushToHistory({
          type: "voice-indicator",
          text: `Great job — you completed the ${completedTestName}. Let me ask you a couple of follow-up questions.`,
          id: nextId(),
        });
      }
      window.currnetScreen = "";
    }
  }, [pushToHistory, completedTestName, ready]);

  // Push divider + voice indicator + Myra message on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isVoiceMode) {
        pushToHistory({ type: "voice-indicator", id: nextId() });
      }
      await showMyraMessage(MYRA_MESSAGES.rpe.RPE_SETUP_BEAT_BY_PATH.granted, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.rpe.RPE_QUESTION, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleContinue = useCallback(() => {
    if (selectedRef.current === null || lockedRef.current) return;
    lockedRef.current = true;
    setLocked(true);

    const { rom, dur } = romDurRef.current;
    onContinue({
      rpe: selectedRef.current,
      rom,
      duration: dur,
    });
  }, [onContinue]);

  useScreenVoice({
    screenName: "test1_rpe",
    flowName: "flow_rpe",
    payloadKey: "test1_rpe",
    exitReason: "rpe_completed",
    skipFlow: false,
    commands: {
      SELECT_RPE: (value) => {
        console.log("useScreenVoice: SELECT_RPE");
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        const numVal = parseInt(value);
        // if (isNaN(numVal)) return;

        const responseText = CONST.getRpeResponseText(numVal);
        if (MyraInteraction.getMode() === "voice") {
          VoiceService?.doSay(responseText, () => {
            // setSelectedRPE(numVal);
            // selectedRef.current = numVal;
            handleSelect(numVal);
          });
        } else {
          // setSelectedRPE(numVal);
          // selectedRef.current = numVal;
          handleSelect(numVal);
        }
        // lockedRef.current = true;
        // setLocked(true);
        // VoiceService?.doSay(responseText, () => {
        //   setSelectedRPE(numVal);
        //   selectedRef.current = numVal;
        //   setTimeout(() => {
        //     const { rom, dur } = romDurRef.current;
        //     onContinue({ rpe: numVal, rom, duration: dur });
        //   }, 500);
        // });
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please select how challenging the exercise was before we continue.");
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("test1_rpe", assessmentData),
    };
    VoiceService._currentFlow = "flow_rpe";
    window.currentFlow = "flow_rpe";
    if (isVoiceMode && mayraCode?.startFlow) {
      mayraCode.startFlow("flow_rpe", "rpe");
    } else {
      VoiceService?.startFlowWithoutAnnouncement?.("flow_rpe");
    }

    window.currentCommandsAudio = {
      SELECT_RPE: (value) => {
        console.log("Window currentCommandsAudio : SELECT_RPE");
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        const numVal = parseInt(value);
        // if (isNaN(numVal)) return;

        const responseText = CONST.getRpeResponseText(numVal);
        if (MyraInteraction.getMode() === "voice") {
          VoiceService?.doSay(responseText, () => {
            // setSelectedRPE(numVal);
            // selectedRef.current = numVal;
            handleSelect(numVal);
          });
        } else {
          // setSelectedRPE(numVal);
          // selectedRef.current = numVal;
          handleSelect(numVal);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (selectedRef.current !== null) {
          const { rom, dur } = romDurRef.current;
          onContinue({ rpe: selectedRef.current, rom, duration: dur });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay("Please select how challenging the exercise was before we continue.");
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = useCallback(
    async (val) => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setSelectedRPE(val);
      selectedRef.current = val;
      setLocked(true);

      const label = CONST.RPE_OPTIONS.find((o) => o.value === val)?.label || val;

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "rpe_options", id: nextId(), data: { selectedValue: val } }, { type: "user", text: `Effort: ${label}`, id: nextId() });

      // Confirmation message
      await showMyraMessage(MYRA_MESSAGES.rpe?.RPE_POST_TAP || "Got it. One last question about how that movement affected your symptoms.", 800);

      // Auto-advance
      const { rom, dur } = romDurRef.current;
      onContinue({ rpe: val, rom, duration: dur, submitted_rpe_1: true });
    },
    [onContinue, pushToHistory, showMyraMessage],
  );

  if (!ready) return null;

  return (
    <>
      <div className={styles.inlineUi2} ref={ContainerRef}>
        {!locked ? (
          <div className={styles.chipPairStack}>
            {CONST.RPE_OPTIONS2.map((chip) => (
              <div key={chip.id} className={styles.chipPair}>
                <button className={`${styles.optionCard} ${selectedRPE === chip.value ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(chip.value)}>
                  {chip.label}
                </button>
                {/* <div className={styles.chipHelper}>{chip.helper}</div> */}
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 14: FEEL AFFECT (Symptom Response 1)
// 3 option cards: IMPROVED / TOLERABLE / WORSENED.
// Enriched mayraForwardCode for backend AI analysis.
// AIProcessingLoader with 60s timeout.
// Subtype override/reclassification logic.
// ════════════════════════════════════════════════════════════════
function FeelAffectScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, showQuestionNuggetMessage }) {
  const [symptomResponse, setSymptomResponse] = useState(null);
  const [locked, setLocked] = useState(false);
  const [isAIProcessing, setIsAIProcessing] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const symptomResponseRef = useRef(null);
  const hasContinuedRef = useRef(false);
  const aiCheckRef = useRef(null);
  const aiTimeoutRef = useRef(null);
  const pendingOptRef = useRef(null); // Store opt for when speech arrives
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const aiProcessingTimeoutRef = useRef(null);
  const startAIProcessingTimeout = () => {
    clearTimeout(aiProcessingTimeoutRef.current);

    aiProcessingTimeoutRef.current = setTimeout(() => {
      console.warn("AI processing timeout reached — forcing reset");

      setIsAIProcessing(false);
      pendingOptRef.current = null;
      hasContinuedRef.current = false;
      lockedRef.current = false;
      setLocked(false);
    }, 60000); // 1 minute
  };
  const clearAIProcessingTimeout = () => {
    clearTimeout(aiProcessingTimeoutRef.current);
  };

  const problemArea = assessmentData.problemArea || "LBP";
  const currentSubtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";

  // Push divider + voice indicator + Myra message on mount
  useEffect(() => {
    let cancelled = false;
    async function init() {
      if (isVoiceMode) {
        pushToHistory({ type: "voice-indicator", id: nextId() });
      }
      await showMyraMessage(MYRA_MESSAGES.feelAffect.FEEL_AFFECT_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.feelAffect.FEEL_AFFECT_QUESTION, "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  // Fallback speech by symptom value
  const getFallbackSpeech = useCallback((value) => {
    if (value === "IMPROVED") return "That's great to hear — it tells me a lot about what direction works for you.";
    if (value === "TOLERABLE") return "Thanks for letting me know. That's useful information for building your plan.";
    return "Thanks for telling me — that's actually very useful information. It helps me adjust your classification.";
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      clearInterval(aiCheckRef.current);
      clearTimeout(aiTimeoutRef.current);
      clearTimeout(aiProcessingTimeoutRef.current);
    };
  }, []);

  // Resolve override and routing
  const resolveAndContinue = useCallback(
    async (opt) => {
      if (isVoiceMode && hasContinuedRef.current) return;
      hasContinuedRef.current = true;
      let finalSubtype = currentSubtype;
      let diagnosisChanged = false;
      let degradation = null;
      let timing = null;
      let cpgForBackend = assessmentData.cpgForBackend;
      window.flowSymptomPayload = null;

      if (opt.value === "WORSENED") {
        diagnosisChanged = true;

        if (problemArea === "LBP") {
          finalSubtype = "NEUTRAL_SENSITIVE";
          degradation = "First Test Felt Worse — LBP reclassified to Neutral Sensitive";
        } else {
          const overrideTarget = CONST.CLINICAL_PATHS[problemArea]?.overrideTarget;
          finalSubtype = overrideTarget || currentSubtype;
          degradation = "First Test Felt Worse — reclassified to override target";
          if (CONST.SUBTYPE_TO_CPG_MAP[problemArea]?.[finalSubtype]) {
            cpgForBackend = CONST.SUBTYPE_TO_CPG_MAP[problemArea][finalSubtype];
          }
        }
        timing = "post_test1_symptom";

        // await showMyraMessage(MYRA_MESSAGES.feelAffect?.worsenedOverride || "Thanks for telling me — that's actually very useful information. It helps me adjust your classification. Let's move on to personalizing your plan.", 800);
        onContinue(
          {
            symptomResponse: opt.value,
            symptomResponse1: opt.value,
            diagnosisChanged,
            degradation,
            timing,
            finalPainSubtype: finalSubtype,
            probableSubtype: finalSubtype,
            cpgForBackend,
            wasOverridden: true,
            overrideReason: "First Test Felt Worse",
          },
          "personalize",
        );
        return;
      }

      if (problemArea === "LBP" && currentSubtype === "ROTATIONAL_INTOLERANT" && opt.value === "IMPROVED") {
        finalSubtype = "FLEXION_INTOLERANT";
        diagnosisChanged = true;
        degradation = "Directional Preference Overwrite — positive extension response";
        timing = "post_test1_symptom";

        await showMyraMessage(MYRA_MESSAGES.feelAffect?.rotationalImprovedOverride || "That's great feedback — it tells me a lot about what direction works for you. Let's move on.", 800);
        onContinue(
          {
            symptomResponse: opt.value,
            symptomResponse1: opt.value,
            diagnosisChanged,
            degradation,
            timing,
            finalPainSubtype: finalSubtype,
            probableSubtype: finalSubtype,
            wasOverridden: true,
            overrideReason: degradation,
          },
          "personalize",
        );
        return;
      }

      const finalFields = {
        symptomResponse: opt.value,
        symptomResponse1: opt.value,
        diagnosisChanged,
        degradation,
        timing,
        finalPainSubtype: finalSubtype,
        probableSubtype: diagnosisChanged ? finalSubtype : currentSubtype,
        wasOverridden: diagnosisChanged,
        overrideReason: diagnosisChanged ? degradation : null,
      };

      if (diagnosisChanged && cpgForBackend !== assessmentData.cpgForBackend) {
        finalFields.cpgForBackend = cpgForBackend;
      }

      const test2 = CONST.getNegativeTest(finalSubtype, problemArea);
      window.symptomSpeech = "";
      let leaveMessage = opt.label;
      if (opt.value === "IMPROVED" && test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "IMPROVED" && !test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE" && test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE" && !test2) {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.WORSENED;
      }

      if (test2) {
        const testName = test2.name || "";
        // await showMyraMessage(resolveMessage(leaveMessage || "There's one more movement I'd like you to try — <strong>{testName}</strong>. Let me show you.", { testName }), 800);
        finalFields.rom_test2_started = true;
        onContinue(finalFields, "feedback2");
      } else {
        // await showMyraMessage(leaveMessage || "That's all the movement testing we need. You're doing great — let's wrap things up.", 800);
        onContinue(finalFields, "personalize");
      }
    },
    [currentSubtype, problemArea, assessmentData.cpgForBackend, onContinue, showMyraMessage],
  );

  const showSymptomAckAndContinue = useCallback(
    async (opt, speech) => {
      const isVoiceMode = MyraInteraction.getMode() === "voice";
      clearAIProcessingTimeout();
      setIsAIProcessing(false);

      await showMyraMessage(speech, 800);

      if (isVoiceMode && window.mayraCode) {
        window.mayraCode.doSay(speech, () => {
          resolveAndContinue(opt);
        });
      } else {
        resolveAndContinue(opt);
      }
    },
    [resolveAndContinue, showMyraMessage],
  );

  // Handle the AI processing and speech announcement
  const processWithAI = useCallback(
    (opt, customSpeech) => {
      const isVoiceMode = MyraInteraction.getMode() === "voice";
      const speech = window.symptomSpeech || customSpeech || getFallbackSpeech(opt.value);

      console.log("🤖 processWithAI called:", {
        mode: isVoiceMode ? "voice" : "chat",
        hasSpeech: !!customSpeech,
        value: opt.value,
      });
      setIsAIProcessing(true);
      startAIProcessingTimeout();

      // Announce the AI processing message
      const processingMessage = "Thanks for your effort — let me take a moment to look at your results.";
      // VoiceService?.doSay(processingMessage);

      setTimeout(() => {
        showSymptomAckAndContinue(opt, speech);
      }, 500);
    },
    [getFallbackSpeech, showSymptomAckAndContinue],
  );
  const announceAndContinue = useCallback(
    (opt, customSpeech) => {
      // if (hasContinuedRef.current) return;

      setIsAIProcessing(true);
      startAIProcessingTimeout();
      const speech = window.symptomSpeech || customSpeech || getFallbackSpeech(opt.value);

      showSymptomAckAndContinue(opt, speech);
    },
    [getFallbackSpeech, showSymptomAckAndContinue],
  );

  const handleSelect = useCallback(
    (id) => {
      if (lockedRef.current || isAIProcessing) return;
      lockedRef.current = true;
      setLocked(true);

      const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.id === id);
      setSymptomResponse(opt.value);
      symptomResponseRef.current = opt.value;

      // STORE the opt for potential async speech - UNCOMMENT THIS
      pendingOptRef.current = opt;

      const symptomData = {
        type: "symptom_selection",
        data: { action: "SELECT_SYMPTOM", value: opt.value },
      };
      if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify(symptomData));
        console.log(symptomData);
      } else {
        VoiceService.startFlowWithoutAnnouncement("flow_symptom");
        setTimeout(() => {
          if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
            VoiceService._ws.send(JSON.stringify(symptomData));
          }
        }, 1000);
        console.error("WebSocket not connected");
      }

      // Push frozen widget + user echo - UNCOMMENT THIS
      let leaveMessage = opt.label;
      if (opt.value === "IMPROVED") {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.IMPROVED_HAS_TEST_2;
      } else if (opt.value === "TOLERABLE") {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.TOLERABLE_HAS_TEST_2;
      } else {
        leaveMessage = MYRA_MESSAGES.feelAffect.FEEL_AFFECT_CLOSE_BY_OUTCOME.WORSENED;
      }
      pushToHistory(
        {
          type: "frozen-widget",
          widgetType: "affect_options",
          id: nextId(),
          data: { selectedValue: opt.value },
        },
        { type: "user", text: opt.label, id: nextId() },
      );

      // Set timeout for fallback speech
      setTimeout(() => {
        if (pendingOptRef.current && !hasContinuedRef.current) {
          console.log("Using fallback speech for:", pendingOptRef.current.value);
          announceAndContinue(pendingOptRef.current, null);
          pendingOptRef.current = null;
        }
      }, 5000);
    },
    [isAIProcessing, pushToHistory, announceAndContinue],
  );
  // useScreenVoice for boilerplate only — flow handled manually
  useScreenVoice({
    screenName: "test1_symptoms",
    trackerName: "symptom1",
    flowName: "flow_symptom",
    payloadKey: "test1_symptoms",
    exitReason: "symptom1_completed",
    skipFlow: false,
    commands: {
      SELECT_SYMPTOM: (value, speech, intent) => {
        console.log("SELECT_SYMPTOM triggered with:", { value, speech, intent });

        if (window.exitHandlerOpen) return;

        // If we have speech from backend, use it
        if (speech && pendingOptRef.current) {
          // Clear the timeout since we got speech
          if (window._speechTimeout) {
            clearTimeout(window._speechTimeout);
            window._speechTimeout = null;
          }
          // Process with the custom speech
          processWithAI(pendingOptRef.current, speech);
          pendingOptRef.current = null;
          return;
        }

        const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === value || o.id === value);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        } else {
          if (isVoiceMode) {
            window.VoiceService?.doSay("Please select how the movement made your symptoms feel.");
          }
        }
      },
    },
  });

  // Manual flow start with enriched mayraForwardCode
  const flowStartedRef = useRef(false);

  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;
    if (flowStartedRef.current) return;
    if (assessmentData?.rpe == null) return;

    const { rom, dur } = parseDataAfterInfo();
    const romValues = rom || [];
    const durValues = dur || [];
    let romChange;
    let tempoChange;

    if (assessmentData.cameraUsed === false) {
      const romAnswer = assessmentData.selfReportRom;
      if (romAnswer === "rom_bigger") romChange = "bigger";
      else if (romAnswer === "rom_smaller") romChange = "smaller";
      else romChange = "same";

      const tempoAnswer = assessmentData.selfReportSpeed;
      if (tempoAnswer === "tempo_slower") tempoChange = "slowed_down";
      else tempoChange = "kept_up";
    } else {
      // Camera path: compute from per-rep data captured during Movement Test 1.
      const { rom, dur } = parseDataAfterInfo();
      romChange = deriveDirectionalChange(rom || [], "rom") || "same";
      tempoChange = deriveDirectionalChange(dur || [], "tempo") || "kept_up";
    }

    // Data source for the Claude synthesis prompt: "camera" when the camera
    // tracked the movement, "self_report" when the user answered questions.
    const dataSource = assessmentData.cameraUsed === false ? "self_report" : "camera";
    let whatsNext = /* TODO: source whats_next */ "personalize"; // this will resend after user makes a choise and backend will update it

    window.mayraForwardCode = {
      romChange,
      tempoChange,
      data_source: dataSource,
      whats_next: whatsNext,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
      midjourneyData: generatePayloadForScreen("test1_symptoms", assessmentData),
      symptomType: "initial",
    };
    window.flowSymptomPayload = {
      romChange,
      tempoChange,
      data_source: dataSource,
      whats_next: whatsNext,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
      midjourneyData: generatePayloadForScreen("test1_symptoms", assessmentData),
      symptomType: true,
    };

    if (isVoiceMode && mayraCode.startFlow) {
      mayraCode.startFlow("flow_symptom", "symptom1");
    } else {
      VoiceService?.startFlowWithoutAnnouncement?.("flow_symptom");
    }

    window.currentCommandsAudio = {
      SELECT_SYMPTOM: (value, speech, intent) => {
        console.log("SELECT_SYMPTOM triggered with:", { value, speech, intent });
        if (window.exitHandlerOpen) return;

        // If we have speech from backend, use it
        if (speech && pendingOptRef.current) {
          if (window._speechTimeout) {
            clearTimeout(window._speechTimeout);
            window._speechTimeout = null;
          }
          processWithAI(pendingOptRef.current, speech);
          pendingOptRef.current = null;
          return;
        }

        const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === value || o.id === value);
        if (opt && !lockedRef.current) {
          handleSelect(opt.id);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command" && symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (symptomResponseRef.current) {
          const opt = CONST.FEEL_AFFECT_OPTIONS.find((o) => o.value === symptomResponseRef.current);
          if (opt) resolveAndContinue(opt);
        } else {
          if (isVoiceMode) {
            window.VoiceService?.doSay("Please select how the movement made your symptoms feel.");
          }
        }
      },
    };

    flowStartedRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentData?.rpe, assessmentData?.selectedZones, assessmentData?.symptomDuration, assessmentData?.painLevel, assessmentData?.cpgForBackend, assessmentData?.probableSubtype, assessmentData?.problemArea, isVoiceMode, handleSelect, processWithAI, resolveAndContinue]);

  if (!ready) return null;

  return (
    <>
      {!locked ? (
        <div className={styles.inlineUi2}>
          <div className={styles.chipPairStack}>
            {CONST.FEEL_AFFECT_OPTIONS.map((o) => (
              <div key={o.id} className={styles.chipPair}>
                <div className={`${styles.optionCard} ${symptomResponse === o.value ? styles.selected : ""} ${locked ? styles.locked : ""}`} onClick={() => handleSelect(o.id)}>
                  {o.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <AIProcessingLoader isVisible={isAIProcessing} />
    </>
  );
}
// ════════════════════════════════════════════════════════════════
// SCREEN 17: FEEDBACK 2 (Symptom Response 2)
// Single screen: Myra setup → question → inline Test 2 demo video → 3 option cards.
// Three buttons (Can't even try / Felt Worse / Felt Better) → two outcomes (WORSE / BETTER).
// Uses flow_symptom / symptom2.
// ════════════════════════════════════════════════════════════════

function Feedback2Screen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [feedback2SelectedId, setFeedback2SelectedId] = useState(null);
  const [locked, setLocked] = useState(false);
  const [ready, setReady] = useState(false);
  const lockedRef = useRef(false);
  const feedback2ResponseRef = useRef(null);
  const feedback2SelectedIdRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const ContainerRef = useRef(null);
  const videoRef = useRef(null);

  // Resolve test 1 + test 2 names and the plain-language description for test 2
  const subtype = assessmentData.probableSubtype || assessmentData.finalPainSubtype || "NEUTRAL_SENSITIVE";
  const problemArea = assessmentData.problemArea || "LBP";
  const test1Name = CONST.TEST_MAP[subtype]?.name || "the first movement";
  const test2 = CONST.getNegativeTest(subtype, problemArea);
  const test2Name = test2?.name || "";
  const test2Description = CONST.TEST_PLAIN_DESCRIPTIONS?.[test2Name] || "do this movement";
  const introVideoUrl = CONST.TEST_INTRO_VIDEOS?.[test2Name] || test2?.video || "";

  if (window?.mayraCode) {
    window.mayraCode?.setIsVisible(false);
  }
  if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
    setMode("voice");
  }

  // ── Push setup + question on mount ──
  useEffect(() => {
    let cancelled = false;
    async function init() {
      await showMyraMessage(MYRA_MESSAGES.feedback2.FEEDBACK_2_SETUP_BEAT, 800);
      await showQuestionNuggetMessage(resolveMessage(MYRA_MESSAGES.feedback2.FEEDBACK_2_QUESTION, { test1Name, test2Description }), "", 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = useCallback(
    async (id, speech) => {
      if (lockedRef.current) return;
      lockedRef.current = true;
      setLocked(true);

      const opt = CONST.FEEDBACK2_OPTIONS.find((o) => o.id === id);
      if (!opt) return;
      setFeedback2SelectedId(opt.id);
      feedback2SelectedIdRef.current = opt.id;
      feedback2ResponseRef.current = opt.value;

      // Pause + clean the inline demo video
      if (videoRef.current) {
        try {
          videoRef.current.pause();
          videoRef.current.removeAttribute("src");
          videoRef.current.load();
        } catch (e) {
          // ignore
        }
      }

      // Push frozen widget + user echo
      pushToHistory({ type: "frozen-widget", widgetType: "feedback2", id: nextId(), data: { selectedId: opt.id, selectedValue: opt.value } }, { type: "user", text: getFeedback2OptionLabel(opt), id: nextId() });

      const ackText = (typeof speech === "string" && speech.trim()) || MYRA_MESSAGES.feedback2?.FEEDBACK_2_ACK || "That locks it in. Let's personalize your plan.";
      if (isVoiceMode && window.mayraCode) {
        window.mayraCode.doSay(ackText);
      }
      await showMyraMessage(ackText, 700);

      const { rom, dur } = parseDataAfterInfo();
      onContinue({
        symptomResponseConfirm: opt.value,
        rom2: rom,
        duration2: dur,
        rom_test2_completed: true,
        submitted_symptoms_2: true,
      });
    },
    [onContinue, showMyraMessage, isVoiceMode, pushToHistory],
  );

  // useScreenVoice for boilerplate only — flow handled manually
  useScreenVoice({
    screenName: "symptom2",
    flowName: "flow_symptom",
    payloadKey: "symptom2",
    exitReason: "feedback2_completed",
    skipFlow: false,
    commands: {
      SELECT_SYMPTOM: (value, speech) => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        // Normalize: voice may send WORSENED/TOLERABLE/IMPROVED from shared command, or CANNOT_TRY from newer training data
        const normalized = value === "CANNOT_TRY" ? "CANNOT_TRY" : value === "WORSENED" || value === "WORSE" ? "WORSE" : "BETTER";
        const opt = normalized === "CANNOT_TRY" ? CONST.FEEDBACK2_OPTIONS.find((o) => o.id === "fb2-cant-try") : normalized === "WORSE" ? CONST.FEEDBACK2_OPTIONS.find((o) => o.id === "fb2-worse") : CONST.FEEDBACK2_OPTIONS.find((o) => o.value === normalized);
        if (opt) {
          handleSelect(opt.id, speech);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        if (value === "continue_command" && feedback2ResponseRef.current) {
          const { rom, dur } = parseDataAfterInfo();
          onContinue({
            symptomResponseConfirm: feedback2ResponseRef.current,
            rom2: rom,
            duration2: dur,
            rom_test2_completed: true,
            submitted_symptoms_2: true,
          });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        if (feedback2ResponseRef.current) {
          const { rom, dur } = parseDataAfterInfo();
          onContinue({
            symptomResponseConfirm: feedback2ResponseRef.current,
            rom2: rom,
            duration2: dur,
            rom_test2_completed: true,
            submitted_symptoms_2: true,
          });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay(MYRA_MESSAGES.feedback2.noSelectionPrompt);
          }
        }
      },
    },
  });

  // Manual flow start + command registration
  useEffect(() => {
    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    window.mayraForwardCode = {
      midjourneyData: generatePayloadForScreen("symptom2", assessmentData),
    };
    if (isVoiceMode) {
      mayraCode.startFlow("flow_symptom", "symptom2");
    } else {
      VoiceService?.startFlowWithoutAnnouncement?.("flow_symptom");
    }

    window.currentCommandsAudio = {
      SELECT_SYMPTOM: (value, speech) => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        const normalized = value === "CANNOT_TRY" ? "CANNOT_TRY" : value === "WORSENED" || value === "WORSE" ? "WORSE" : "BETTER";
        const opt = normalized === "CANNOT_TRY" ? CONST.FEEDBACK2_OPTIONS.find((o) => o.id === "fb2-cant-try") : normalized === "WORSE" ? CONST.FEEDBACK2_OPTIONS.find((o) => o.id === "fb2-worse") : CONST.FEEDBACK2_OPTIONS.find((o) => o.value === normalized);
        if (opt) {
          handleSelect(opt.id, speech);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        if (value === "continue_command" && feedback2ResponseRef.current) {
          const { rom, dur } = parseDataAfterInfo();
          onContinue({
            symptomResponseConfirm: feedback2ResponseRef.current,
            rom2: rom,
            duration2: dur,
            rom_test2_completed: true,
            submitted_symptoms_2: true,
          });
        }
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        if (lockedRef.current) return;
        if (feedback2ResponseRef.current) {
          const { rom, dur } = parseDataAfterInfo();
          onContinue({
            symptomResponseConfirm: feedback2ResponseRef.current,
            rom2: rom,
            duration2: dur,
            rom_test2_completed: true,
            submitted_symptoms_2: true,
          });
        } else {
          if (isVoiceMode) {
            VoiceService?.doSay(MYRA_MESSAGES.feedback2.noSelectionPrompt);
          }
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!ready) return null;

  return (
    <div className={styles.inlineUi2} ref={ContainerRef}>
      {!locked ? (
        <>
          {introVideoUrl ? (
            <div className={styles.videoContainer}>
              <video ref={videoRef} src={introVideoUrl} controls playsInline preload="metadata" />
            </div>
          ) : null}
          <div className={styles.feedback2Options}>
            {CONST.FEEDBACK2_OPTIONS.map((o) => (
              <div key={o.id} className={`${styles.feedback2Btn} ${feedback2SelectedId === o.id ? styles.selected : ""}`} onClick={() => handleSelect(o.id)}>
                {getFeedback2OptionLabel(o)}
              </div>
            ))}
          </div>
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// HARD STOP SCREEN
// Safety termination — hides Myra, shows empathy + recommendation.
// Triggered by: safety symptoms, Test 1 pain, "couldn't finish".
// ════════════════════════════════════════════════════════════════

function HardStopScreen({ source, pushToHistory, showMyraMessage, scrollToBottom }) {
  const [rendered, setRendered] = useState(false);
  const isVoiceMode = MyraInteraction.getMode() === "voice";

  useEffect(() => {
    window.mayraCode?.setIsVisible(false);
    window.mayraCode?.forceStop();

    // Speak empathy message
    const empathyMap = {
      safety: MYRA_MESSAGES.hardStop?.safety?.empathy || "Your safety is my top priority.",
      test1_pain: MYRA_MESSAGES.hardStop?.test1Pain?.empathy || "I'm glad you told me about the pain.",
      couldnt_finish: MYRA_MESSAGES.hardStop?.couldntFinish?.empathy || "No worries at all — that's important information.",
    };
    const speech = empathyMap[source] || empathyMap.safety;
    if (isVoiceMode) {
      VoiceService?.doSay(speech);
    }

    // Screen tracking
    MyraInteraction?.onScreenEnter?.("hard_stop");
    window.screenTracker?.enterScreen("hard_stop");

    // Push conversation entries
    let cancelled = false;
    async function init() {
      await showMyraMessage(speech, 900);
      if (cancelled) return;

      const detailMap = {
        safety: MYRA_MESSAGES.hardStop?.safety?.detail || "Based on what you've shared, I'd strongly recommend seeing a healthcare provider before starting an exercise program. They can evaluate your symptoms and let you know when it's safe to proceed.",
        test1_pain: MYRA_MESSAGES.hardStop?.test1Pain?.detail || "Experiencing pain during that movement tells me we should take a different approach. I'd recommend seeing a healthcare provider who can evaluate things in person.",
        couldnt_finish: MYRA_MESSAGES.hardStop?.couldntFinish?.detail || "Not being able to complete the movement tells me this might need a more hands-on approach. I'd recommend seeing a healthcare provider who can work with you directly.",
      };
      const detail = detailMap[source] || detailMap.safety;

      // Push hard stop card as frozen widget
      pushToHistory({ type: "frozen-widget", widgetType: "hard_stop_card", id: nextId(), data: { detail } });

      await _delay(600);
      if (cancelled) return;

      const followUp = MYRA_MESSAGES.hardStop?.followUp || "I know this isn't the outcome you were hoping for. If you have any questions about what this means or what to expect from an in-person visit, I'm here — just ask.";
      await showMyraMessage(followUp, 800);
      if (!cancelled) setRendered(true);
    }
    init();

    return () => {
      cancelled = true;
      window.screenTracker?.exitScreen("hard_stop", { exitReason: "hard_stop_viewed" });
    };
  }, [source]);

  // No live content needed — everything is in conversation history
  // Input bar stays active so the user can chat with Myra
  return null;
}

// ════════════════════════════════════════════════════════════════
// SCREEN 18: PERSONALIZE
// Grouped form fields (basics, capacity, preferences).
// Group-by-group with Skip/Next per group. Fully skippable.
// Mode-specific flow routing.
// ════════════════════════════════════════════════════════════════

function PersonalizeScreen({ assessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue, setMode, showQuestionNuggetMessage }) {
  const [formData, setFormData] = useState({});
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [ready, setReady] = useState(false);
  const flowStartedRef = useRef(false);
  const initRef = useRef(false);
  const ContainerRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const validSymptomDurations = ["ACUTE", "SUBACUTE", "CHRONIC"];
  window.test2AnnounceSkipped = false;
  if (MyraInteraction && MyraInteraction?.getMode() === "voice") {
    setMode("voice");
  }

  // Close AR camera stream if still open
  useEffect(() => {
    window.closeStream?.();
  }, []);

  // ── Spec 1: pre-fill formData and selectedGoals on mount ──
  // Hydrates fields opportunistically captured during landing chat (or any
  // earlier mid-GSA voice extraction) so the user sees their answers
  // already filled in. Field-name remap matches the voice-extraction
  // handler at lines 6178–6188 (weightLbs → weight, activityLevel →
  // activity, symptomDuration → duration). preExistingConditions and
  // currentConditions are written even though the form has no UI for
  // them — they flow through onContinue → backend regardless.
  const prefillRef = useRef(false);
  useEffect(() => {
    if (prefillRef.current) return;
    prefillRef.current = true;

    const condRaw = localStorage.getItem("userCondition");
    const cond = condRaw ? JSON.parse(condRaw) : {};
    const userConds = cond.usercondition || { pre_existing: [], current: [] };

    const prefill = {};
    if (assessmentData.age) prefill.age = String(assessmentData.age);
    if (assessmentData.weightLbs || assessmentData.weight) prefill.weight = String(assessmentData.weightLbs || assessmentData.weight);
    if (assessmentData.heightFt) prefill.heightFt = String(assessmentData.heightFt);
    if (assessmentData.heightIn) prefill.heightIn = String(assessmentData.heightIn);
    if (assessmentData.activityLevel || assessmentData.activity) prefill.activity = assessmentData.activityLevel || assessmentData.activity;
    const symptomDuration = assessmentData.symptomDuration || (typeof assessmentData.duration === "string" ? assessmentData.duration : null);
    if (validSymptomDurations.includes(symptomDuration)) prefill.duration = symptomDuration;
    if (assessmentData.balance) prefill.balance = assessmentData.balance;
    if (assessmentData.floorCapability) prefill.floorCapability = assessmentData.floorCapability;
    if (userConds.pre_existing?.length) prefill.preExistingConditions = userConds.pre_existing.join(", ");
    if (userConds.current?.length) prefill.currentConditions = userConds.current.join(", ");

    console.log(" duration", assessmentData.duration, "symptomDuration", assessmentData.symptomDuration, prefill.duration);
    if (Object.keys(prefill).length > 0) {
      setFormData((prev) => ({ ...prev, ...prefill }));
    }

    if (assessmentData.goals && Array.isArray(assessmentData.goals) && assessmentData.goals.length > 0) {
      setSelectedGoals(assessmentData.goals);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useScreenVoice for boilerplate — flow handled manually
  // exitReason handled manually in finishPersonalize (dynamic based on skip vs complete)
  useScreenVoice({
    screenName: "personalize",
    flowName: "flow_personalized",
    payloadKey: "personalize",
    skipFlow: false,
    commands: {
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleNext();
      },
      FORM_QUESTION: () => {
        if (window.exitHandlerOpen) return;
        const missing = getMissingFields();
        if (isVoiceMode) {
          VoiceService?.doSay(`Please enter ${missing}.`);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;

        // Handle continue command
        if (intent === "continue_command" || value === "continue_command") {
          handleNext();
          return;
        }

        // Handle extracted data
        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          // Update formData state (not demographics - this screen uses formData)
          setFormData((prev) => {
            const updates = {};
            const fieldMappings = {
              age: "age",
              weightLbs: "weight",
              heightFt: "heightFt",
              heightIn: "heightIn",
              activityLevel: "activity",
              symptomDuration: "duration",
              balance: "balance",
              preExistingConditions: "preExistingConditions",
              currentConditions: "currentConditions",
            };

            Object.entries(fieldMappings).forEach(([extractedKey, formKey]) => {
              if (extracted[extractedKey] !== undefined && extracted[extractedKey] !== null) {
                updates[formKey] = extracted[extractedKey];
                console.log(`[VOICE] Updating ${formKey} to:`, extracted[extractedKey]);
              }
            });

            return { ...prev, ...updates };
          });

          // Handle goals - convert from string values to the expected object format
          if (extracted.goals) {
            const goalTextMap = {
              reduce_pain: "Reduce Pain",
              less_stiff: "Reduce Stiffness",
              improve_strength: "Improve Strength",
              improve_flexibility: "Improve Flexibility",
              daily_tasks: "Make Daily Tasks Easier",
              balance: "Improve Balance & Stability",
              picking_up: "Picking Up Things",
              sleep: "Improve Sleep Quality",
              walking: "Improve Walking & Endurance",
              lifting: "Make Bending & Lifting Easier",
              posture: "Improve Sitting & Standing Posture",
              rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
              overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
              running: "Running, Cycling, etc.",
              fitness: "Fitness: Gym, CrossFit, etc.",
            };

            const goalsArray = Array.isArray(extracted.goals) ? extracted.goals : [extracted.goals];
            const formattedGoals = goalsArray
              .filter((goalValue) => goalTextMap[goalValue])
              .map((goalValue) => ({
                value: goalValue,
                text: goalTextMap[goalValue],
              }));

            if (formattedGoals.length > 0) {
              setSelectedGoals(formattedGoals);
              // Also mark goals as filled in formData
              setFormData((prev) => ({ ...prev, goals: true }));
              console.log("[VOICE] Updating goals to:", formattedGoals);
            }
          }
        }

        // Handle condition disclosure
        if (intent === "condition_disclosure") {
          const conditions = JSON.parse(localStorage.getItem("userCondition") || "{}");
          localStorage.setItem("userCondition", JSON.stringify(conditions));
        }
      },
      FIELD_SKIPPED: (value, speech, intent, extracted) => {
        VoiceService.resetAssembly();
      },
      GIVE_AGE: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        // Process all actions in the batch (user may say age + weight + height together)
        allActions.forEach((a) => {
          if (a.action === "GIVE_AGE" && a.value != null) handleFieldChange("age", String(a.value));
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_WEIGHT: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_FT: (value, speech, intent, extracted, actionValue, actions) => {
        // Height ft and inches often come together in one batch
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_IN: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      // ── Option selectors ──

      SELECT_ACTIVITY_LEVEL: (value, speech, intent, extracted, actionValue) => {
        // PERSONALIZE_GROUPS uses the enum value directly: "SEDENTARY", "LIGHTLY_ACTIVE", etc.
        const validValues = ["SEDENTARY", "LIGHTLY_ACTIVE", "ACTIVE", "VERY_ACTIVE"];
        if (actionValue && validValues.includes(actionValue)) handleFieldChange("activity", actionValue, true);
      },

      SELECT_FLOOR_CAPABILITY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "YES" ? "yes" : actionValue === "NO" ? "no" : null;
        if (mapped) handleFieldChange("floorCapability", mapped);
      },

      SELECT_BALANCE: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "STEADY" ? "steady" : actionValue === "UNSTEADY" ? "unsteady" : null;
        if (mapped) handleFieldChange("balance", mapped);
      },

      // ── Goals — can fire multiple in one batch ──
      SELECT_GOAL: (value, speech, intent, extracted, actionValue, actions) => {
        const GOAL_MAP = {
          REDUCE_PAIN: "reduce_pain",
          LESS_STIFF: "less_stiff",
          IMPROVE_STRENGTH: "improve_strength",
          IMPROVE_FLEXIBILITY: "improve_flexibility",
          DAILY_TASKS: "daily_tasks",
          BALANCE: "balance",
          PICKING_UP: "picking_up",
          SLEEP: "sleep",
          WALKING: "walking",
          LIFTING: "lifting",
          POSTURE: "posture",
          ROTATIONAL_SPORTS: "rotational_sports",
          OVERHEAD_SPORTS: "overhead_sports",
          RUNNING: "running",
          FITNESS: "fitness",
        };

        const allActions = actions || [];
        const goalActions = allActions.filter((a) => a.action === "SELECT_GOAL");
        const newGoalValues = goalActions.map((a) => GOAL_MAP[a.value]).filter(Boolean);

        if (newGoalValues.length === 0) return;

        // selectedGoals stores raw value strings (e.g. "reduce_pain"), toggleGoal checks prev.includes(goalValue)
        setSelectedGoals((prev) => {
          const existingSet = new Set(prev);
          const toAdd = newGoalValues.filter((v) => !existingSet.has(v));
          return [...prev, ...toAdd];
        });
        setFormData((prev) => ({ ...prev, goals: true }));
      },

      SELECT_FREQUENCY: (value, speech, intent, extracted, actionValue) => {
        // scheduleDays options use string values: "2", "3", "4", "5", "6", "7"
        const days = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if (!isNaN(days) && days >= 2 && days <= 7) handleFieldChange("scheduleDays", String(days));
      },

      SELECT_DURATION_MINUTES: (value, speech, intent, extracted, actionValue) => {
        // scheduleTime options use string values: "10", "15", "20"
        const minutes = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if ([10, 15, 20].includes(minutes)) handleFieldChange("scheduleTime", String(minutes));
      },

      SELECT_SESSIONS_PER_DAY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "ONE" ? "one" : actionValue === "MULTIPLE" ? "multiple" : null;
        if (mapped) handleFieldChange("sessionPref", mapped);
      },
      SELECT_DURATION: (value, speech, intent, extracted, actionValue) => {
        const validDurations = ["ACUTE", "CHRONIC", "SUBACUTE"];
        if (validDurations.includes(actionValue)) {
          handleFieldChange("duration", actionValue);
        }
      },
    },
  });

  // Mode-specific flow start
  useEffect(() => {
    if (flowStartedRef.current) return;
    flowStartedRef.current = true;

    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    const mode = MyraInteraction?.getCurrentMode?.();
    const payload = generatePayloadForScreen("personalize", assessmentData);

    if (mode === "voice") {
      window.mayraForwardCode = { midjourneyData: payload };
      mayraCode.startFlow("flow_personalized", "personalized");
    } else if (mode === "chat") {
      const chatAnnouncement = "Let's personalize your plan. I'll need a few details about you.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_personalized");
      MyraInteraction?.onMyraMessage?.(chatAnnouncement);
    } else {
      const buttonAnnouncement = "Let's personalize your plan. I'll need a few details about you.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_personalized");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Command registration
  useEffect(() => {
    window.currentCommandsAudio = {
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        handleNext();
      },
      FORM_QUESTION: () => {
        if (window.exitHandlerOpen) return;
        const missing = getMissingFields();
        if (isVoiceMode) {
          VoiceService?.doSay(`Please enter ${missing}.`);
        }
      },
      FIELD_SKIPPED: (value, speech, intent, extracted) => {
        VoiceService.resetAssembly();
        handleNext();
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;

        // Handle continue command
        if (intent === "continue_command" || value === "continue_command") {
          handleNext();
          return;
        }

        // Handle extracted data
        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          // Update formData state (not demographics - this screen uses formData)
          setFormData((prev) => {
            const updates = {};
            const fieldMappings = {
              age: "age",
              weightLbs: "weight",
              heightFt: "heightFt",
              heightIn: "heightIn",
              activityLevel: "activity",
              symptomDuration: "duration",
              preExistingConditions: "preExistingConditions",
              currentConditions: "currentConditions",
            };

            Object.entries(fieldMappings).forEach(([extractedKey, formKey]) => {
              if (extracted[extractedKey] !== undefined && extracted[extractedKey] !== null) {
                updates[formKey] = extracted[extractedKey];
                console.log(`[VOICE] Updating ${formKey} to:`, extracted[extractedKey]);
              }
            });

            return { ...prev, ...updates };
          });

          // Handle goals - convert from string values to the expected object format
          if (extracted.goals) {
            const goalTextMap = {
              reduce_pain: "Reduce Pain",
              less_stiff: "Reduce Stiffness",
              improve_strength: "Improve Strength",
              improve_flexibility: "Improve Flexibility",
              daily_tasks: "Make Daily Tasks Easier",
              balance: "Improve Balance & Stability",
              picking_up: "Picking Up Things",
              sleep: "Improve Sleep Quality",
              walking: "Improve Walking & Endurance",
              lifting: "Make Bending & Lifting Easier",
              posture: "Improve Sitting & Standing Posture",
              rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
              overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
              running: "Running, Cycling, etc.",
              fitness: "Fitness: Gym, CrossFit, etc.",
            };

            const goalsArray = Array.isArray(extracted.goals) ? extracted.goals : [extracted.goals];
            const formattedGoals = goalsArray
              .filter((goalValue) => goalTextMap[goalValue])
              .map((goalValue) => ({
                value: goalValue,
                text: goalTextMap[goalValue],
              }));

            if (formattedGoals.length > 0) {
              setSelectedGoals(formattedGoals);
              // Also mark goals as filled in formData
              setFormData((prev) => ({ ...prev, goals: true }));
              console.log("[VOICE] Updating goals to:", formattedGoals);
            }
          }
        }

        // Handle condition disclosure
        if (intent === "condition_disclosure") {
          const conditions = JSON.parse(localStorage.getItem("userCondition") || "{}");
          localStorage.setItem("userCondition", JSON.stringify(conditions));
        }
      },
      GIVE_AGE: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        // Process all actions in the batch (user may say age + weight + height together)
        allActions.forEach((a) => {
          if (a.action === "GIVE_AGE" && a.value != null) handleFieldChange("age", String(a.value));
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_WEIGHT: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_WEIGHT" && a.value != null) handleFieldChange("weight", String(a.value));
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_FT: (value, speech, intent, extracted, actionValue, actions) => {
        // Height ft and inches often come together in one batch
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_FT" && a.value != null) handleFieldChange("heightFt", String(a.value));
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      GIVE_HEIGHT_IN: (value, speech, intent, extracted, actionValue, actions) => {
        const allActions = actions || [];
        allActions.forEach((a) => {
          if (a.action === "GIVE_HEIGHT_IN" && a.value != null) handleFieldChange("heightIn", String(a.value));
        });
      },

      // ── Option selectors ──

      SELECT_ACTIVITY_LEVEL: (value, speech, intent, extracted, actionValue) => {
        // PERSONALIZE_GROUPS uses the enum value directly: "SEDENTARY", "LIGHTLY_ACTIVE", etc.
        const validValues = ["SEDENTARY", "LIGHTLY_ACTIVE", "ACTIVE", "VERY_ACTIVE"];
        if (actionValue && validValues.includes(actionValue)) handleFieldChange("activity", actionValue, true);
      },

      SELECT_FLOOR_CAPABILITY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "YES" ? "yes" : actionValue === "NO" ? "no" : null;
        if (mapped) handleFieldChange("floorCapability", mapped);
      },

      SELECT_BALANCE: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "STEADY" ? "steady" : actionValue === "UNSTEADY" ? "unsteady" : null;
        if (mapped) handleFieldChange("balance", mapped);
      },

      // ── Goals — can fire multiple in one batch ──
      SELECT_GOAL: (value, speech, intent, extracted, actionValue, actions) => {
        const GOAL_MAP = {
          REDUCE_PAIN: "reduce_pain",
          LESS_STIFF: "less_stiff",
          IMPROVE_STRENGTH: "improve_strength",
          IMPROVE_FLEXIBILITY: "improve_flexibility",
          DAILY_TASKS: "daily_tasks",
          BALANCE: "balance",
          PICKING_UP: "picking_up",
          SLEEP: "sleep",
          WALKING: "walking",
          LIFTING: "lifting",
          POSTURE: "posture",
          ROTATIONAL_SPORTS: "rotational_sports",
          OVERHEAD_SPORTS: "overhead_sports",
          RUNNING: "running",
          FITNESS: "fitness",
        };

        const allActions = actions || [];
        const goalActions = allActions.filter((a) => a.action === "SELECT_GOAL");
        const newGoalValues = goalActions.map((a) => GOAL_MAP[a.value]).filter(Boolean);

        if (newGoalValues.length === 0) return;

        // selectedGoals stores raw value strings (e.g. "reduce_pain"), toggleGoal checks prev.includes(goalValue)
        setSelectedGoals((prev) => {
          const existingSet = new Set(prev);
          const toAdd = newGoalValues.filter((v) => !existingSet.has(v));
          return [...prev, ...toAdd];
        });
        setFormData((prev) => ({ ...prev, goals: true }));
      },

      SELECT_FREQUENCY: (value, speech, intent, extracted, actionValue) => {
        // scheduleDays options use string values: "2", "3", "4", "5", "6", "7"
        const days = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if (!isNaN(days) && days >= 2 && days <= 7) handleFieldChange("scheduleDays", String(days));
      },

      SELECT_DURATION_MINUTES: (value, speech, intent, extracted, actionValue) => {
        // scheduleTime options use string values: "10", "15", "20"
        const minutes = typeof actionValue === "number" ? actionValue : parseInt(actionValue);
        if ([10, 15, 20].includes(minutes)) handleFieldChange("scheduleTime", String(minutes));
      },

      SELECT_SESSIONS_PER_DAY: (value, speech, intent, extracted, actionValue) => {
        const mapped = actionValue === "ONE" ? "one" : actionValue === "MULTIPLE" ? "multiple" : null;
        if (mapped) handleFieldChange("sessionPref", mapped);
      },
      SELECT_DURATION: (value, speech, intent, extracted, actionValue) => {
        const validDurations = ["ACUTE", "CHRONIC", "SUBACUTE"];
        if (validDurations.includes(actionValue)) {
          handleFieldChange("duration", actionValue);
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  // ── Push divider + first group Myra message on mount ──
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    let cancelled = false;
    async function init() {
      const group = CONST.PERSONALIZE_GROUPS[0];
      // if (group) {
      //   await showMyraMessage(group.myraIntro, 900);
      // }
      await showMyraMessage(MYRA_MESSAGES.personalize.PERSONALIZE_SETUP_BEAT || "What is your pain level right now? 0 is no pain, 10 is the worst imaginable.", 800);
      await showQuestionNuggetMessage(MYRA_MESSAGES.personalize.PERSONALIZE_QUESTION, MYRA_MESSAGES.personalize.PERSONALIZE_NUGGET, 900);
      if (!cancelled) setReady(true);
    }
    init();
    return () => {
      cancelled = true;
    };
  }, []);

  function getMissingFields() {
    const group = CONST.PERSONALIZE_GROUPS[0];
    if (!group) return "the remaining fields";
    const missing = group.fields.filter((f) => !formData[f.id]).map((f) => f.label);
    return missing.length > 0 ? missing.join(", ") : "the remaining fields";
  }

  async function finishPersonalize(skipped) {
    const mode = MyraInteraction?.getMode?.();
    const transitionMsg = MYRA_MESSAGES.personalize?.finishTransition || "Alright — I'm calculating your Recovery Compass Score now.";
    if (isVoiceMode) {
      VoiceService?.doSay(transitionMsg);
    }
    await showMyraMessage(transitionMsg, 800);

    if (skipped && !formData.age) {
      window.screenTracker?.exitScreen("personalize", { exitReason: "conservative_defaults_accepted" });
      onContinue({
        useStandardPlan: true,
        personal_info_skipped: true,
        demographics_provided: false,
      });
    } else {
      window.screenTracker?.exitScreen("personalize", { exitReason: "demographics_completed" });
      onContinue({
        biometrics: {
          age: formData.age || null,
          weight: formData.weight || null,
          height: formData.heightFt && formData.heightIn ? `${formData.heightFt}'${formData.heightIn}"` : null,
          gender: formData.gender || null,
          activityLevel: formData.activity || null,
          floorCapability: formData.floorCapability || null,
          balance: formData.balance || null,
          // balance: assessmentData?.balance || "steady",
        },
        signature: new Date().toISOString(),
        demographics_provided: true,
        completed_demographics: true,
        scheduleDays: formData.scheduleDays || null,
        scheduleTime: formData.scheduleTime || null,
        sessionPref: formData.sessionPref || null,
        goals: selectedGoals.length > 0 ? selectedGoals : null,
      });
    }
  }

  function handleFieldChange(fieldId, value) {
    // if (fieldId === "activity" && formData.activity === value) {
    //   return;
    // }
    setFormData((prev) => ({ ...prev, [fieldId]: value }));
  }

  function toggleGoal(goalValue) {
    setSelectedGoals((prev) => {
      if (prev.includes(goalValue)) return prev.filter((g) => g !== goalValue);
      return [...prev, goalValue];
    });
    setFormData((prev) => ({ ...prev, goals: true }));
  }
  function getFillStatus(fd, goals) {
    const fields = [fd.age, fd.weight, fd.heightFt, fd.heightIn, fd.activity, fd.balance, fd.duration, goals.length > 0 ? "goals" : null];

    const filledCount = fields.filter(Boolean).length;
    const totalCount = fields.length;

    if (filledCount === 0) return "filledNothing";
    if (filledCount === totalCount) return "filledAll";
    return "filledSome";
  }
  const handleNext = useCallback(async () => {
    // Push frozen widget capturing the user's answers
    const fillStatus = getFillStatus(formData, selectedGoals);
    let leaveMessage = MYRA_MESSAGES.personalize.finishTransition;
    if (fillStatus === "filledNothing") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledNothing;
    } else if (fillStatus === "filledAll") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledAll;
    } else if (fillStatus === "filledSome") {
      leaveMessage = MYRA_MESSAGES.personalize.PERSONALIZE_CLOSE_BY_STATE.filledSome;
    } else {
      leaveMessage = MYRA_MESSAGES.personalize.finishTransition;
    }
    pushToHistory(
      {
        type: "frozen-widget",
        widgetType: "personalize_group",
        id: nextId(),
        data: {
          groupId: CONST.PERSONALIZE_GROUPS[0].id,
          formData: { ...formData },
          selectedGoals: [...selectedGoals],
          result: fillStatus,
        },
      },
      { type: "user", text: summarizeAnswers(formData, selectedGoals), id: nextId() },
      { type: "myra", text: leaveMessage, id: nextId() },
    );

    // Apply silent defaults for fields no longer collected or left blank
    const symptomDuration = validSymptomDurations.includes(formData.duration) ? formData.duration : "ACUTE";
    const finalFields = {
      age: formData.age || null,
      weight: formData.weight || null,
      heightFt: formData.heightFt || null,
      heightIn: formData.heightIn || null,
      activity: formData.activity || null,
      symptomDuration,
      balance: formData.balance || "steady",
      goals: selectedGoals.length > 0 ? selectedGoals : null,
      // Silent defaults for fields no longer collected in GSA:
      scheduleDays: "4",
      sessionPref: "one",
      scheduleTime: "15",
      floorCapability: "no",
      // Status flags:
      completed_demographics: true,
      demographics_provided: hasAnyFieldFilled(formData, selectedGoals),
    };
    console.log("Final personalized data to be sent to backend:", formData);
    onContinue(finalFields);
  }, [formData, selectedGoals, pushToHistory, onContinue]);

  function hasAnyFieldFilled(fd, goals) {
    return !!(fd.age || fd.weight || fd.heightFt || fd.heightIn || fd.activity || fd.duration || fd.balance || goals.length > 0);
  }

  function summarizeAnswers(fd, goals) {
    const count = [fd.age, fd.weight, fd.heightFt, fd.activity, fd.duration, fd.balance, goals.length > 0 ? "goals" : null].filter(Boolean).length;
    return count === 0 ? "Skipped" : `${count} field${count > 1 ? "s" : ""} provided`;
  }

  if (!ready) return null;

  const group = CONST.PERSONALIZE_GROUPS[0];
  if (!group) return null;

  const numberFields = group.fields.filter((f) => f.type === "number");
  const otherFields = group.fields.filter((f) => f.type !== "number");

  return (
    <div className={styles.inlineUi} ref={ContainerRef}>
      <div className={styles.pzGroup}>
        {/* Number fields paired */}
        {(() => {
          const rows = [];
          for (let i = 0; i < numberFields.length; i += 2) {
            rows.push(
              <div className={styles.pzFieldRow} key={numberFields[i].id}>
                <div className={styles.pzField}>
                  <label className={styles.formLabel}>
                    {numberFields[i].label}
                    <span className={styles.optional}>(optional)</span>
                  </label>
                  <input type="number" className={styles.formInput} placeholder={numberFields[i].placeholder} min={numberFields[i].min || ""} max={numberFields[i].max || ""} value={formData[numberFields[i].id] || ""} onChange={(e) => handleFieldChange(numberFields[i].id, e.target.value)} />
                </div>
                {i + 1 < numberFields.length && (
                  <div className={styles.pzField}>
                    <label className={styles.formLabel}>
                      {numberFields[i + 1].label}
                      <span className={styles.optional}>(optional)</span>
                    </label>
                    <input type="number" className={styles.formInput} placeholder={numberFields[i + 1].placeholder} min={numberFields[i + 1].min || ""} max={numberFields[i + 1].max || ""} value={formData[numberFields[i + 1].id] || ""} onChange={(e) => handleFieldChange(numberFields[i + 1].id, e.target.value)} />
                  </div>
                )}
              </div>,
            );
          }
          return rows;
        })()}

        {/* Options and goals fields */}
        {otherFields.map((field) => {
          if (field.type === "goals") {
            return (
              <div className={styles.pzField} key={field.id}>
                <label className={styles.formLabel}>
                  {field.label}
                  <span className={styles.optional}>(optional, pick any)</span>
                </label>
                <div className={styles.pzGoalWrapper}>
                  <div className={styles.pzGoalRow}>
                    {field.options.map((opt) => (
                      <div key={opt.id} className={`${styles.pzGoalItem} ${selectedGoals.includes(opt.value) ? styles.selected : ""}`} onClick={() => toggleGoal(opt.value)}>
                        <span className={styles.pzGoalLabel}>{opt.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          }
          if (field.type === "options") {
            return (
              <div className={styles.pzField} key={field.id}>
                <label className={styles.formLabel}>
                  {field.label}
                  <span className={styles.optional}>(optional)</span>
                </label>
                <div className={styles.pzOptionRow}>
                  {field.options.map((opt) => (
                    <button key={opt.id} className={`${styles.pzOptBtn} ${formData[field.id] === opt.value ? styles.selected : ""}`} onClick={() => handleFieldChange(field.id, opt.value)}>
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}

        {/* Single Next button — no Skip */}
        <div className={styles.pzActions}>
          <button className={`${styles.videoBtn} ${styles.videoBtnPrimary}`} onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 19: RECOVERY SCORE
// Animated ring display. Gates voice flow on loading completion.
// Backend API call stubbed with getDummyPlan().
// ════════════════════════════════════════════════════════════════
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
async function fetchWithRetry(url, options = {}, opts = {}) {
  const { maxAttempts = 4, initialDelay = 800, factor = 2, jitter = true, timeout = 20000, signal } = opts;

  let attempt = 0;

  while (attempt < maxAttempts) {
    attempt += 1;

    // per-attempt timeout
    const controller = new AbortController();
    const combinedSignal = signal
      ? new AbortController().signal // placeholder, we'll combine below
      : controller.signal;

    // Combine signals: prefer outer signal (if provided), but ensure we can timeout.
    // If a signal was passed, we listen to it and abort our controller when it fires.
    if (signal) {
      if (signal.aborted) {
        controller.abort();
      } else {
        const onAbort = () => controller.abort();
        signal.addEventListener("abort", onAbort, { once: true });
      }
    }

    let timeoutId;
    try {
      if (timeout) {
        timeoutId = setTimeout(() => controller.abort(), timeout);
      }

      const res = await fetch(url, {
        ...options,
        signal: controller.signal,
      });

      // if server error (5xx) treat as retryable; if 4xx treat as permanent failure
      if (res.ok) {
        clearTimeout(timeoutId);
        return { ok: true, response: await res.json(), attempt };
      } else if (res.status >= 500 && res.status < 600) {
        // retryable server error
        const errText = await res.text().catch(() => "");
        throw new Error(`Server error ${res.status}: ${errText}`);
      } else {
        // client error - do not retry
        const errText = await res.text().catch(() => "");
        return { ok: false, permanentError: true, status: res.status, body: errText };
      }
    } catch (err) {
      clearTimeout(timeoutId);

      // If aborted externally, rethrow so caller can handle immediate abort
      if (signal && signal.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }

      // If this was the last attempt, return failure info
      if (attempt >= maxAttempts) {
        return { ok: false, error: err, attempt };
      }

      // compute backoff delay (exponential + jitter)
      let delay = initialDelay * Math.pow(factor, attempt - 1);
      if (jitter) {
        const jitterVal = Math.random() * (delay * 0.25); // up to 25% jitter
        delay = delay - jitterVal;
      }

      // wait and retry
      await sleep(delay);
      // then continue loop for next attempt
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  // fallback - should never reach here because loop returns
  return { ok: false, error: new Error("Retries exhausted") };
}

function RecoveryScoreScreen({ assessmentData, updateAssessmentData, pushToHistory, showMyraMessage, scrollToBottom, onContinue }) {
  console.log("ASSESSMENT DATA IS : ", assessmentData);
  const [loadingWait, setLoadingWait] = useState(true);
  const [scoreData, setScoreData] = useState(null);
  const flowStartedRef = useRef(false);
  const initRef = useRef(false);
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const problemArea = assessmentData.problemArea || "LBP";
  const isLBP = problemArea === "LBP";
  const URL = CONST.SCORE_API_URL;
  const ContainerRef = useRef(null);
  const isVoiceMode = MyraInteraction.getMode() === "voice";
  const transformedRequest = {
    painLocations: assessmentData?.selectedZones || [],
    cpgClassification: assessmentData?.cpgForBackend,
    ...(assessmentData?.subtypeQuestions && assessmentData?.selfAssessmentAnswer
      ? {
          subjectiveResponses: {
            q1: assessmentData?.subtypeQuestions?.value || "",
            q2a: assessmentData?.selfAssessmentAnswer || "",
          },
        }
      : {}),
    symptomDuration: assessmentData?.symptomDuration || "",
    analyticsId: assessmentData?.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
    preTestNPRS: assessmentData?.painLevel || 0,
    probableSubtype: assessmentData?.probableSubtype || "",
    diagnosisChanged: assessmentData?.diagnosisChanged || false,
    degradation: assessmentData?.degradation ?? null,
    timing: assessmentData?.timing ?? null,
    signature: assessmentData?.signature || false,
    current_conditions: assessmentData?.biometrics?.currentConditions || userConditions?.current || "",
    pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || userConditions?.pre_existing || "",
    input_mode: MyraInteraction?.getMode?.() || "chat",

    romTest1: {
      testName: assessmentData?.testName || "",
      symptomaticResponse: assessmentData?.symptomResponse?.value || assessmentData?.symptomResponse1 || assessmentData?.symptomResponse || "",
      rpe: assessmentData?.rpe || 0,
      movementQuality: assessmentData?.romQuality || "",
      cvData: {
        rom: Array.isArray(assessmentData?.rom) ? assessmentData.rom : assessmentData?.rom != null ? [assessmentData.rom] : [],

        duration: Array.isArray(assessmentData?.duration) ? assessmentData.duration : assessmentData?.duration != null ? [assessmentData.duration] : [],
      },
    },
    ...(assessmentData?.testName2 && assessmentData?.symptomResponseConfirm
      ? {
          romTest2: {
            testName: assessmentData?.testName2,
            symptomaticResponse: assessmentData?.symptomResponseConfirm,
          },
        }
      : {}),

    biometrics: assessmentData?.biometrics?.skipped
      ? { skipped: true }
      : {
          skipped: false,
          age: assessmentData?.biometrics?.age || 60,
          activityLevel: assessmentData?.biometrics?.activityLevel,
          heightFt: assessmentData?.biometrics?.heightFt,
          heightIn: assessmentData?.biometrics?.heightIn,
          weightLbs: assessmentData?.biometrics?.weightLbs,
          floorCapability: assessmentData?.biometrics?.floorCapability,
          balance: assessmentData?.biometrics?.balance || assessmentData?.balance || "steady",
          goal: assessmentData?.biometrics?.goal || "",
          sessionPref: assessmentData?.biometrics?.sessionPref || "one",
          scheduleTime: assessmentData?.biometrics?.scheduleTime || "",
          scheduleDays: assessmentData?.biometrics?.scheduleDays || "",
          current_conditions: assessmentData?.biometrics?.currentConditions || userConditions?.current || "",
          pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || userConditions?.pre_existing || "",
          input_mode: MyraInteraction?.getMode?.() || "chat",
        },
  };

  // Backend calculation
  useEffect(() => {
    if (!initRef.current) {
      initRef.current = true;
    }
    async function calculateScore() {
      if (AnalyticsService) AnalyticsService.startSession();
      try {
        const payload = JSON.stringify(transformedRequest);
        const result = await fetchWithRetry(URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
        });
        if (result.ok && result.response) {
          const apiResponse = result.response;

          // Extract data from the nested structure
          const userProfile = apiResponse.userProfile || {};
          const recoveryPlan = apiResponse.recoveryPlan || {};

          // Build the structured scoreData
          const structuredData = {
            // Score information
            finalScore: userProfile.recoveryScore || 0,
            pillar1: userProfile.pillar1 || 0,
            pillar2: userProfile.pillar2 || 0,
            pillar3: userProfile.pillar3 || 0,
            pillar4: userProfile.pillar4 || 0,
            rcsCalculated: userProfile.rcsCalculated || 0,
            totalAdjustment: userProfile.totalAdjustment || 0,
            adjustmentDetails: userProfile.adjustmentDetails || {},

            // User profile information
            level: userProfile.level || 1,
            finalPainSubtype: userProfile.finalPainSubtype || "",
            finalCpgClassification: userProfile.finalCpgClassification || "",
            planDetails: userProfile.planDetails || {},

            // Recovery plan
            recoveryPlan: recoveryPlan,
            planRationaleSpeech: recoveryPlan.rationale || "",
            estimatedTime: recoveryPlan.estimatedTime || "10-12 min",

            // Metadata
            aiLogId: `api-${Date.now()}`,
            aiLatencyMs: result.attempt ? Date.now() - performance.now() : 0,
            planGeneratedAt: new Date().toISOString(),
            exerciseCandidatesCount: recoveryPlan.exercises?.length || 0,
          };
          setScoreData(structuredData);
          updateAssessmentData({ ...assessmentData, ...structuredData });
          setLoadingWait(false);
        }
      } catch {
        const fallback = CONST.getDummyPlan(assessmentData.problemArea);
        setScoreData({
          finalScore: fallback.score,
          planDetails: fallback,
          rcsCalculated: true,
          planRationaleSpeech: "",
          aiLogId: `fallback-${Date.now()}`,
          aiLatencyMs: 0,
          planGeneratedAt: new Date().toISOString(),
          exerciseCandidatesCount: fallback.exercises.length,
        });
        setLoadingWait(false);
      }
    }
    calculateScore();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useScreenVoice for boilerplate — flow handled manually
  useScreenVoice({
    screenName: "recovery_score",
    flowName: "flow_recovery_compass_score",
    payloadKey: "recovery_score",
    exitReason: "scored",
    commands: {
      READY_TO_PROCEED: (value) => {
        if (window.exitHandlerOpen) return;
        if (value === true || value === "true") {
          setTimeout(() => handleContinue(), 2000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command") setTimeout(() => handleContinue(), 2000);
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleContinue(), 2000);
      },
    },
  });

  // Mode-specific flow start — only after loading completes
  useEffect(() => {
    if (loadingWait || flowStartedRef.current) return;
    flowStartedRef.current = true;

    const mayraCode = window.mayraCode;
    if (!mayraCode) return;

    const mergedData = { ...assessmentData, ...scoreData };
    const mode = MyraInteraction?.getMode?.();
    console.log("Mode is : ", mode);
    window.mayraForwardCode = { midjourneyData: generatePayloadForScreen("recovery_score", mergedData) };

    if (mode === "voice") {
      mayraCode.startFlow("flow_recovery_compass_score", "recovery_score");
    } else if (mode === "chat") {
      const chatAnnouncement = "Your recovery score is ready! Let me walk you through it.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_recovery_compass_score", "", "");
      MyraInteraction?.onMyraMessage?.(chatAnnouncement);
    } else {
      const buttonAnnouncement = "Your recovery score is ready! Let me walk you through it.";
      VoiceService?.startFlowWithoutAnnouncement?.("flow_recovery_compass_score", "", "");
    }

    if (AnalyticsService) {
      AnalyticsService.trackStep(mergedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingWait]);

  const handleContinue = useCallback(() => {
    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      window.audioPlayer.ctx.resume();
    }
    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }

    if (!scoreData) return;
    const subtypeForFrozen = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";
    const diagnosisForFrozen = CONST.MESSAGING.diagnosis[subtypeForFrozen] || CONST.MESSAGING.diagnosis.NEUTRAL_SENSITIVE;
    const scoreForFrozen = scoreData.finalScore || 0;
    pushToHistory({ type: "frozen-widget", widgetType: "rcs", id: nextId(), data: { score: scoreForFrozen, diagnosis: diagnosisForFrozen } }, { type: "user", text: "View My Week 1 Recovery Plan", id: nextId() });
    onContinue({ ...scoreData, recovery_score_viewed: true });
  }, [scoreData, assessmentData, onContinue]);

  // Command registration — 2s delay on all continues
  useEffect(() => {
    window.currentCommandsAudio = {
      READY_TO_PROCEED: (value) => {
        if (window.exitHandlerOpen) return;
        if (value === true || value === "true") {
          setTimeout(() => handleContinue(), 2000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (value === "continue_command") setTimeout(() => handleContinue(), 2000);
      },
      MOVE_ON: () => {
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleContinue(), 2000);
      },
    };
  }, [handleContinue]);

  // Loading state — inline in chat area
  if (loadingWait || !scoreData) {
    return (
      <div className={styles.inlineUi}>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <div className={styles.aiProcessingSpinner} />
          <p style={{ fontWeight: 600, marginTop: 16, color: "#1f2937" }}>Calculating Your Recovery Score</p>
          <p style={{ color: "#6b7280", fontSize: "14px", marginTop: 4 }}>This may take a moment…</p>
        </div>
      </div>
    );
  }

  const score = scoreData.finalScore || 0;
  const subtype = assessmentData.probableSubtype || "NEUTRAL_SENSITIVE";
  const diagnosis = CONST.MESSAGING.diagnosis[subtype] || CONST.MESSAGING.diagnosis.NEUTRAL_SENSITIVE;
  const rm = scoreData.totalAdjustment || scoreData.planDetails?.readinessModifier || 85;
  let tier;
  if (rm >= 90) tier = CONST.MESSAGING.readinessTiers.READY_TO_GO;
  else if (rm >= 75) tier = CONST.MESSAGING.readinessTiers.CAUTIOUS_START;
  else if (rm >= 50) tier = CONST.MESSAGING.readinessTiers.GENTLE_APPROACH;
  else tier = CONST.MESSAGING.readinessTiers.STARTING_WITH_CARE;
  const circumference = 2 * Math.PI * 65;

  return (
    <div className={styles.inlineUi} ref={ContainerRef}>
      <div className={styles.rcsScreen}>
        <h2 className={styles.rcsTitle}>Recovery Compass</h2>
        <p className={styles.rcsSubtitle}>The Starting Point of Your Recovery Journey</p>

        <div className={styles.rcsScoreSection}>
          <span className={styles.rcsScoreLabel}>Your Score</span>
          <div className={styles.rcsRingContainer}>
            <svg viewBox="0 0 160 160" className={styles.rcsRingSvg}>
              <defs>
                <linearGradient id="scoreGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#16a34a" />
                  <stop offset="100%" stopColor="#15803d" />
                </linearGradient>
              </defs>
              <circle cx="80" cy="80" r="65" fill="none" stroke="#e5e7eb" strokeWidth="8" />
              <circle cx="80" cy="80" r="65" fill="none" stroke="url(#scoreGrad)" strokeWidth="8" strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={circumference * (1 - score / 100)} transform="rotate(-90 80 80)" className={styles.rcsRingFill} />
            </svg>
            <span className={styles.rcsScoreNumber}>{score}</span>
          </div>
        </div>

        <p className={styles.rcsExplanation}>Your Recovery Compass Score starts at {score}, reflecting your current recovery stage. As you follow your personalized plan over the next 8 weeks, this score is designed to improve steadily, with a goal of reaching closer to 100.</p>

        <div className={styles.rcsDiagnosisCard}>
          <h3 className={styles.rcsDiagnosisHeadline}>{diagnosis.headline}</h3>
          <p className={styles.rcsDiagnosisRelief}>{diagnosis.relief}</p>
        </div>

        <div className={styles.rcsPersonalizationCard}>
          <p className={styles.rcsPersonalizationTitle}>How We've Personalized Your Plan</p>
          <div className={styles.rcsFactors}>
            <div className={styles.rcsFactor}>
              <span>📊</span>
              <span>Your Score</span>
            </div>
            <span className={styles.rcsPlus}>+</span>
            <div className={styles.rcsFactor}>
              <span>📋</span>
              <span>Your History</span>
            </div>
            <span className={styles.rcsPlus}>+</span>
            <div className={styles.rcsFactor}>
              <span>👤</span>
              <span>Your Info</span>
            </div>
          </div>
        </div>

        <button className={styles.btnSafe} onClick={handleContinue} style={{ marginTop: 12 }}>
          View My Week 1 Recovery Plan
        </button>
      </div>
    </div>
  );
}

// ════════════════════════════════════════════════════════════════
// SCREEN 20: PLAN SCREEN
// Exercise plan display with QnA flow. Sign-up CTA.
// Fires dual gtag events, saveFullData, saveUserJourney.
// ════════════════════════════════════════════════════════════════

function PlanScreen({ assessmentData, updateAssessmentData, qaRef, onOpenQnA, pushToHistory, showMyraMessage, scrollToBottom }) {
  const [loadingScore, setLoadingScore] = useState(true);
  const [scoreData, setScoreData] = useState(null);
  const initRef = useRef(false);
  const planFlowStartedRef = useRef(false);
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const [showRationale, setShowRationale] = useState({});
  const [usedQaButtons, setUsedQaButtons] = useState({});
  const [showRead, setShowRead] = useState(false);
  const [ready, setReady] = useState(false);
  const rationaleSpeech = scoreData?.planRationaleSpeech || assessmentData?.planRationaleSpeech;
  const [showQaPrompt, setShowQaPrompt] = useState(false);
  const [isTypingQaPrompt, setIsTypingQaPrompt] = useState(false);
  const [showRemOptions, setShowRemOptions] = useState(false);
  let userName = localStorage.getItem("self_name") || "";
  console.log("Rationale speech is : ", rationaleSpeech);
  let fullSpeech = userName ? `${userName} | ${rationaleSpeech}` : rationaleSpeech;
  const [expanded, setExpanded] = useState(false);
  const text = `${userName ? userName + " " : ""}${rationaleSpeech}`;
  const audioStartTimeRef = useRef(null);
  const startingPlanRef = useRef(null);
  const hasScrolledRef = useRef(false);
  const signupButtonRef = useRef(null);
  const planCardRef = useRef(null);

  // play speak and replay states
  const [audioState, setAudioState] = useState("thinking"); // 'thinking', 'speaking', 'replay'
  const [showReplayOne, setShowReplayOne] = useState(false);
  const [audioProgress, setAudioProgress] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);
  const audioIntervalRef = useRef(null);
  const [selectedAnalysisQaId, setSelectedAnalysisQaId] = useState(null);
  const [speechInProgress, setSpeechInProgress] = useState(false);

  const [showTypingIndicator, setShowTypingIndicator] = useState(false);
  const [introMessageAdded, setIntroMessageAdded] = useState(false);

  useEffect(() => {
    if (showTypingIndicator && startingPlanRef.current) {
      setTimeout(() => {
        if (startingPlanRef.current) {
          startingPlanRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      }, 100);
    }
  }, [showTypingIndicator]);
  useEffect(() => {
    if (ready && planCardRef.current) {
      setTimeout(() => {
        if (planCardRef.current) {
          planCardRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 200);
    }
  }, [ready]);

  // Clean up audio interval
  const clearAudioInterval = () => {
    if (audioIntervalRef.current) {
      clearInterval(audioIntervalRef.current);
      audioIntervalRef.current = null;
    }
  };

  // Format time (seconds → MM:SS)
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  // Rough time estimate per phase: based on sets x reps x 3s + holds + brief rest
  const estimatePhaseTime = (items, phaseLabel = "") => {
    if (!items || items.length === 0) return null;

    const isWarmup = phaseLabel.toLowerCase().includes("warm");
    const isCooldown = phaseLabel.toLowerCase().includes("cool");
    const isMainWork = !isWarmup && !isCooldown;

    const ANNOUNCEMENT_PER_SET_SEC = 20;
    // Voice countdown is ~4s and chat can be longer; use a blended 5s estimate.
    const START_COUNTDOWN_PER_SET_SEC = 5;

    const totalSec = items.reduce((sum, ex, idx) => {
      const sets = parseInt(ex.sets) || 1;
      const reps = parseInt(ex.reps) || 8;
      const hold = parseInt(ex.hold) || 0;

      let baseMovePerRep;
      if (isWarmup) {
        baseMovePerRep = hold > 0 ? 3 : 4; // If holding, movement is quicker
      } else if (isCooldown) {
        baseMovePerRep = hold > 0 ? 2 : 5; // Cool-down stretches are slower
      } else {
        baseMovePerRep = hold > 0 ? 2 : 3; // Main work exercises
      }

      // Total time per rep = movement + hold
      const repTime = baseMovePerRep + hold;

      // TIME PER SET
      const setTime = reps * repTime;

      // Announcement time per set .
      let setOverhead = 0;
      if (sets > 1) {
        setOverhead = sets * (ANNOUNCEMENT_PER_SET_SEC + START_COUNTDOWN_PER_SET_SEC);
      } else {
        setOverhead = ANNOUNCEMENT_PER_SET_SEC + START_COUNTDOWN_PER_SET_SEC;
      }
      // Only adding rest if there are multiple sets
      let restBetweenSets = 0;
      if (sets > 1) {
        if (isWarmup || isCooldown) {
          restBetweenSets = (sets - 1) * 10; // Shorter rest for stretches
        } else {
          restBetweenSets = (sets - 1) * 20; // Longer rest for main work
        }
      }

      // Time to set up for the next exercise (except after last exercise)
      const transitionAfter = idx < items.length - 1 ? 15 : 0;

      // ── TOTAL FOR THIS EXERCISE
      const exerciseTotal = sets * setTime + setOverhead + restBetweenSets + transitionAfter;

      return sum + exerciseTotal;
    }, 0);

    // Converting to minutes and format
    const mins = Math.ceil(totalSec / 60);
    return mins < 1 ? "<1 min" : `~${mins} min`;
  };

  const groupExercisesByPhase = (exList) => {
    if (!exList || exList.length === 0) return [];

    // Check if exercises have purpose or phase field
    const hasPurpose = exList.some((ex) => ex.purpose || ex.phase);

    if (hasPurpose) {
      const groups = { warmup: [], main: [], cooldown: [] };

      exList.forEach((ex) => {
        // Use 'purpose' field first, then fall back to 'phase'
        const purposeValue = (ex.purpose || ex.phase || "main").toLowerCase();

        if (purposeValue.includes("warm")) {
          groups.warmup.push(ex);
        } else if (purposeValue.includes("cool")) {
          groups.cooldown.push(ex);
        } else {
          groups.main.push(ex);
        }
      });

      // Build result array with only non-empty groups
      const result = [];
      if (groups.warmup.length) {
        result.push({
          label: "Warm up",
          items: groups.warmup,
          duration: estimatePhaseTime(groups.warmup, "warm"),
        });
      }
      if (groups.main.length) {
        result.push({
          label: "Main work",
          items: groups.main,
          duration: estimatePhaseTime(groups.main, "main"),
        });
      }
      if (groups.cooldown.length) {
        result.push({
          label: "Cool down",
          items: groups.cooldown,
          duration: estimatePhaseTime(groups.cooldown, "cool"),
        });
      }

      return result;
    }

    // FALLBACK
    // If no purpose/phase field exists, useing position as a heuristic

    if (exList.length === 1) {
      return [
        {
          label: "Main work",
          items: exList,
          duration: estimatePhaseTime(exList, "main"),
        },
      ];
    }

    if (exList.length === 2) {
      return [
        {
          label: "Warm up",
          items: [exList[0]],
          duration: estimatePhaseTime([exList[0]], "warm"),
        },
        {
          label: "Main work",
          items: [exList[1]],
          duration: estimatePhaseTime([exList[1]], "main"),
        },
      ];
    }

    // 3+ exercises: first=warmup, middle=main, last=cooldown
    return [
      {
        label: "Warm up",
        items: [exList[0]],
        duration: estimatePhaseTime([exList[0]], "warm"),
      },
      {
        label: "Main work",
        items: exList.slice(1, -1),
        duration: estimatePhaseTime(exList.slice(1, -1), "main"),
      },
      {
        label: "Cool down",
        items: [exList[exList.length - 1]],
        duration: estimatePhaseTime([exList[exList.length - 1]], "cool"),
      },
    ];
  };

  // Total time of all phase groups.
  const getTotalTimeFromGroups = (exList) => {
    if (!exList || exList.length === 0) return "";

    const groups = groupExercisesByPhase(exList);
    if (!groups.length) return "";

    let totalMinutes = 0;
    groups.forEach((group) => {
      const durationText = String(group?.duration || "")
        .toLowerCase()
        .trim();
      if (!durationText) return;

      if (durationText.includes("<1")) {
        totalMinutes += 1;
        return;
      }

      const firstPart = durationText.replace("~", "").split(" ")[0];
      const minutes = parseInt(firstPart, 10) || 0; // Convert to integer and handle NaN
      totalMinutes += minutes;
    });
    console.log("total minutes : ", totalMinutes);
    if (totalMinutes <= 0) return "";
    return `${totalMinutes}-${totalMinutes + 2}`;
  };

  // Handle replay button click
  const handlePlayAudio = () => {
    const fullSpeech = userName ? `${userName}, ${rationaleSpeech}` : rationaleSpeech;
    setSpeechInProgress(true);

    setAudioState("speaking");
    setShowReplayOne(false);
    setAudioProgress(0);
    setTotalDuration(0);
    hasScrolledRef.current = false;

    clearAudioInterval();
    if (window.audioPlayer?.pcm) {
      window.audioPlayer.pcm.exactDuration = 0;
      window.audioPlayer.pcm.totalQueuedSamples = 0;
      window.audioPlayer.pcm.queuedSamples = 0;
    }

    // Start timer simulation (replace with actual audio duration tracking)
    startAudioProgressSimulation();

    if (window.mayraCode && fullSpeech) {
      try {
        window.initFromUserGesture();
        window.audioPlayer?.ctx?.resume();
      } catch (e) {}
      window.mayraCode.doSay(fullSpeech, () => {
        setAudioState("replay");
        setShowReplayOne(true);
        clearAudioInterval();
        setSpeechInProgress(false);
      });
    }
  };
  const handleStopAudio = () => {
    if (speechInProgress) {
      VoiceService.stopAllVoiceActivity();
      // Clear any pending callbacks
      VoiceService._callbacks.onAgentSpeechEndCustom = () => {};

      console.log("Speech completely stopped by user");
    }
    // Clear audio interval
    clearAudioInterval();

    // Reset UI state to replay mode
    setShowRemOptions(true);
    setAudioState("replay");
    setShowReplayOne(true);
    setSpeechInProgress(false);
    setAudioProgress(0);
    audioStartTimeRef.current = null;

    // Reset UI state
  };
  // Scroll to sign-up button when audio reaches 25% of total duration
  useEffect(() => {
    // Only proceed if we have valid values
    if (totalDuration === 0 || audioProgress === 0) return;
    if (hasScrolledRef.current) return; // Only scroll once
    if (!ready) return;

    // Calculate 25% of total duration
    const twentyFivePercent = totalDuration * 0.25;

    // Check if we've reached or passed 25%
    // Use a small buffer to handle floating point precision
    if (audioProgress >= twentyFivePercent - 0.1) {
      console.log(`25% milestone reached! Progress: ${audioProgress}s, Target: ${twentyFivePercent}s`);

      // Mark as scrolled immediately to prevent multiple triggers
      hasScrolledRef.current = true;

      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        if (signupButtonRef.current) {
          signupButtonRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
          console.log("Scrolled to sign-up button");
        } else {
          console.log("Sign-up button ref not found");
        }
      });
    }
  }, [audioProgress, totalDuration, ready]);

  const startAudioProgressSimulation = () => {
    clearAudioInterval();
    setAudioProgress(0);
    audioStartTimeRef.current = Date.now();

    const PLACEHOLDER_DURATION = 75; // 1:15 shown until real duration arrives

    let confirmedDuration = 0;
    let anchorWallMs = Date.now();
    let anchorPlayedSec = 0;
    let lastEmittedSec = 0;
    let sessionStarted = false;

    audioIntervalRef.current = setInterval(() => {
      const pcm = window.audioPlayer?.pcm;
      // ── Wait for THIS session's tts_start before trusting any PCM values ──
      if (!sessionStarted) {
        if (pcm?.active === true) {
          sessionStarted = true;
        } else {
          // Still waiting — show placeholder moving by wall-clock
          const wallElapsed = (Date.now() - audioStartTimeRef.current) / 1000;
          const safe = Math.max(lastEmittedSec, Math.min(wallElapsed, PLACEHOLDER_DURATION - 0.1));
          lastEmittedSec = safe;
          setTotalDuration(PLACEHOLDER_DURATION);
          setAudioProgress(safe);
          return;
        }
      }

      // ── Step 1: lock in real duration once tts_end sets exactDuration ──
      if (!confirmedDuration && pcm?.exactDuration > 0) {
        confirmedDuration = pcm.exactDuration;
        setTotalDuration(confirmedDuration);
      }

      // If no real duration yet, show placeholder and move by wall-clock
      if (!confirmedDuration) {
        const wallElapsed = (Date.now() - audioStartTimeRef.current) / 1000;
        const safe = Math.max(lastEmittedSec, Math.min(wallElapsed, PLACEHOLDER_DURATION - 0.1));
        lastEmittedSec = safe;
        setTotalDuration(PLACEHOLDER_DURATION);
        setAudioProgress(safe);
        return;
      }

      // ── Step 2: real duration confirmed — use PCM anchor + interpolation ──
      const sampleRate = pcm?.sampleRate || 24000;
      const totalQueued = pcm?.totalQueuedSamples || 0;
      const stillQueued = Math.max(0, pcm?.queuedSamples || 0);

      if (totalQueued > 0) {
        const playedFromPcm = Math.max(0, totalQueued - stillQueued) / sampleRate;
        if (playedFromPcm > anchorPlayedSec) {
          anchorPlayedSec = playedFromPcm;
          anchorWallMs = Date.now();
        }
      }

      const wallDriftSec = (Date.now() - anchorWallMs) / 1000;
      const interpolated = anchorPlayedSec + wallDriftSec;
      const clamped = Math.min(interpolated, confirmedDuration);
      const safe = Math.max(lastEmittedSec, clamped);
      lastEmittedSec = safe;

      setAudioProgress(safe);
    }, 50);
  };
  useEffect(() => {
    const checkSpeakingState = setInterval(() => {
      const pcm = window.audioPlayer?.pcm;
      // Use PCM active state as the authoritative source of truth
      const isActuallySpeaking = pcm?.active === true || pcm?.queuedSamples > 0;

      if (isActuallySpeaking) {
        if (audioState !== "speaking") {
          setAudioState("speaking");
          setShowReplayOne(false);
          // Only start simulation if not already running
          if (!audioIntervalRef.current) startAudioProgressSimulation();
        }
      } else {
        if (audioState === "speaking") {
          // Snap progress to full duration on natural completion
          setAudioProgress((prev) => {
            const dur = window.audioPlayer?.pcm?.exactDuration;
            return dur ? dur : prev;
          });
          setAudioState("replay");
          setShowReplayOne(true);
          clearAudioInterval();
        } else if (audioState !== "replay" && audioState !== "thinking") {
          setAudioState("thinking");
        }
      }
    }, 200); // faster poll = smoother progress bar

    return () => {
      clearInterval(checkSpeakingState);
      clearAudioInterval();
    };
  }, [audioState, rationaleSpeech]);
  useEffect(() => {
    if (!ready) return;

    let timer = null;

    if (startingPlanRef.current) {
      startingPlanRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    // return () => {
    //   if (timer) clearTimeout(timer);
    // };
  }, [ready, scoreData]);

  // Build the same payload as the legacy RecoveryScoreScreen
  const transformedRequest = useMemo(
    () => ({
      painLocations: assessmentData?.selectedZones || [],
      cpgClassification: assessmentData?.cpgForBackend,
      ...(assessmentData?.subtypeQuestions && assessmentData?.selfAssessmentAnswer
        ? {
            subjectiveResponses: {
              q1: assessmentData?.subtypeQuestions?.value || "",
              q2a: assessmentData?.selfAssessmentAnswer || "",
            },
          }
        : {}),
      symptomDuration: assessmentData?.symptomDuration || "",
      analyticsId: assessmentData?.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
      preTestNPRS: assessmentData?.painLevel || 0,
      probableSubtype: assessmentData?.probableSubtype || "",
      diagnosisChanged: assessmentData?.diagnosisChanged || false,
      degradation: assessmentData?.degradation ?? null,
      timing: assessmentData?.timing ?? null,
      signature: assessmentData?.signature || false,
      current_conditions: assessmentData?.biometrics?.currentConditions || userConditions?.current || "",
      pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || userConditions?.pre_existing || "",
      input_mode: MyraInteraction?.getMode?.() || "chat",
      romTest1: {
        testName: assessmentData?.testName || "",
        symptomaticResponse: assessmentData?.symptomResponse?.value || assessmentData?.symptomResponse1 || assessmentData?.symptomResponse || "",
        rpe: assessmentData?.rpe || 0,
        movementQuality: assessmentData?.romQuality || "",
        cvData: {
          rom: Array.isArray(assessmentData?.rom) ? assessmentData.rom : assessmentData?.rom != null ? [assessmentData.rom] : [],
          duration: Array.isArray(assessmentData?.duration) ? assessmentData.duration : assessmentData?.duration != null ? [assessmentData.duration] : [],
        },
      },
      ...(assessmentData?.testName2 && assessmentData?.symptomResponseConfirm
        ? {
            romTest2: {
              testName: assessmentData?.testName2,
              symptomaticResponse: assessmentData?.symptomResponseConfirm,
            },
          }
        : {}),
      biometrics: assessmentData?.biometrics?.skipped
        ? { skipped: true }
        : {
            skipped: false,
            age: assessmentData?.biometrics?.age || 60,
            activityLevel: assessmentData?.biometrics?.activityLevel,
            heightFt: assessmentData?.biometrics?.heightFt,
            heightIn: assessmentData?.biometrics?.heightIn,
            weightLbs: assessmentData?.biometrics?.weightLbs,
            floorCapability: assessmentData?.biometrics?.floorCapability,
            balance: assessmentData?.biometrics?.balance || assessmentData?.balance || "steady",
            goal: assessmentData?.biometrics?.goal || "",
            sessionPref: assessmentData?.biometrics?.sessionPref || "one",
            scheduleTime: assessmentData?.biometrics?.scheduleTime || "",
            scheduleDays: assessmentData?.biometrics?.scheduleDays || "",
            current_conditions: assessmentData?.biometrics?.currentConditions || userConditions?.current || "",
            pre_existing_conditions: assessmentData?.biometrics?.preExistingConditions || userConditions?.pre_existing || "",
            input_mode: MyraInteraction?.getMode?.() || "chat",
          },
    }),
    [assessmentData, userConditions],
  );

  // Fetch the score from the same endpoint as before
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    async function calculateScore() {
      if (AnalyticsService) AnalyticsService.startSession();
      try {
        const result = await fetchWithRetry(CONST.SCORE_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(transformedRequest),
        });
        if (result.ok && result.response) {
          const apiResponse = result.response;
          const userProfile = apiResponse.userProfile || {};
          const recoveryPlan = apiResponse.recoveryPlan || {};
          const structuredData = {
            finalScore: userProfile.recoveryScore || 0,
            pillar1: userProfile.pillar1 || 0,
            pillar2: userProfile.pillar2 || 0,
            pillar3: userProfile.pillar3 || 0,
            pillar4: userProfile.pillar4 || 0,
            rcsCalculated: userProfile.rcsCalculated || 0,
            totalAdjustment: userProfile.totalAdjustment || 0,
            adjustmentDetails: userProfile.adjustmentDetails || {},
            level: userProfile.level || 1,
            finalPainSubtype: userProfile.finalPainSubtype || "",
            finalCpgClassification: userProfile.finalCpgClassification || "",
            planDetails: userProfile.planDetails || {},
            recoveryPlan: recoveryPlan,
            planRationaleSpeech: recoveryPlan.rationale || "",
            estimatedTime: recoveryPlan.estimatedTime || "10-12 min",
            aiLogId: `api-${Date.now()}`,
            aiLatencyMs: result.attempt ? Date.now() - performance.now() : 0,
            planGeneratedAt: new Date().toISOString(),
            exerciseCandidatesCount: recoveryPlan.exercises?.length || 0,
            viewed_plan: true,
          };
          setScoreData(structuredData);
          updateAssessmentData({ ...assessmentData, ...structuredData });
          setLoadingScore(false);
        }
      } catch {
        const fallback = CONST.getDummyPlan(assessmentData.problemArea);
        setScoreData({
          finalScore: fallback.score,
          planDetails: fallback,
          rcsCalculated: true,
          planRationaleSpeech: "",
          aiLogId: `fallback-${Date.now()}`,
          aiLatencyMs: 0,
          planGeneratedAt: new Date().toISOString(),
          exerciseCandidatesCount: fallback.exercises.length,
        });
        setLoadingScore(false);
      }
    }
    calculateScore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Data-driven Q&A buttons — extensible by adding items ──
  const PLAN_QA_ITEMS = useMemo(
    () => [
      { key: "why", label: "Why these exercises?", question: "Why these exercises?", answer: CONST.PLAN_QA_ANSWERS?.why || "Each exercise was chosen based on your pain pattern, movement results, and subtype classification. They target the specific areas that need strengthening or mobility work for your recovery." },
      { key: "often", label: "How often should I do this?", question: "How often should I do this?", answer: CONST.PLAN_QA_ANSWERS?.often || "Your plan is designed for 3 sessions per week. Each session takes about 15–20 minutes. Consistency matters more than intensity — even 2 sessions is better than none." },
      { key: "hurts", label: "What if it hurts?", question: "What if it hurts?", answer: CONST.PLAN_QA_ANSWERS?.hurts || "Mild discomfort during exercises can be normal, but sharp or increasing pain is not. If an exercise causes pain above a 4 out of 10 or gets worse as you go, stop and let me know. I can swap it for an alternative." },
      // More can be added here without code changes
    ],
    [],
  );

  const effectiveAssessmentData = { ...assessmentData, ...(scoreData || {}) };
  const plan = scoreData?.recoveryPlan || scoreData?.planDetails || assessmentData.recoveryPlan || assessmentData.planDetails || CONST.getDummyPlan(assessmentData.problemArea);
  const exercises = plan.exercises || [];
  const estTotalTime = getTotalTimeFromGroups(exercises);
  const estTime = estTotalTime || scoreData?.estimatedTime || plan.estimatedTime || "15-20";
  const latestAssessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");
  const finalGSADuration = window.timeTracker.getGSADuration();
  const updatedAssessmentData = { ...latestAssessmentData, exercises, final_conversion_type: "signup", gsaDurationSec: finalGSADuration, viewed_plan: true, completed_assessment: true, session_last_update: new Date().toISOString() };

  console.log("est total time : ", estTotalTime);

  useScreenVoice({
    screenName: "plan_screen",
    flowName: "flow_plan_v2",
    payloadKey: "plan_screen",
    exitReason: "sign-up",
    commands: {
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        if (intent === "signup_request") {
          setTimeout(() => handleSignUp(), 3000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        if (value === "continue_command") setTimeout(() => handleSignUp(), 3000);
        if (intent === "signup_request") {
          setTimeout(() => handleSignUp(), 3000);
        }
      },
      MOVE_ON: () => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleSignUp(), 3000);
      },
      SIGN_UP: () => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleSignUp(), 3000);
      },
    },
  });

  // Helper function to safely encode UTF-8 to base64
  const utf8ToBase64 = (str) => {
    try {
      const utf8Bytes = new TextEncoder().encode(str);
      let binaryString = "";
      utf8Bytes.forEach((byte) => {
        binaryString += String.fromCharCode(byte);
      });
      return btoa(binaryString);
    } catch (error) {
      console.error("Failed to encode data to base64:", error);
      const cleaned = str.replace(/[^\x00-\x7F]/g, "");
      return btoa(cleaned);
    }
  };

  // ── Push divider + Myra messages + plan card on mount ──
  // useEffect(() => {
  //   if (loadingScore || !scoreData) return;
  //   let cancelled = false;
  //   async function init() {
  //     pushToHistory({ type: "voice-indicator", id: nextId() });
  //     await showMyraMessage(MYRA_MESSAGES.plan?.intro || "Here's your personalized Week 1 Recovery Plan.", 1000);
  //     if (!cancelled) setReady(true);
  //   }
  //   init();
  //   return () => {
  //     cancelled = true;
  //   };
  // }, [loadingScore, scoreData]);
  // Handle intro message sequence after API data is ready
  useEffect(() => {
    if (loadingScore || !scoreData || introMessageAdded) return;

    let isMounted = true;

    async function showIntroSequence() {
      // Show typing indicator
      setShowTypingIndicator(true);

      // Wait 2 seconds
      await new Promise((resolve) => setTimeout(resolve, 1500));

      if (!isMounted) return;

      // Hide typing indicator
      setShowTypingIndicator(false);
      pushToHistory({ type: "voice-indicator2", id: nextId() });
      // Add Myra message to conversation history
      pushToHistory({
        type: "myra",
        text: MYRA_MESSAGES.plan?.intro || "Here's your personalized Week 1 Recovery Plan.",
        id: nextId(),
      });

      // Mark as added so it doesn't run again
      setIntroMessageAdded(true);

      // Set ready to show plan card
      setReady(true);
    }

    showIntroSequence();

    return () => {
      isMounted = false;
    };
  }, [loadingScore, scoreData, introMessageAdded, pushToHistory]);

  // ── Auto-play Myra's analysis once plan card is visible and rationale is ready ──
  useEffect(() => {
    if (!ready) return;
    if (!rationaleSpeech) return;
    if (audioState === "speaking" || speechInProgress) return;
    // Small delay so the card renders before audio starts
    // const timer = setTimeout(() => {
    // }, 600);
    if (ready && rationaleSpeech) {
      window.initFromUserGesture();
      window.audioPlayer?.ctx?.resume();
      handlePlayAudio();
    }
    // return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, rationaleSpeech]);

  // ── Push Myra Q&A prompt after plan card is visible ──
  useEffect(() => {
    if (!ready) return;
    let cancelled = false;
    async function showPromptWithTyping() {
      // Show typing animation first
      setIsTypingQaPrompt(true);
      await new Promise((resolve) => setTimeout(resolve, 800));
      if (!cancelled) {
        setIsTypingQaPrompt(false);
        setShowQaPrompt(true);
      }
    }
    showPromptWithTyping();
    return () => {
      cancelled = true;
    };
  }, [ready]);

  // Analytics + flow start on mount
  useEffect(() => {
    if (loadingScore || !scoreData || planFlowStartedRef.current) return;
    planFlowStartedRef.current = true;
    // gtag conversion — plan reached
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/Kf-vCLqv7YUcEOmeoIhD",
      });
    }

    // Screen tracking
    MyraInteraction?.onScreenEnter?.("plan_screen");
    window.screenTracker?.enterScreen("plan_screen");
    window.initFromUserGesture?.();
    window.mayraCode?.setIsVisible(false);

    // Send payload BEFORE startFlow
    const payload = generatePayloadForScreen("plan_screen", effectiveAssessmentData);
    VoiceService?.sendMidJourneyData?.(payload);

    // Send QnA data bundle
    VoiceService?.setQnAData?.({
      userProfile: effectiveAssessmentData.biometrics,
      currentPlan: effectiveAssessmentData.planDetails,
      planRationale: effectiveAssessmentData.planRationaleSpeech,
      sessionId: window.trSessionId,
    });

    VoiceService._currentFlow = "flow_plan_v2";
    window.currentFlow = "flow_plan_v2";
    window.mayraCode?.startFlow?.("flow_plan_v2");

    // Save full data
    if (AnalyticsService && AnalyticsService.saveFullData) {
      try {
        const sanitizedData = { ...effectiveAssessmentData };
        if (sanitizedData.planRationaleSpeech) {
          sanitizedData.planRationaleSpeech = sanitizedData.planRationaleSpeech.substring(0, 5000);
        }
        const encoded = utf8ToBase64(JSON.stringify(sanitizedData));
        AnalyticsService.saveFullData(encoded);
      } catch (error) {
        console.error("Failed to save full data to analytics:", error);
        try {
          const { planRationaleSpeech, ...dataWithoutRationale } = effectiveAssessmentData;
          const encoded = utf8ToBase64(JSON.stringify(dataWithoutRationale));
          AnalyticsService.saveFullData(encoded);
        } catch (fallbackError) {
          console.error("Fallback encoding also failed:", fallbackError);
        }
      }
    }

    // Save user journey
    saveUserJourney(effectiveAssessmentData);
    setShowRemOptions(true);

    return () => {
      window.screenTracker?.exitScreen("plan_screen", { exitReason: "plan_viewed" });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingScore, scoreData]);

  // Command registration
  useEffect(() => {
    window.currentCommandsAudio = {
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (window.exitHandlerOpen) return;
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (intent === "signup_request") {
          setTimeout(() => handleSignUp(), 3000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (window.exitHandlerOpen) return;
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (value === "continue_command") setTimeout(() => handleSignUp(), 3000);
        if (intent === "signup_request") {
          setTimeout(() => handleSignUp(), 3000);
        }
      },
      MOVE_ON: () => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleSignUp(), 3000);
      },
      SIGN_UP: () => {
        if (window.currentScreen !== MyraInteraction.getCurrentScreen?.()) {
          console.log("[PLAN] Ignoring command - not on plan screen");
          return;
        }
        if (window.exitHandlerOpen) return;
        setTimeout(() => handleSignUp(), 3000);
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSignUp() {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/mZpjCLO7gYYcEOmeoIhD",
      });
    }

    // Write the signed_up boolean flag to the DB before redirecting.
    // This keeps signed_up and final_conversion_type in sync — today
    // final_conversion_type is set but signed_up is not, causing dashboard
    // inconsistency (open investigation item #3 in project instructions).
    if (AnalyticsService) {
      try {
        await new Promise((resolve) => {
          AnalyticsService.trackStep(
            {
              ...updatedAssessmentData,
              signed_up: true,
              session_last_update: new Date().toISOString(),
            },
            resolve, // trackStep accepts an optional callback after fetch completes
          );
          // Safety timeout — don't block redirect for more than 2s if backend hangs
          setTimeout(resolve, 2000);
        });
      } catch (err) {
        console.error("Failed to write signed_up flag before redirect:", err);
      }
    }

    await saveUserJourney(updatedAssessmentData);
    var subDomain = "live";
    if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
      subDomain = "uat";
    }
    window.location.replace("https://" + subDomain + ".virdiohealth.com/register?self-assessment=true&fromsite=" + window.location.host + "&data=" + window.trSessionId);
  }

  function toggleRationale(index) {
    setShowRationale((prev) => ({ ...prev, [index]: !prev[index] }));
  }

  function handlePlanQa(key, questionText, answer) {
    // Mark button as used
    setUsedQaButtons((prev) => ({ ...prev, [key]: true }));

    // Write post-plan Myra engagement. Clicking a canned Q&A button counts as
    // engagement — it's the user asking a question and Myra answering, even if
    // the answer was pre-written.
    window.myraEngagedPostPlan = true;
    if (AnalyticsService) {
      // Count a canned Q&A click as one conversation turn.
      const existingTurns = Number(assessmentData.myraTotalTurns || 0) + 1;
      AnalyticsService.trackStep({
        ...assessmentData,
        myraEngagedPostPlan: true,
        myraConversationCount: existingTurns,
        myraTotalTurns: existingTurns,
        session_last_update: new Date().toISOString(),
      });
    }

    // Open Q&A overlay with pre-loaded answer
    qaRef?.current?.addExchange?.(questionText, answer, "plan_qa");
    onOpenQnA?.();
  }

  // Loading state — show spinner while score calculates
  if (loadingScore || !scoreData) {
    return (
      <div className={styles.inlineUi}>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <div className={styles.aiProcessingSpinner} />
          <p style={{ fontWeight: 600, marginTop: 16, color: "#1f2937" }}>Building your recovery plan</p>
          <p style={{ color: "#6b7280", fontSize: "14px", marginTop: 4 }}>This may take a moment…</p>
        </div>
      </div>
    );
  }
  window.currentScreen = "plan_screen";
  if (!ready && showTypingIndicator) {
    return (
      <div className={styles.inlineUi2} style={{ padding: 0, margin: 0 }}>
        {showTypingIndicator && (
          <div className={styles.typingRow} ref={startingPlanRef}>
            <div className={styles.msgAvatar}>M</div>
            <div className={styles.typingDots}>
              <span />
              <span />
              <span />
            </div>
          </div>
        )}
      </div>
    );
  }
  if (!ready) return null;

  return (
    <>
      {/* ═══════════════════════════════════════════════════════════ */}
      {/* BEAT 2 — PLAN CARD                                           */}
      {/* Phase-grouped (Warm up / Main work / Cool down)              */}
      {/* No floating title, no email button                           */}
      {/* ═══════════════════════════════════════════════════════════ */}
      <div className={styles.inlineUi} ref={planCardRef}>
        {/* {showTypingIndicator && (
          <div className={styles.typingRow} ref={startingPlanRef}>
            <div className={styles.msgAvatar}>M</div>
            <div className={styles.typingDots}>
              <span />
              <span />
              <span />
            </div>
          </div>
        )} */}
        <div className={styles.planCardV2}>
          <div className={styles.planCardHeader}>
            <h2 className={styles.planCardTitle}>Your starting plan</h2>
            <div className={styles.planCardStats}>
              <span className={styles.planStatPill}>{exercises.length} exercises</span>
              <span className={styles.planStatDot} />
              <span>~{estTime} min</span>
              <span className={styles.planStatDot} />
              <span>3× per week</span>
            </div>
          </div>

          {groupExercisesByPhase(exercises).map((group, gIdx) => (
            <div className={styles.phaseGroup} key={gIdx}>
              <div className={styles.phaseLabel}>
                <span className={styles.phaseNum}>{gIdx + 1}</span>
                <span>{group.label}</span>
                {group.duration && <span className={styles.phaseDuration}>~{group.duration}</span>}
              </div>
              {group.items.map((ex, i) => {
                const sideLabel = ex.performance_side ? ` — ${ex.performance_side} Leg` : "";
                const holdText = ex.hold ? ` | ${ex.hold}s hold` : "";
                const hasValidImage = typeof ex.image === "string" && ex.image.trim().length > 0;
                const exerciseIndex = exercises.indexOf(ex);
                return (
                  <React.Fragment key={i}>
                    <div className={styles.exerciseRowV2}>
                      <div className={styles.exThumbV2} style={{ backgroundColor: hasValidImage ? "transparent" : "#e2e8f0" }}>
                        {hasValidImage ? <img src={ex.image} alt={ex.name} className={styles.exerciseThumbnailImage} /> : <span className={styles.exerciseThumbnailLabel}>{ex.name.substring(0, 2).toUpperCase()}</span>}
                      </div>
                      <div className={styles.exInfoV2}>
                        <div className={styles.exNameV2}>
                          {ex.name}
                          {sideLabel}
                        </div>
                        <div className={styles.exDoseV2}>
                          {ex.sets} Sets of {ex.reps} Reps{holdText}
                        </div>
                      </div>
                      <button className={styles.exInfoBtnV2} onClick={() => toggleRationale(exerciseIndex)} aria-label="Why this exercise?">
                        i
                      </button>
                    </div>
                    {showRationale[exerciseIndex] && (
                      <div className={styles.planExRationale}>
                        <p>
                          <strong>Why it helps:</strong> {ex.rationale}
                        </p>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* BEAT 3 — MYRA COACHING CARD                                  */}
      {/* On-screen text = static coaching language                    */}
      {/* Audio = dynamic rationaleSpeech (auto-plays on mount)        */}
      {/* ═══════════════════════════════════════════════════════════ */}
      <div className={styles.inlineUi}>
        <div className={styles.myraCoachCard}>
          <div className={styles.myraCoachHeader}>
            <div className={styles.msgAvatar}>M</div>
            <div>
              <div className={styles.myraCoachName}>Myra</div>
              <div className={styles.myraCoachStatus}>
                {audioState === "speaking" && (
                  <>
                    <span className={styles.liveDot} />
                    Speaking now
                  </>
                )}
                {audioState === "thinking" && "Preparing…"}
                {audioState === "replay" && "Tap to replay"}
              </div>
            </div>
          </div>

          <div className={styles.myraCoachBody}>
            <p>I chose these exercises specifically for your body, and I'd love to share why—take a moment to read or listen to my feedback.</p>
            <p>
              When you are ready to begin your plan, we will take this recovery journey together. I will be right by your side to:
              <ul>
                <li>Answer your questions at any time</li>
                <li>Adjust your plan based on how you feel</li>
                <li>Track your progress and share insights on your goals</li>
              </ul>
            </p>
          </div>

          <div className={styles.audioControlsInline}>
            {rationaleSpeech ? (
              <button
                className={styles.audioPlayBtnInline}
                onClick={() => {
                  if (audioState === "speaking") handleStopAudio();
                  else handlePlayAudio();
                }}
                aria-label={audioState === "speaking" ? "Pause" : "Play"}
              >
                {audioState === "speaking" ? (
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <rect x="6" y="4" width="4" height="16" />
                    <rect x="14" y="4" width="4" height="16" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <polygon points="5 3 19 12 5 21 5 3" />
                  </svg>
                )}
              </button>
            ) : null}
            {rationaleSpeech ? (
              <>
                <div className={styles.audioScrubberInline}>
                  <div className={styles.audioScrubberFillInline} style={{ width: `${totalDuration > 0 ? Math.min(100, (audioProgress / totalDuration) * 100) : 0}%` }} />
                </div>
                <span className={styles.audioTimeInline}>
                  {formatTime(audioProgress)} / {formatTime(totalDuration)}
                </span>
              </>
            ) : null}
            <button className={styles.audioReadBtn} onClick={() => setShowRead(true)}>
              Read
            </button>
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* BEAT 4 — SIGN UP CTA — 2 lines                              */}
      {/* Copy from MYRA_MESSAGES.plan.signupCta                       */}
      {/* ═══════════════════════════════════════════════════════════ */}
      <div className={styles.inlineUi}>
        <button className={styles.signupBtn} onClick={handleSignUp} ref={signupButtonRef}>
          <span className={styles.signupLine}>{MYRA_MESSAGES.plan?.signupCta?.line1 || "Continue my recovery with Myra"}</span>
          <span className={styles.signupLineSub}>{MYRA_MESSAGES.plan?.signupCta?.line2 || "Sign up — free, no credit card"}</span>
        </button>
      </div>

      {/* ═══════════════════════════════════════════════════════════ */}
      {/* OVERLAY — Read transcript                                    */}
      {/* ═══════════════════════════════════════════════════════════ */}
      {showRead && (
        <div className={styles.overlay}>
          <div className={styles.overlayCard}>
            <button className={styles.overlayClose} onClick={() => setShowRead(false)} aria-label="Close">
              ×
            </button>
            <h3 className={styles.overlayTitle}>Myra's analysis</h3>
            <div className={styles.transcript}>
              {/* Transcript source: rationaleSpeech (same source as the audio) */}
              {rationaleSpeech ? rationaleSpeech.split(/\n+/).map((para, i) => <p key={i}>{para}</p>) : <p>Your analysis will appear here once it's ready.</p>}
            </div>
            <button className={styles.overlayCtaSingle} onClick={handleSignUp}>
              Sign Up — It's Free
            </button>
          </div>
        </div>
      )}
    </>
  );
}

function saveUserJourney(assessmentData) {
  const screenFlow = window.screenTracker?.getScreenFlow() || [];
  const arEntry1 = screenFlow.find((s) => s.screen === "movement_test_1");
  const arEntry2 = screenFlow.find((s) => s.screen === "movement_test_2");

  const payload = {
    session_id: window.trSessionId,
    analyticsId: window.trSessionId,
    screen_flow: screenFlow,
    myra_engagement: {
      landing: {
        engaged: window.myraEngagedGsa || false,
        messageCount: window.landingMessageCount || 0,
        topic: window.landingTopic || null,
      },
      gsa: {
        engaged: window.myraEngagedGsa || false,
        messageCount: window.gsaMessageCount || 0,
        topic: window.flowGsaTopic || null,
      },
      post_plan: {
        engaged: window.myraEngagedPlanV2 || false,
        messageCount: window.planV2MessageCount || 0,
        topic: window.planV2Topic || null,
      },
    },
    test1: {
      videoWatched: assessmentData.test1VideoWatched,
      videoDuration: assessmentData.test1VideoDuration,
      arDuration: arEntry1?.duration || null,
      rom: assessmentData.rom,
      symptomResponse: assessmentData.symptomResponse,
      testEvents: assessmentData.test1Events || [],
    },
    test2: {
      videoWatched: assessmentData.test2VideoWatched,
      videoDuration: assessmentData.test2VideoDuration,
      arDuration: arEntry2?.duration || null,
      rom: assessmentData.rom2,
      symptomResponse: assessmentData.symptomResponseConfirm,
      testEvents: assessmentData.test2Events || [],
    },
    plan: {
      aiLogId: assessmentData.aiLogId,
      latencyMs: assessmentData.aiLatencyMs,
    },
  };

  console.log("Jurney", payload);

  fetch(CONST.JOURNEY_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ journeyData: payload }),
  }).catch(() => {});
}

// ════════════════════════════════════════════════════════════════
// CROSS-CUTTING: EXIT HANDLER
// Context-aware exit overlay with structured reason capture.
// Myra-routed reasons open QnA overlay with deterministic message.
// ════════════════════════════════════════════════════════════════

function ExitHandler({ currentStep, assessmentData, onClose, onOpenQnA }) {
  const [showLeaving, setShowLeaving] = useState(false);
  const [showPainReferral, setShowPainReferral] = useState(false);
  const [showModePicker, setShowModePicker] = useState(false);
  const [pendingReason, setPendingReason] = useState(null);
  const [feedback, setFeedback] = useState("");

  // Set exit handler flag
  useEffect(() => {
    window.exitHandlerOpen = true;
    return () => {
      window.exitHandlerOpen = false;
    };
  }, []);

  // Determine context
  function getContext() {
    const step = currentStep || "";
    if (step.includes("personalize")) return "personalize";
    if (step.includes("movement_test") || step.includes("self_report") || step.includes("test1_demo") || step.includes("test2_demo") || step.includes("camera") || step.includes("rpe") || step.includes("feel_affect") || step.includes("feedback2")) return "movement_test";
    return "gsa";
  }

  const ctx = getContext();
  const config = CONST.EXIT_CONFIGS[ctx];

  function handleTile(reason) {
    if (reason === "leave") {
      setShowLeaving(true);
      return;
    }

    if (reason === "pain") {
      setShowPainReferral(true);
      // Analytics
      if (AnalyticsService) {
        AnalyticsService.trackStep({
          ...assessmentData,
          event_name: "exit_gsa",
          exitReason: reason || "want_to_leave",
          exitStep: currentStep,
          context_type: ctx,
          outcome: "PAIN_REFERRAL",
          comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
          timestamp: new Date().toISOString(),
          screenFlow: window.screenTracker?.getScreenFlow() || [],
        });
      }
      return;
    }

    // Myra-routed: check if communication mode is selected
    const currentMode = MyraInteraction?.getCurrentMode?.();
    if (!currentMode) {
      setPendingReason(reason);
      setShowModePicker(true);
      return;
    }

    routeToMyra(reason);
  }

  async function routeToMyra(reason, mode = "chat") {
    const msg = CONST.EXIT_MYRA_MESSAGES[reason];
    const tileTitle = config.tiles.find((t) => t.reason === reason)?.title || reason;
    const flowToStart = window.currentFlow || VoiceService._currentFlow;
    window.audioPlayer?.ttsPcmAbort?.();
    if (window?.videoController) {
      window?.videoController?.pause();
    }

    // Analytics
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        exitReason: reason || "want_to_leave",
        exitStep: currentStep,
        context_type: ctx,
        outcome: "MYRA_CHAT",
        comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
        timestamp: new Date().toISOString(),
        screenFlow: window.screenTracker?.getScreenFlow() || [],
      });
    }
    if (mode === "voice") {
      const granted = await window.requestMicrophonePermission({
        onGrant: () => {
          if (VoiceService._flowReady) {
            VoiceService.startFlowWithoutAnnouncement(flowToStart, "", msg);
          } else {
            VoiceService.startFlowWithoutAnnouncement(flowToStart, "", msg);
            VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
          }
        },
        onDeny: () => {
          MyraInteraction.switchMode("chat");
          onOpenQnA(tileTitle, msg, "exit_" + reason);
        },
      });
    } else if (mode === "chat") {
      onOpenQnA(tileTitle, msg, "exit_" + reason);
    }
    onClose();
  }

  function handleModeSelected(mode) {
    MyraInteraction?.switchMode?.(mode);
    setShowModePicker(false);
    if (pendingReason) {
      routeToMyra(pendingReason, mode);
    }
  }

  function confirmExit() {
    // Analytics
    if (AnalyticsService) {
      AnalyticsService.trackStep({
        ...assessmentData,
        event_name: "exit_gsa",
        exitReason: "want_to_leave",
        exitStep: currentStep,
        context_type: ctx,
        outcome: "EXIT",
        feedback: feedback.trim() || null,
        comm_mode: MyraInteraction?.getCurrentMode?.() || "button",
        timestamp: new Date().toISOString(),
        screenFlow: window.screenTracker?.getScreenFlow() || [],
      });
    }

    // Goodbye message
    const goodbye = MYRA_MESSAGES.exit?.confirmExitGoodbye || "Thanks for giving the assessment a try. If you ever want to come back, I'll be here. Take care.";
    VoiceService?.doSay(goodbye);

    // Full cleanup
    window.audioPlayer?.ttsPcmAbort?.();
    window.mayraCode?.forceStop();
    window.mayraCode?.setIsVisible(false);
    window.destroyOwnedResources?.();
    window.destroyFlutterResources?.();
    window.exitHandlerOpen = false;
    localStorage.setItem("loadAfterReloadAutoHome", "1");
    localStorage.removeItem("trSessionId");
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("userCondition");
    window.trSessionId = null;

    onClose();
    window.location.href = "/?gsa=v2";
  }

  if (!config) return null;

  // Determine which sub-screen to show
  let content;

  if (showModePicker) {
    content = (
      <>
        <h2 className={styles.exitHeading}>Choose How to Chat with Myra</h2>
        <p className={styles.exitSubheading}>Pick your preferred way to communicate before we connect you.</p>
        <div className={styles.modeSelectOptions}>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("voice")}>
            <span className={styles.modeSelectIcon}>🎤</span>
            <div>
              <span className={styles.modeSelectLabel}>Talk</span>
              <span className={styles.modeSelectDesc}>Voice — recommended</span>
            </div>
          </button>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("chat")}>
            <span className={styles.modeSelectIcon}>💬</span>
            <div>
              <span className={styles.modeSelectLabel}>Chat</span>
              <span className={styles.modeSelectDesc}>Type your responses</span>
            </div>
          </button>
          <button className={styles.modeSelectBtn} onClick={() => handleModeSelected("button")}>
            <span className={styles.modeSelectIcon}>👆</span>
            <div>
              <span className={styles.modeSelectLabel}>Tap Responses</span>
              <span className={styles.modeSelectDesc}>Use on-screen buttons</span>
            </div>
          </button>
        </div>
        <button
          className={styles.ehBack}
          onClick={() => {
            setShowModePicker(false);
            setPendingReason(null);
          }}
        >
          Go back
        </button>
      </>
    );
  } else if (showPainReferral) {
    content = (
      <>
        <div style={{ textAlign: "center", fontSize: "32px", marginBottom: 8 }}>🩺</div>
        <h2 className={styles.exitHeading}>We Recommend Seeing a Provider</h2>
        <p className={styles.exitSubheading} style={{ textAlign: "left" }}>
          If you're experiencing increased pain, we'd strongly recommend consulting with a healthcare provider before continuing. They can evaluate your symptoms and let you know when it's safe to proceed with an exercise program.
        </p>
        <p className={styles.exitSubheading} style={{ textAlign: "left", marginBottom: 16 }}>
          You can always come back and restart the assessment when you're ready.
        </p>
        <button
          className={styles.btnSafe}
          onClick={() => {
            window.location.href = "/";
          }}
          style={{ width: "100%" }}
        >
          Find a Provider
        </button>
        <button className={styles.ehBack} onClick={() => setShowPainReferral(false)}>
          Go back
        </button>
      </>
    );
  } else if (showLeaving) {
    content = (
      <>
        <h2 className={styles.ehLeavingHeading}>Before you go</h2>
        <p className={styles.ehLeavingSub}>Your progress won't be saved, but you can restart anytime.</p>
        <textarea className={styles.ehFeedbackArea} placeholder="Any feedback on how we can improve? (optional)" value={feedback} onChange={(e) => setFeedback(e.target.value)} />
        <button className={styles.ehExitBtn} onClick={confirmExit}>
          Exit to landing page
        </button>
        <button
          className={styles.ehBack}
          onClick={() => {
            setShowLeaving(false);
          }}
        >
          Stay here
        </button>
      </>
    );
  } else {
    content = (
      <>
        <h2 className={styles.exitHeading}>{config.heading}</h2>
        <p className={styles.exitSubheading}>{config.subheading}</p>
        {config.tiles.map((tile) => (
          <div key={tile.reason} className={styles.ehTile} onClick={() => handleTile(tile.reason)}>
            <div className={styles.ehTileTitle}>{tile.title}</div>
            <div className={styles.ehTileDesc}>{tile.desc}</div>
          </div>
        ))}
        <button className={styles.ehBack} onClick={onClose}>
          I changed my mind — take me back
        </button>
      </>
    );
  }

  return (
    <div
      className={styles.exitOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.exitCard}>
        <div className={styles.exitCardInner}>{content}</div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// FLUTTER MESSAGE RESOLVER BRIDGE
// Flutter calls window.getMessage({ path, mode, flow, test, vars })
// via callNative("getMessage", { ... }) to fetch any string from
// MYRA_MESSAGES.js.
//
// Handles all three node shapes documented in MYRA_MESSAGES.js:
//   Shape 1 — plain string (mode/flow ignored)
//   Shape 2 — { voice, chat }
//   Shape 3 — { app: {voice, chat}, gsa: { test1: {voice, chat}, test2: {...} } }
//
// Resolver order for Shape 3 (gsa flow):
//   gsa[test][mode] → gsa.test1[mode] → app[mode]
// Empty string at any level falls through to the next candidate.
//
// {var} substitution is delegated to resolveMessage from GSA_MYRA_MESSAGES.js
// so this bridge stays consistent with the rest of the React-side callers.
//
// Returns "" on any miss — Dart side has per-call-site fallback strings.
// ─────────────────────────────────────────────────────────────
window.getMessage = (args) => {
  let requestId = null;
  let path = null;
  try {
    console.log("[getMessage] ENTER", typeof args);
    const params = typeof args === "string" ? JSON.parse(args) : args;
    console.log("[getMessage] parsed params:", params);

    requestId = params?.requestId; // Flutter passes this in for push-back
    const { path: p, mode = "voice", flow = "app", test = "test1", vars = {} } = params || {};
    path = p;

    if (!path) {
      console.warn("[getMessage] no path in params");
      deliverResult(requestId, "");
      return "";
    }

    console.log("[getMessage] MYRA_MESSAGES typeof:", typeof MYRA_MESSAGES, "isObject:", MYRA_MESSAGES != null && typeof MYRA_MESSAGES === "object");

    // 1. Walk dot-delimited path through MYRA_MESSAGES.
    let node = MYRA_MESSAGES;
    for (const part of path.split(".")) {
      if (node == null || typeof node !== "object") {
        console.warn("[getMessage] path walk failed at part:", part, "path:", path);
        deliverResult(requestId, "");
        return "";
      }
      node = node[part];
    }
    if (node == null) {
      console.warn("[getMessage] node null after walk:", path);
      deliverResult(requestId, "");
      return "";
    }

    console.log("[getMessage] node found:", typeof node, node && typeof node === "object" ? Object.keys(node) : node);

    // 2. Resolve by shape.
    let template = "";
    if (typeof node === "string") {
      template = node;
    } else if (node.voice !== undefined || node.chat !== undefined) {
      // Shape 2 — voice/chat split.
      template = node[mode] || node.voice || node.chat || "";
    } else if (node.app !== undefined || node.gsa !== undefined) {
      // Shape 3 — full flow split.
      const candidates = flow === "gsa" ? [node.gsa?.[test]?.[mode], node.gsa?.test1?.[mode], node.app?.[mode]] : [node.app?.[mode]];
      template = candidates.find((s) => s != null && s !== "") || "";
    } else {
      console.warn("[getMessage] node has no recognised shape:", Object.keys(node));
      deliverResult(requestId, "");
      return "";
    }

    if (!template) {
      console.warn("[getMessage] template empty after shape resolution for", path);
      deliverResult(requestId, "");
      return "";
    }

    // 3. Delegate {var} substitution to the existing helper.
    const out = resolveMessage(template, vars || {});
    console.log("[getMessage] RESOLVED", path, "→", String(out).slice(0, 80), "(id=" + requestId + ")");
    deliverResult(requestId, out);
    return out; // legacy return — kept for direct-from-console debugging
  } catch (e) {
    console.error("[getMessage] error resolving", args, e);
    deliverResult(requestId, "");
    return "";
  }
};

// Helper — pushes the resolved value back to Flutter.
// No-op if no requestId or deliverMessages not registered.
function deliverResult(requestId, value) {
  if (requestId == null) {
    console.warn("[getMessage] deliverResult: no requestId, skipping push");
    return;
  }
  if (typeof window.deliverMessages !== "function") {
    console.warn("[getMessage] deliverResult: window.deliverMessages not registered (id=" + requestId + ")");
    return;
  }
  try {
    const payload = JSON.stringify({ requestId, value: value || "" });
    console.log("[getMessage] deliverResult: pushing id=" + requestId + " length=" + (value || "").length);
    window.deliverMessages(payload);
  } catch (e) {
    console.error("[getMessage] deliverResult error", e);
  }
}

// ─────────────────────────────────────────────────────────────
// FLUTTER ANALYTICS BRIDGE
// Flutter calls window.flutterAnalytics.trackEvent(name, params)
// via TunnelWeb.dart using tn.callNative("trackEvent", {...})
// ─────────────────────────────────────────────────────────────
window.trackFlutterEvent = (eventData) => {
  console.log("_trackEvent", eventData);

  if (!eventData) {
    console.warn("trackFlutterEvent: eventData is required.");
    return;
  }

  let eventInfo;

  try {
    eventInfo = typeof eventData === "string" ? JSON.parse(eventData) : eventData;
  } catch (error) {
    console.warn("trackFlutterEvent: invalid eventData JSON.", eventData, error);
    return;
  }

  if (!eventInfo || typeof eventInfo !== "object") {
    console.warn("trackFlutterEvent: eventData must be an object.");
    return;
  }

  const eventName = eventInfo.event_name;

  if (!eventName) {
    console.warn("trackFlutterEvent: event_name is required.", eventInfo);
    return;
  }

  const latestAssessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");

  const eventTimestamp = new Date().toISOString();

  const eventPayload = {
    ...eventInfo,
    event_timestamp: eventTimestamp,
  };

  const runStep = localStorage.getItem("runStep");

  const eventKey = runStep === "2" ? "test2Events" : "test1Events";

  const existingEvents = Array.isArray(latestAssessmentData[eventKey]) ? latestAssessmentData[eventKey] : [];

  const updatedAssessmentData = {
    ...latestAssessmentData,
    session_last_update: eventTimestamp,
    [eventKey]: [...existingEvents, [eventName, eventPayload]],
  };

  saveUserJourney(updatedAssessmentData);

  localStorage.setItem("assessmentData", JSON.stringify(updatedAssessmentData));

  if (window.updateAssessmentDataGlobal) {
    window.updateAssessmentDataGlobal(updatedAssessmentData);
  }
};

window.flutterAnalyticsBridgeReady = true;

// ════════════════════════════════════════════════════════════════
// CROSS-CUTTING: INACTIVITY MODAL
// Triggered by AUTO_PAUSE command from backend.
// Resume or exit options.
// ════════════════════════════════════════════════════════════════

function InactivityModal({ onResume, onExit }) {
  return (
    <div
      className={styles.exitOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onResume();
      }}
    >
      <div className={styles.exitCard}>
        <div className={styles.exitCardInner} style={{ textAlign: "center" }}>
          <h2 className={styles.exitHeading}>Still there?</h2>
          <p className={styles.exitSubheading}>Take your time — I've paused the assessment. When you're ready, just tap below to continue.</p>
          <button className={styles.btnSafe} onClick={onResume} style={{ width: "100%", marginTop: 12 }}>
            I'm ready — let's continue
          </button>
          <button className={styles.ehBack} onClick={onExit}>
            I want to exit
          </button>
        </div>
      </div>
    </div>
  );
}
